export const matches_data = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.15622,
          -34.9051
        ]
      },
      properties: {
        Year: 1930,
        Datetime: "13 Jul 1930 - 15:00 ",
        Stage: "Group 1",
        Stadium: "Pocitos",
        City: "Montevideo ",
        HomeTeamName: "France",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 4444,
        RoundID: "rsixteen",
        MatchID: 1096,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.158,
          -34.883
        ]
      },
      properties: {
        Year: 1930,
        Datetime: "13 Jul 1930 - 15:00 ",
        Stage: "Group 4",
        Stadium: "Parque Central",
        City: "Montevideo ",
        HomeTeamName: "USA",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Belgium",
        WinConditions: " ",
        Attendance: 18346,
        RoundID: "rsixteen",
        MatchID: 1090,
        HomeTeamInitials: "USA",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.158,
          -34.883
        ]
      },
      properties: {
        Year: 1930,
        Datetime: "14 Jul 1930 - 12:45 ",
        Stage: "Group 2",
        Stadium: "Parque Central",
        City: "Montevideo ",
        HomeTeamName: "Yugoslavia",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 24059,
        RoundID: "rsixteen",
        MatchID: 1093,
        HomeTeamInitials: "YUG",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.15622,
          -34.9051
        ]
      },
      properties: {
        Year: 1930,
        Datetime: "14 Jul 1930 - 14:50 ",
        Stage: "Group 3",
        Stadium: "Pocitos",
        City: "Montevideo ",
        HomeTeamName: "Romania",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Peru",
        WinConditions: " ",
        Attendance: 2549,
        RoundID: "rsixteen",
        MatchID: 1098,
        HomeTeamInitials: "ROU",
        AwayTeamInitials: "PER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.158,
          -34.883
        ]
      },
      properties: {
        Year: 1930,
        Datetime: "15 Jul 1930 - 16:00 ",
        Stage: "Group 1",
        Stadium: "Parque Central",
        City: "Montevideo ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 23409,
        RoundID: "rsixteen",
        MatchID: 1085,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.158,
          -34.883
        ]
      },
      properties: {
        Year: 1930,
        Datetime: "16 Jul 1930 - 14:45 ",
        Stage: "Group 1",
        Stadium: "Parque Central",
        City: "Montevideo ",
        HomeTeamName: "Chile",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 9249,
        RoundID: "rsixteen",
        MatchID: 1095,
        HomeTeamInitials: "CHI",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.158,
          -34.883
        ]
      },
      properties: {
        Year: 1930,
        Datetime: "17 Jul 1930 - 12:45 ",
        Stage: "Group 2",
        Stadium: "Parque Central",
        City: "Montevideo ",
        HomeTeamName: "Yugoslavia",
        HomeTeamGoals: 4,
        AwayTeamGoals: 0,
        AwayTeamName: "Bolivia",
        WinConditions: " ",
        Attendance: 18306,
        RoundID: "rsixteen",
        MatchID: 1092,
        HomeTeamInitials: "YUG",
        AwayTeamInitials: "BOL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.158,
          -34.883
        ]
      },
      properties: {
        Year: 1930,
        Datetime: "17 Jul 1930 - 14:45 ",
        Stage: "Group 4",
        Stadium: "Parque Central",
        City: "Montevideo ",
        HomeTeamName: "USA",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Paraguay",
        WinConditions: " ",
        Attendance: 18306,
        RoundID: "rsixteen",
        MatchID: 1097,
        HomeTeamInitials: "USA",
        AwayTeamInitials: "PAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.15279,
          -34.89468
        ]
      },
      properties: {
        Year: 1930,
        Datetime: "18 Jul 1930 - 14:30 ",
        Stage: "Group 3",
        Stadium: "Estadio Centenario",
        City: "Montevideo ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Peru",
        WinConditions: " ",
        Attendance: 57735,
        RoundID: "rsixteen",
        MatchID: 1099,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "PER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.15279,
          -34.89468
        ]
      },
      properties: {
        Year: 1930,
        Datetime: "19 Jul 1930 - 12:50 ",
        Stage: "Group 1",
        Stadium: "Estadio Centenario",
        City: "Montevideo ",
        HomeTeamName: "Chile",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 2000,
        RoundID: "rsixteen",
        MatchID: 1094,
        HomeTeamInitials: "CHI",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.15279,
          -34.89468
        ]
      },
      properties: {
        Year: 1930,
        Datetime: "19 Jul 1930 - 15:00 ",
        Stage: "Group 1",
        Stadium: "Estadio Centenario",
        City: "Montevideo ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 6,
        AwayTeamGoals: 3,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 42100,
        RoundID: "rsixteen",
        MatchID: 1086,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.15279,
          -34.89468
        ]
      },
      properties: {
        Year: 1930,
        Datetime: "20 Jul 1930 - 13:00 ",
        Stage: "Group 2",
        Stadium: "Estadio Centenario",
        City: "Montevideo ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 4,
        AwayTeamGoals: 0,
        AwayTeamName: "Bolivia",
        WinConditions: " ",
        Attendance: 25466,
        RoundID: "rsixteen",
        MatchID: 1091,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "BOL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.15279,
          -34.89468
        ]
      },
      properties: {
        Year: 1930,
        Datetime: "20 Jul 1930 - 15:00 ",
        Stage: "Group 4",
        Stadium: "Estadio Centenario",
        City: "Montevideo ",
        HomeTeamName: "Paraguay",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Belgium",
        WinConditions: " ",
        Attendance: 12000,
        RoundID: "rsixteen",
        MatchID: 1089,
        HomeTeamInitials: "PAR",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.15279,
          -34.89468
        ]
      },
      properties: {
        Year: 1930,
        Datetime: "21 Jul 1930 - 14:50 ",
        Stage: "Group 3",
        Stadium: "Estadio Centenario",
        City: "Montevideo ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 4,
        AwayTeamGoals: 0,
        AwayTeamName: "Romania",
        WinConditions: " ",
        Attendance: 70022,
        RoundID: "rsixteen",
        MatchID: 1100,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "ROU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.15279,
          -34.89468
        ]
      },
      properties: {
        Year: 1930,
        Datetime: "22 Jul 1930 - 14:45 ",
        Stage: "Group 1",
        Stadium: "Estadio Centenario",
        City: "Montevideo ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Chile",
        WinConditions: " ",
        Attendance: 41459,
        RoundID: "rsixteen",
        MatchID: 1084,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "CHI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.15279,
          -34.89468
        ]
      },
      properties: {
        Year: 1930,
        Datetime: "26 Jul 1930 - 14:45 ",
        Stage: "Semi-finals",
        Stadium: "Estadio Centenario",
        City: "Montevideo ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 6,
        AwayTeamGoals: 1,
        AwayTeamName: "USA",
        WinConditions: " ",
        Attendance: 72886,
        RoundID: "semi",
        MatchID: 1088,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "USA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.15279,
          -34.89468
        ]
      },
      properties: {
        Year: 1930,
        Datetime: "27 Jul 1930 - 14:45 ",
        Stage: "Semi-finals",
        Stadium: "Estadio Centenario",
        City: "Montevideo ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 6,
        AwayTeamGoals: 1,
        AwayTeamName: "Yugoslavia",
        WinConditions: " ",
        Attendance: 79867,
        RoundID: "semi",
        MatchID: 1101,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "YUG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.15279,
          -34.89468
        ]
      },
      properties: {
        Year: 1930,
        Datetime: "30 Jul 1930 - 14:15 ",
        Stage: "Final",
        Stadium: "Estadio Centenario",
        City: "Montevideo ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 4,
        AwayTeamGoals: 2,
        AwayTeamName: "Argentina",
        WinConditions: " ",
        Attendance: 68346,
        RoundID: "final",
        MatchID: 1087,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.65001,
          45.04175
        ]
      },
      properties: {
        Year: 1934,
        Datetime: "27 May 1934 - 16:30 ",
        Stage: "Preliminary round",
        Stadium: "Stadio Benito Mussolini",
        City: "Turin ",
        HomeTeamName: "Austria",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "France",
        WinConditions: "win after extra time ",
        Attendance: 16000,
        RoundID: "rsixteen",
        MatchID: 1104,
        HomeTeamInitials: "AUT",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          14.29333,
          40.85972
        ]
      },
      properties: {
        Year: 1934,
        Datetime: "27 May 1934 - 16:30 ",
        Stage: "Preliminary round",
        Stadium: "Giorgio Ascarelli",
        City: "Naples ",
        HomeTeamName: "Hungary",
        HomeTeamGoals: 4,
        AwayTeamGoals: 2,
        AwayTeamName: "Egypt",
        WinConditions: " ",
        Attendance: 9000,
        RoundID: "rsixteen",
        MatchID: 1119,
        HomeTeamInitials: "HUN",
        AwayTeamInitials: "EGY"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.12392,
          45.47804
        ]
      },
      properties: {
        Year: 1934,
        Datetime: "27 May 1934 - 16:30 ",
        Stage: "Preliminary round",
        Stadium: "San Siro",
        City: "Milan ",
        HomeTeamName: "Switzerland",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Netherlands",
        WinConditions: " ",
        Attendance: 33000,
        RoundID: "rsixteen",
        MatchID: 1133,
        HomeTeamInitials: "SUI",
        AwayTeamInitials: "NED"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.309667,
          44.49231
        ]
      },
      properties: {
        Year: 1934,
        Datetime: "27 May 1934 - 16:30 ",
        Stage: "Preliminary round",
        Stadium: "Littorale",
        City: "Bologna ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Argentina",
        WinConditions: " ",
        Attendance: 14000,
        RoundID: "rsixteen",
        MatchID: 1102,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.28256,
          43.78074
        ]
      },
      properties: {
        Year: 1934,
        Datetime: "27 May 1934 - 16:30 ",
        Stage: "Preliminary round",
        Stadium: "Giovanni Berta",
        City: "Florence ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 5,
        AwayTeamGoals: 2,
        AwayTeamName: "Belgium",
        WinConditions: " ",
        Attendance: 8000,
        RoundID: "rsixteen",
        MatchID: 1108,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.95262,
          44.41645
        ]
      },
      properties: {
        Year: 1934,
        Datetime: "27 May 1934 - 16:30 ",
        Stage: "Preliminary round",
        Stadium: "Luigi Ferraris",
        City: "Genoa ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 21000,
        RoundID: "rsixteen",
        MatchID: 1111,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.47231,
          41.92693
        ]
      },
      properties: {
        Year: 1934,
        Datetime: "27 May 1934 - 16:30 ",
        Stage: "Preliminary round",
        Stadium: "Nazionale PNF",
        City: "Rome ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 7,
        AwayTeamGoals: 1,
        AwayTeamName: "USA",
        WinConditions: " ",
        Attendance: 25000,
        RoundID: "rsixteen",
        MatchID: 1135,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "USA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.79416,
          45.62388
        ]
      },
      properties: {
        Year: 1934,
        Datetime: "27 May 1934 - 16:30 ",
        Stage: "Preliminary round",
        Stadium: "Littorio",
        City: "Trieste ",
        HomeTeamName: "Czechoslovakia",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Romania",
        WinConditions: " ",
        Attendance: 9000,
        RoundID: "rsixteen",
        MatchID: 1141,
        HomeTeamInitials: "TCH",
        AwayTeamInitials: "ROU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.65001,
          45.04175
        ]
      },
      properties: {
        Year: 1934,
        Datetime: "31 May 1934 - 16:30 ",
        Stage: "Quarter-finals",
        Stadium: "Stadio Benito Mussolini",
        City: "Turin ",
        HomeTeamName: "Czechoslovakia",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Switzerland",
        WinConditions: " ",
        Attendance: 12000,
        RoundID: "quart",
        MatchID: 1143,
        HomeTeamInitials: "TCH",
        AwayTeamInitials: "SUI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.12392,
          45.47804
        ]
      },
      properties: {
        Year: 1934,
        Datetime: "31 May 1934 - 16:30 ",
        Stage: "Quarter-finals",
        Stadium: "San Siro",
        City: "Milan ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Sweden",
        WinConditions: " ",
        Attendance: 3000,
        RoundID: "quart",
        MatchID: 1129,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "SWE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.28256,
          43.78074
        ]
      },
      properties: {
        Year: 1934,
        Datetime: "31 May 1934 - 16:30 ",
        Stage: "Quarter-finals",
        Stadium: "Giovanni Berta",
        City: "Florence ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Spain",
        WinConditions: "",
        Attendance: 35000,
        RoundID: "quart",
        MatchID: 1122,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.309667,
          44.49231
        ]
      },
      properties: {
        Year: 1934,
        Datetime: "31 May 1934 - 16:30 ",
        Stage: "Quarter-finals",
        Stadium: "Littorale",
        City: "Bologna ",
        HomeTeamName: "Austria",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Hungary",
        WinConditions: " ",
        Attendance: 23000,
        RoundID: "quart",
        MatchID: 1106,
        HomeTeamInitials: "AUT",
        AwayTeamInitials: "HUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.28256,
          43.78074
        ]
      },
      properties: {
        Year: 1934,
        Datetime: "01 Jun 1934 - 16:30 ",
        Stage: "Quarter-finals",
        Stadium: "Giovanni Berta",
        City: "Florence ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 43000,
        RoundID: "quart",
        MatchID: 1123,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.12392,
          45.47804
        ]
      },
      properties: {
        Year: 1934,
        Datetime: "03 Jun 1934 - 16:30 ",
        Stage: "Semi-finals",
        Stadium: "San Siro",
        City: "Milan ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Austria",
        WinConditions: " ",
        Attendance: 35000,
        RoundID: "semi",
        MatchID: 1107,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "AUT"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.47231,
          41.92693
        ]
      },
      properties: {
        Year: 1934,
        Datetime: "03 Jun 1934 - 16:30 ",
        Stage: "Semi-finals",
        Stadium: "Nazionale PNF",
        City: "Rome ",
        HomeTeamName: "Czechoslovakia",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Germany",
        WinConditions: " ",
        Attendance: 15000,
        RoundID: "semi",
        MatchID: 1130,
        HomeTeamInitials: "TCH",
        AwayTeamInitials: "GER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          14.29333,
          40.85972
        ]
      },
      properties: {
        Year: 1934,
        Datetime: "07 Jun 1934 - 18:00 ",
        Stage: "Match for third place",
        Stadium: "Giorgio Ascarelli",
        City: "Naples ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Austria",
        WinConditions: " ",
        Attendance: 7000,
        RoundID: "third",
        MatchID: 1105,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "AUT"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.47231,
          41.92693
        ]
      },
      properties: {
        Year: 1934,
        Datetime: "10 Jun 1934 - 17:30 ",
        Stage: "Final",
        Stadium: "Nazionale PNF",
        City: "Rome ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Czechoslovakia",
        WinConditions: "win after extra time ",
        Attendance: 55000,
        RoundID: "final",
        MatchID: 1134,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "TCH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.25295,
          48.84138
        ]
      },
      properties: {
        Year: 1938,
        Datetime: "04 Jun 1938 - 17:00 ",
        Stage: "First round",
        Stadium: "Parc des Princes",
        City: "Paris ",
        HomeTeamName: "Switzerland",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Germany",
        WinConditions: " ",
        Attendance: 27152,
        RoundID: "rsixteen",
        MatchID: 1165,
        HomeTeamInitials: "SUI",
        AwayTeamInitials: "GER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          4.02444,
          49.24698
        ]
      },
      properties: {
        Year: 1938,
        Datetime: "05 Jun 1938 - 17:00 ",
        Stage: "First round",
        Stadium: "Velodrome Municipale",
        City: "Reims ",
        HomeTeamName: "Hungary",
        HomeTeamGoals: 6,
        AwayTeamGoals: 0,
        AwayTeamName: "Dutch East Indies",
        WinConditions: " ",
        Attendance: 9000,
        RoundID: "rsixteen",
        MatchID: 1173,
        HomeTeamInitials: "HUN",
        AwayTeamInitials: "INH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.24786,
          48.92924
        ]
      },
      properties: {
        Year: 1938,
        Datetime: "05 Jun 1938 - 17:00 ",
        Stage: "First round",
        Stadium: "Stade Olympique",
        City: "Colombes ",
        HomeTeamName: "France",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Belgium",
        WinConditions: " ",
        Attendance: 30454,
        RoundID: "rsixteen",
        MatchID: 1146,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          1.43411,
          43.58321
        ]
      },
      properties: {
        Year: 1938,
        Datetime: "05 Jun 1938 - 17:00 ",
        Stage: "First round",
        Stadium: "Stade Municipal",
        City: "Toulouse ",
        HomeTeamName: "Cuba",
        HomeTeamGoals: 3,
        AwayTeamGoals: 3,
        AwayTeamName: "Romania",
        WinConditions: " ",
        Attendance: 7000,
        RoundID: "rsixteen",
        MatchID: 1156,
        HomeTeamInitials: "CUB",
        AwayTeamInitials: "ROU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          5.39612,
          43.26962
        ]
      },
      properties: {
        Year: 1938,
        Datetime: "05 Jun 1938 - 17:00 ",
        Stage: "First round",
        Stadium: "Stade Velodrome",
        City: "Marseilles ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Norway",
        WinConditions: "win after extra time ",
        Attendance: 19000,
        RoundID: "rsixteen",
        MatchID: 1179,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "NOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.75511,
          48.55994
        ]
      },
      properties: {
        Year: 1938,
        Datetime: "05 Jun 1938 - 17:30 ",
        Stage: "First round",
        Stadium: "Stade de la Meinau",
        City: "Strasbourg ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 6,
        AwayTeamGoals: 5,
        AwayTeamName: "Poland",
        WinConditions: "win after extra time ",
        Attendance: 13452,
        RoundID: "rsixteen",
        MatchID: 1150,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "POL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          0.17111,
          49.50194
        ]
      },
      properties: {
        Year: 1938,
        Datetime: "05 Jun 1938 - 18:30 ",
        Stage: "First round",
        Stadium: "Cavee Verte",
        City: "Le Havre ",
        HomeTeamName: "Czechoslovakia",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Netherlands",
        WinConditions: "win after extra time ",
        Attendance: 11000,
        RoundID: "rsixteen",
        MatchID: 1172,
        HomeTeamInitials: "TCH",
        AwayTeamInitials: "NED"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          1.43411,
          43.58321
        ]
      },
      properties: {
        Year: 1938,
        Datetime: "09 Jun 1938 - 18:00 ",
        Stage: "First round",
        Stadium: "Stade Municipal",
        City: "Toulouse ",
        HomeTeamName: "Cuba",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Romania",
        WinConditions: " ",
        Attendance: 8000,
        RoundID: "rsixteen",
        MatchID: 1157,
        HomeTeamInitials: "CUB",
        AwayTeamInitials: "ROU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.25295,
          48.84138
        ]
      },
      properties: {
        Year: 1938,
        Datetime: "09 Jun 1938 - 18:00 ",
        Stage: "First round",
        Stadium: "Parc des Princes",
        City: "Paris ",
        HomeTeamName: "Switzerland",
        HomeTeamGoals: 4,
        AwayTeamGoals: 2,
        AwayTeamName: "Germany",
        WinConditions: " ",
        Attendance: 20025,
        RoundID: "rsixteen",
        MatchID: 1166,
        HomeTeamInitials: "SUI",
        AwayTeamInitials: "GER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.59838,
          44.82911
        ]
      },
      properties: {
        Year: 1938,
        Datetime: "12 Jun 1938 - 17:00 ",
        Stage: "Quarter-finals",
        Stadium: "Stade du Parc Lescure",
        City: "Bordeaux ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Czechoslovakia",
        WinConditions: "",
        Attendance: 22021,
        RoundID: "quart",
        MatchID: 1152,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "TCH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          3.03611,
          50.6375
        ]
      },
      properties: {
        Year: 1938,
        Datetime: "12 Jun 1938 - 17:00 ",
        Stage: "Quarter-finals",
        Stadium: "Victor Boucquey",
        City: "Lille ",
        HomeTeamName: "Hungary",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Switzerland",
        WinConditions: " ",
        Attendance: 15000,
        RoundID: "quart",
        MatchID: 1175,
        HomeTeamInitials: "HUN",
        AwayTeamInitials: "SUI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.12561,
          43.5912
        ]
      },
      properties: {
        Year: 1938,
        Datetime: "12 Jun 1938 - 17:00 ",
        Stage: "Quarter-finals",
        Stadium: "Fort Carree",
        City: "Antibes ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 8,
        AwayTeamGoals: 0,
        AwayTeamName: "Cuba",
        WinConditions: " ",
        Attendance: 7000,
        RoundID: "quart",
        MatchID: 1158,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "CUB"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.24786,
          48.92924
        ]
      },
      properties: {
        Year: 1938,
        Datetime: "12 Jun 1938 - 17:00 ",
        Stage: "Quarter-finals",
        Stadium: "Stade Olympique",
        City: "Colombes ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 58455,
        RoundID: "quart",
        MatchID: 1164,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.59838,
          44.82911
        ]
      },
      properties: {
        Year: 1938,
        Datetime: "14 Jun 1938 - 18:00 ",
        Stage: "Quarter-finals",
        Stadium: "Stade du Parc Lescure",
        City: "Bordeaux ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Czechoslovakia",
        WinConditions: " ",
        Attendance: 18141,
        RoundID: "quart",
        MatchID: 1153,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "TCH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.25295,
          48.84138
        ]
      },
      properties: {
        Year: 1938,
        Datetime: "16 Jun 1938 - 18:00 ",
        Stage: "Semi-finals",
        Stadium: "Parc des Princes",
        City: "Paris ",
        HomeTeamName: "Hungary",
        HomeTeamGoals: 5,
        AwayTeamGoals: 1,
        AwayTeamName: "Sweden",
        WinConditions: " ",
        Attendance: 20000,
        RoundID: "semi",
        MatchID: 1176,
        HomeTeamInitials: "HUN",
        AwayTeamInitials: "SWE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          5.39612,
          43.26962
        ]
      },
      properties: {
        Year: 1938,
        Datetime: "16 Jun 1938 - 18:00 ",
        Stage: "Semi-finals",
        Stadium: "Stade Velodrome",
        City: "Marseilles ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 33000,
        RoundID: "semi",
        MatchID: 1149,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.59838,
          44.82911
        ]
      },
      properties: {
        Year: 1938,
        Datetime: "19 Jun 1938 - 17:00 ",
        Stage: "Match for third place",
        Stadium: "Stade du Parc Lescure",
        City: "Bordeaux ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 4,
        AwayTeamGoals: 2,
        AwayTeamName: "Sweden",
        WinConditions: " ",
        Attendance: 12000,
        RoundID: "third",
        MatchID: 1151,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "SWE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.24786,
          48.92924
        ]
      },
      properties: {
        Year: 1938,
        Datetime: "19 Jun 1938 - 17:00 ",
        Stage: "Final",
        Stadium: "Stade Olympique",
        City: "Colombes ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 4,
        AwayTeamGoals: 2,
        AwayTeamName: "Hungary",
        WinConditions: " ",
        Attendance: 45000,
        RoundID: "final",
        MatchID: 1174,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "HUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.23008,
          -22.9122
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "24 Jun 1950 - 15:00 ",
        Stage: "Group 1",
        Stadium: "Maracana-Estudio Jornalista Mario Filho",
        City: "Rio De Janeiro ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 4,
        AwayTeamGoals: 0,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 81649,
        RoundID: "group",
        MatchID: 1187,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.23008,
          -22.9122
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "25 Jun 1950 - 15:00 ",
        Stage: "Group 2",
        Stadium: "Maracana-Estudio Jornalista Mario Filho",
        City: "Rio De Janeiro ",
        HomeTeamName: "England",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Chile",
        WinConditions: " ",
        Attendance: 29703,
        RoundID: "group",
        MatchID: 1192,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "CHI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -49.25583,
          -25.43944
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "25 Jun 1950 - 15:00 ",
        Stage: "Group 2",
        Stadium: "Durival de Brito",
        City: "Curitiba ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "USA",
        WinConditions: " ",
        Attendance: 9511,
        RoundID: "group",
        MatchID: 1208,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "USA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -46.66533,
          -23.54844
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "25 Jun 1950 - 15:00 ",
        Stage: "Group 3",
        Stadium: "Pacaembu",
        City: "Sao Paulo ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 36502,
        RoundID: "group",
        MatchID: 1219,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.91777,
          -19.90833
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "25 Jun 1950 - 15:00 ",
        Stage: "Group 1",
        Stadium: "Independencia",
        City: "Belo Horizonte ",
        HomeTeamName: "Yugoslavia",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Switzerland",
        WinConditions: " ",
        Attendance: 7336,
        RoundID: "group",
        MatchID: 1230,
        HomeTeamInitials: "YUG",
        AwayTeamInitials: "SUI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -46.66533,
          -23.54844
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "28 Jun 1950 - 15:00 ",
        Stage: "Group 1",
        Stadium: "Pacaembu",
        City: "Sao Paulo ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Switzerland",
        WinConditions: " ",
        Attendance: 42032,
        RoundID: "group",
        MatchID: 1188,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "SUI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -51.22722,
          -30.06166
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "28 Jun 1950 - 15:00 ",
        Stage: "Group 1",
        Stadium: "Eucaliptos",
        City: "Porto Alegre ",
        HomeTeamName: "Yugoslavia",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 11078,
        RoundID: "group",
        MatchID: 1225,
        HomeTeamInitials: "YUG",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.23008,
          -22.9122
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "29 Jun 1950 - 15:00 ",
        Stage: "Group 2",
        Stadium: "Maracana-Estudio Jornalista Mario Filho",
        City: "Rio De Janeiro ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Chile",
        WinConditions: " ",
        Attendance: 19790,
        RoundID: "group",
        MatchID: 1193,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "CHI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -49.25583,
          -25.43944
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "29 Jun 1950 - 15:30 ",
        Stage: "Group 3",
        Stadium: "Durival de Brito",
        City: "Curitiba ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Paraguay",
        WinConditions: " ",
        Attendance: 7903,
        RoundID: "group",
        MatchID: 1228,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "PAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.91777,
          -19.90833
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "29 Jun 1950 - 15:00 ",
        Stage: "Group 2",
        Stadium: "Independencia",
        City: "Belo Horizonte ",
        HomeTeamName: "USA",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 10151,
        RoundID: "group",
        MatchID: 1202,
        HomeTeamInitials: "USA",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.23008,
          -22.9122
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "01 Jul 1950 - 15:00 ",
        Stage: "Group 1",
        Stadium: "Maracana-Estudio Jornalista Mario Filho",
        City: "Rio De Janeiro ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Yugoslavia",
        WinConditions: " ",
        Attendance: 142429,
        RoundID: "group",
        MatchID: 1191,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "YUG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.23008,
          -22.9122
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "02 Jul 1950 - 15:00 ",
        Stage: "Group 2",
        Stadium: "Maracana-Estudio Jornalista Mario Filho",
        City: "Rio De Janeiro ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 74462,
        RoundID: "group",
        MatchID: 1199,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -46.66533,
          -23.54844
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "02 Jul 1950 - 15:00 ",
        Stage: "Group 3",
        Stadium: "Pacaembu",
        City: "Sao Paulo ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Paraguay",
        WinConditions: " ",
        Attendance: 25811,
        RoundID: "group",
        MatchID: 1218,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "PAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.91777,
          -19.90833
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "02 Jul 1950 - 15:00 ",
        Stage: "Group 4",
        Stadium: "Independencia",
        City: "Belo Horizonte ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 8,
        AwayTeamGoals: 0,
        AwayTeamName: "Bolivia",
        WinConditions: " ",
        Attendance: 5284,
        RoundID: "group",
        MatchID: 1185,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "BOL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -51.22722,
          -30.06166
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "02 Jul 1950 - 15:40 ",
        Stage: "Group 1",
        Stadium: "Eucaliptos",
        City: "Porto Alegre ",
        HomeTeamName: "Switzerland",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 3580,
        RoundID: "group",
        MatchID: 1222,
        HomeTeamInitials: "SUI",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -34.90292,
          -8.06302
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "02 Jul 1950 - 15:00 ",
        Stage: "Group 2",
        Stadium: "Ilha do Retiro",
        City: "Recife ",
        HomeTeamName: "Chile",
        HomeTeamGoals: 5,
        AwayTeamGoals: 2,
        AwayTeamName: "USA",
        WinConditions: " ",
        Attendance: 8501,
        RoundID: "group",
        MatchID: 1194,
        HomeTeamInitials: "CHI",
        AwayTeamInitials: "USA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -46.66533,
          -23.54844
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "09 Jul 1950 - 15:00 ",
        Stage: "Group 6",
        Stadium: "Pacaembu",
        City: "Sao Paulo ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 44802,
        RoundID: "rfour",
        MatchID: 1207,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.23008,
          -22.9122
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "09 Jul 1950 - 15:00 ",
        Stage: "Group 6",
        Stadium: "Maracana-Estudio Jornalista Mario Filho",
        City: "Rio De Janeiro ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 7,
        AwayTeamGoals: 1,
        AwayTeamName: "Sweden",
        WinConditions: " ",
        Attendance: 138886,
        RoundID: "rfour",
        MatchID: 1189,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "SWE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.23008,
          -22.9122
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "13 Jul 1950 - 15:00 ",
        Stage: "Group 6",
        Stadium: "Maracana-Estudio Jornalista Mario Filho",
        City: "Rio De Janeiro ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 6,
        AwayTeamGoals: 1,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 152772,
        RoundID: "rfour",
        MatchID: 1186,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -46.66533,
          -23.54844
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "13 Jul 1950 - 15:00 ",
        Stage: "Group 6",
        Stadium: "Pacaembu",
        City: "Sao Paulo ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Sweden",
        WinConditions: " ",
        Attendance: 7987,
        RoundID: "rfour",
        MatchID: 1231,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "SWE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -46.66533,
          -23.54844
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "16 Jul 1950 - 15:00 ",
        Stage: "Match for third place",
        Stadium: "Pacaembu",
        City: "Sao Paulo ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 11227,
        RoundID: "third",
        MatchID: 1206,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.23008,
          -22.9122
        ]
      },
      properties: {
        Year: 1950,
        Datetime: "16 Jul 1950 - 15:00 ",
        Stage: "Final",
        Stadium: "Maracana-Estudio Jornalista Mario Filho",
        City: "Rio De Janeiro ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 173850,
        RoundID: "final",
        MatchID: 1190,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.46485,
          46.96304
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "16 Jun 1954 - 18:00 ",
        Stage: "Group 3",
        Stadium: "Wankdorf Stadium",
        City: "Berne ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Czechoslovakia",
        WinConditions: " ",
        Attendance: 20500,
        RoundID: "group",
        MatchID: 1315,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "TCH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.50472,
          47.39305
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "16 Jun 1954 - 18:00 ",
        Stage: "Group 3",
        Stadium: "Hardturm",
        City: "Zurich ",
        HomeTeamName: "Austria",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Scotland",
        WinConditions: " ",
        Attendance: 25000,
        RoundID: "group",
        MatchID: 1236,
        HomeTeamInitials: "AUT",
        AwayTeamInitials: "SCO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          6.1182,
          46.2091
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "16 Jun 1954 - 18:00 ",
        Stage: "Group 1",
        Stadium: "Charmilles",
        City: "Geneva ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 5,
        AwayTeamGoals: 0,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 13470,
        RoundID: "group",
        MatchID: 1249,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          6.62438,
          46.53337
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "16 Jun 1954 - 18:00 ",
        Stage: "Group 1",
        Stadium: "La Pontaise",
        City: "Lausanne ",
        HomeTeamName: "Yugoslavia",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 16000,
        RoundID: "group",
        MatchID: 1276,
        HomeTeamInitials: "YUG",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.46485,
          46.96304
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "17 Jun 1954 - 18:00 ",
        Stage: "Group 2",
        Stadium: "Wankdorf Stadium",
        City: "Berne ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "Turkey",
        WinConditions: " ",
        Attendance: 28000,
        RoundID: "group",
        MatchID: 1283,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "TUR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.50472,
          47.39305
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "17 Jun 1954 - 18:00 ",
        Stage: "Group 2",
        Stadium: "Hardturm",
        City: "Zurich ",
        HomeTeamName: "Hungary",
        HomeTeamGoals: 9,
        AwayTeamGoals: 0,
        AwayTeamName: "Korea Republic",
        WinConditions: " ",
        Attendance: 13000,
        RoundID: "group",
        MatchID: 1294,
        HomeTeamInitials: "HUN",
        AwayTeamInitials: "KOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.61999,
          47.54156
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "17 Jun 1954 - 18:10 ",
        Stage: "Group 4",
        Stadium: "St. Jakob",
        City: "Basel ",
        HomeTeamName: "England",
        HomeTeamGoals: 4,
        AwayTeamGoals: 4,
        AwayTeamName: "Belgium",
        WinConditions: " ",
        Attendance: 14000,
        RoundID: "group",
        MatchID: 1240,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          6.62438,
          46.53337
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "17 Jun 1954 - 17:50 ",
        Stage: "Group 4",
        Stadium: "La Pontaise",
        City: "Lausanne ",
        HomeTeamName: "Switzerland",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 43000,
        RoundID: "group",
        MatchID: 1300,
        HomeTeamInitials: "SUI",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.61999,
          47.54156
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "19 Jun 1954 - 16:50 ",
        Stage: "Group 3",
        Stadium: "St. Jakob",
        City: "Basel ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 7,
        AwayTeamGoals: 0,
        AwayTeamName: "Scotland",
        WinConditions: " ",
        Attendance: 34000,
        RoundID: "group",
        MatchID: 1313,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "SCO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.50472,
          47.39305
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "19 Jun 1954 - 17:00 ",
        Stage: "Group 3",
        Stadium: "Hardturm",
        City: "Zurich ",
        HomeTeamName: "Austria",
        HomeTeamGoals: 5,
        AwayTeamGoals: 0,
        AwayTeamName: "Czechoslovakia",
        WinConditions: " ",
        Attendance: 26000,
        RoundID: "group",
        MatchID: 1238,
        HomeTeamInitials: "AUT",
        AwayTeamInitials: "TCH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          6.1182,
          46.2091
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "19 Jun 1954 - 17:10 ",
        Stage: "Group 1",
        Stadium: "Charmilles",
        City: "Geneva ",
        HomeTeamName: "France",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 19000,
        RoundID: "group",
        MatchID: 1275,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          6.62438,
          46.53337
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "19 Jun 1954 - 17:00 ",
        Stage: "Group 1",
        Stadium: "La Pontaise",
        City: "Lausanne ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Yugoslavia",
        WinConditions: " ",
        Attendance: 24637,
        RoundID: "group",
        MatchID: 1252,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "YUG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.61999,
          47.54156
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "20 Jun 1954 - 16:50 ",
        Stage: "Group 2",
        Stadium: "St. Jakob",
        City: "Basel ",
        HomeTeamName: "Hungary",
        HomeTeamGoals: 8,
        AwayTeamGoals: 3,
        AwayTeamName: "Germany FR",
        WinConditions: " ",
        Attendance: 56000,
        RoundID: "group",
        MatchID: 1277,
        HomeTeamInitials: "HUN",
        AwayTeamInitials: "FRG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          6.1182,
          46.2091
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "20 Jun 1954 - 17:00 ",
        Stage: "Group 2",
        Stadium: "Charmilles",
        City: "Geneva ",
        HomeTeamName: "Turkey",
        HomeTeamGoals: 7,
        AwayTeamGoals: 0,
        AwayTeamName: "Korea Republic",
        WinConditions: " ",
        Attendance: 4000,
        RoundID: "group",
        MatchID: 1304,
        HomeTeamInitials: "TUR",
        AwayTeamInitials: "KOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.46485,
          46.96304
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "20 Jun 1954 - 17:10 ",
        Stage: "Group 4",
        Stadium: "Wankdorf Stadium",
        City: "Berne ",
        HomeTeamName: "England",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Switzerland",
        WinConditions: " ",
        Attendance: 43500,
        RoundID: "group",
        MatchID: 1263,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "SUI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.96129,
          46.02404
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "20 Jun 1954 - 17:00 ",
        Stage: "Group 4",
        Stadium: "Comunale di Cornaredo",
        City: "Lugano ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "Belgium",
        WinConditions: " ",
        Attendance: 24000,
        RoundID: "group",
        MatchID: 1243,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.50472,
          47.39305
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "23 Jun 1954 - 18:00 ",
        Stage: "Group 2",
        Stadium: "Hardturm",
        City: "Zurich ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 7,
        AwayTeamGoals: 2,
        AwayTeamName: "Turkey",
        WinConditions: " ",
        Attendance: 17000,
        RoundID: "group",
        MatchID: 1284,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "TUR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.61999,
          47.54156
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "23 Jun 1954 - 18:00 ",
        Stage: "Group 4",
        Stadium: "St. Jakob",
        City: "Basel ",
        HomeTeamName: "Switzerland",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 30000,
        RoundID: "group",
        MatchID: 1301,
        HomeTeamInitials: "SUI",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.61999,
          47.54156
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "26 Jun 1954 - 17:00 ",
        Stage: "Quarter-finals",
        Stadium: "St. Jakob",
        City: "Basel ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 4,
        AwayTeamGoals: 2,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 28000,
        RoundID: "quart",
        MatchID: 1264,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          6.62438,
          46.53337
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "26 Jun 1954 - 17:00 ",
        Stage: "Quarter-finals",
        Stadium: "La Pontaise",
        City: "Lausanne ",
        HomeTeamName: "Austria",
        HomeTeamGoals: 7,
        AwayTeamGoals: 5,
        AwayTeamName: "Switzerland",
        WinConditions: " ",
        Attendance: 35000,
        RoundID: "quart",
        MatchID: 1237,
        HomeTeamInitials: "AUT",
        AwayTeamInitials: "SUI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          6.1182,
          46.2091
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "27 Jun 1954 - 17:00 ",
        Stage: "Quarter-finals",
        Stadium: "Charmilles",
        City: "Geneva ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Yugoslavia",
        WinConditions: " ",
        Attendance: 17000,
        RoundID: "quart",
        MatchID: 1285,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "YUG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.46485,
          46.96304
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "27 Jun 1954 - 17:00 ",
        Stage: "Quarter-finals",
        Stadium: "Wankdorf Stadium",
        City: "Berne ",
        HomeTeamName: "Hungary",
        HomeTeamGoals: 4,
        AwayTeamGoals: 2,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 40000,
        RoundID: "quart",
        MatchID: 1248,
        HomeTeamInitials: "HUN",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.61999,
          47.54156
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "30 Jun 1954 - 18:00 ",
        Stage: "Semi-finals",
        Stadium: "St. Jakob",
        City: "Basel ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 6,
        AwayTeamGoals: 1,
        AwayTeamName: "Austria",
        WinConditions: " ",
        Attendance: 58000,
        RoundID: "semi",
        MatchID: 1233,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "AUT"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          6.62438,
          46.53337
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "30 Jun 1954 - 18:00 ",
        Stage: "Semi-finals",
        Stadium: "La Pontaise",
        City: "Lausanne ",
        HomeTeamName: "Hungary",
        HomeTeamGoals: 4,
        AwayTeamGoals: 2,
        AwayTeamName: "Uruguay",
        WinConditions: "win after extra time ",
        Attendance: 45000,
        RoundID: "semi",
        MatchID: 1295,
        HomeTeamInitials: "HUN",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.50472,
          47.39305
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "03 Jul 1954 - 17:00 ",
        Stage: "Match for third place",
        Stadium: "Hardturm",
        City: "Zurich ",
        HomeTeamName: "Austria",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 32000,
        RoundID: "third",
        MatchID: 1239,
        HomeTeamInitials: "AUT",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.46485,
          46.96304
        ]
      },
      properties: {
        Year: 1954,
        Datetime: "04 Jul 1954 - 17:00 ",
        Stage: "Final",
        Stadium: "Wankdorf Stadium",
        City: "Berne ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Hungary",
        WinConditions: " ",
        Attendance: 62500,
        RoundID: "final",
        MatchID: 1278,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "HUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          18.0004,
          59.37244
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "08 Jun 1958 - 14:00 ",
        Stage: "Group 3",
        Stadium: "Rasunda Stadium",
        City: "Solna ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 34107,
        RoundID: "group",
        MatchID: 1415,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.98734,
          57.70585
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "08 Jun 1958 - 19:00 ",
        Stage: "Group 4",
        Stadium: "Nya Ullevi",
        City: "Gothenburg ",
        HomeTeamName: "Soviet Union",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 49348,
        RoundID: "group",
        MatchID: 1372,
        HomeTeamInitials: "URS",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.98925,
          55.58601
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "08 Jun 1958 - 19:00 ",
        Stage: "Group 1",
        Stadium: "Malmo Stadion",
        City: "Malmo",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 1,
        AwayTeamGoals: 3,
        AwayTeamName: "Germany FR",
        WinConditions: " ",
        Attendance: 31156,
        RoundID: "group",
        MatchID: 1323,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "FRG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          16.7708,
          60.6087
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "08 Jun 1958 - 19:00 ",
        Stage: "Group 3",
        Stadium: "Jarnvallen",
        City: "Sandviken ",
        HomeTeamName: "Hungary",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Wales",
        WinConditions: " ",
        Attendance: 15343,
        RoundID: "group",
        MatchID: 1407,
        HomeTeamInitials: "HUN",
        AwayTeamInitials: "WAL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          16.17271,
          58.58458
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "08 Jun 1958 - 19:00 ",
        Stage: "Group 2",
        Stadium: "Idrottsparken",
        City: "Norrkoping",
        HomeTeamName: "France",
        HomeTeamGoals: 7,
        AwayTeamGoals: 3,
        AwayTeamName: "Paraguay",
        WinConditions: " ",
        Attendance: 16518,
        RoundID: "group",
        MatchID: 1386,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "PAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          16.5403,
          59.62023
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "08 Jun 1958 - 19:00 ",
        Stage: "Group 2",
        Stadium: "Arosvallen",
        City: "Vasteras ",
        HomeTeamName: "Yugoslavia",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Scotland",
        WinConditions: " ",
        Attendance: 9591,
        RoundID: "group",
        MatchID: 1434,
        HomeTeamInitials: "YUG",
        AwayTeamInitials: "SCO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.94912,
          58.35709
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "08 Jun 1958 - 19:00 ",
        Stage: "Group 4",
        Stadium: "Rimnersvallen",
        City: "Udevalla ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Austria",
        WinConditions: " ",
        Attendance: 17788,
        RoundID: "group",
        MatchID: 1326,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "AUT"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.86726,
          56.68431
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "08 Jun 1958 - 19:00 ",
        Stage: "Group 1",
        Stadium: "Orjans Vall",
        City: "Halmstad ",
        HomeTeamName: "Northern Ireland",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Czechoslovakia",
        WinConditions: " ",
        Attendance: 10647,
        RoundID: "group",
        MatchID: 1421,
        HomeTeamInitials: "NIR",
        AwayTeamInitials: "TCH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.98734,
          57.70585
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "11 Jun 1958 - 19:00 ",
        Stage: "Group 4",
        Stadium: "Nya Ullevi",
        City: "Gothenburg ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 40895,
        RoundID: "group",
        MatchID: 1339,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          18.0004,
          59.37244
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "11 Jun 1958 - 19:00 ",
        Stage: "Group 3",
        Stadium: "Rasunda Stadium",
        City: "Solna ",
        HomeTeamName: "Mexico",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Wales",
        WinConditions: " ",
        Attendance: 15150,
        RoundID: "group",
        MatchID: 1418,
        HomeTeamInitials: "MEX",
        AwayTeamInitials: "WAL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          16.17271,
          58.58458
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "11 Jun 1958 - 19:00 ",
        Stage: "Group 2",
        Stadium: "Idrottsparken",
        City: "Norrkoping",
        HomeTeamName: "Paraguay",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Scotland",
        WinConditions: " ",
        Attendance: 11665,
        RoundID: "group",
        MatchID: 1423,
        HomeTeamInitials: "PAR",
        AwayTeamInitials: "SCO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          16.5403,
          59.62023
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "11 Jun 1958 - 19:00 ",
        Stage: "Group 2",
        Stadium: "Arosvallen",
        City: "Vasteras ",
        HomeTeamName: "Yugoslavia",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 12217,
        RoundID: "group",
        MatchID: 1388,
        HomeTeamInitials: "YUG",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.93483,
          57.73573
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "11 Jun 1958 - 19:00 ",
        Stage: "Group 4",
        Stadium: "Ryavallen",
        City: "Boras ",
        HomeTeamName: "Soviet Union",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Austria",
        WinConditions: " ",
        Attendance: 21239,
        RoundID: "group",
        MatchID: 1332,
        HomeTeamInitials: "URS",
        AwayTeamInitials: "AUT"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.70668,
          56.04994
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "11 Jun 1958 - 19:00 ",
        Stage: "Group 1",
        Stadium: "Olympia Stadium",
        City: "Helsingborg ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Czechoslovakia",
        WinConditions: " ",
        Attendance: 25000,
        RoundID: "group",
        MatchID: 1391,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "TCH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.86726,
          56.68431
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "11 Jun 1958 - 19:00 ",
        Stage: "Group 1",
        Stadium: "Orjans Vall",
        City: "Halmstad ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Northern Ireland",
        WinConditions: " ",
        Attendance: 14174,
        RoundID: "group",
        MatchID: 1324,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "NIR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          18.0004,
          59.37244
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "12 Jun 1958 - 19:00 ",
        Stage: "Group 3",
        Stadium: "Rasunda Stadium",
        City: "Solna ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Hungary",
        WinConditions: " ",
        Attendance: 38850,
        RoundID: "group",
        MatchID: 1406,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "HUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          18.0004,
          59.37244
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "15 Jun 1958 - 14:00 ",
        Stage: "Group 3",
        Stadium: "Rasunda Stadium",
        City: "Solna ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Wales",
        WinConditions: " ",
        Attendance: 30287,
        RoundID: "group",
        MatchID: 1438,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "WAL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.98734,
          57.70585
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "15 Jun 1958 - 19:00 ",
        Stage: "Group 4",
        Stadium: "Nya Ullevi",
        City: "Gothenburg ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Soviet Union",
        WinConditions: " ",
        Attendance: 50928,
        RoundID: "group",
        MatchID: 1344,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "URS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.98925,
          55.58601
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "15 Jun 1958 - 19:00 ",
        Stage: "Group 1",
        Stadium: "Malmo Stadion",
        City: "Malmo",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Northern Ireland",
        WinConditions: " ",
        Attendance: 21990,
        RoundID: "group",
        MatchID: 1389,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "NIR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          16.7708,
          60.6087
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "15 Jun 1958 - 19:00 ",
        Stage: "Group 3",
        Stadium: "Jarnvallen",
        City: "Sandviken ",
        HomeTeamName: "Hungary",
        HomeTeamGoals: 4,
        AwayTeamGoals: 0,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 13300,
        RoundID: "group",
        MatchID: 1403,
        HomeTeamInitials: "HUN",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          16.495,
          59.37067
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "15 Jun 1958 - 19:00 ",
        Stage: "Group 2",
        Stadium: "Tunavallen",
        City: "Eskilstuna ",
        HomeTeamName: "Paraguay",
        HomeTeamGoals: 3,
        AwayTeamGoals: 3,
        AwayTeamName: "Yugoslavia",
        WinConditions: " ",
        Attendance: 13103,
        RoundID: "group",
        MatchID: 1426,
        HomeTeamInitials: "PAR",
        AwayTeamInitials: "YUG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          15.22348,
          59.26618
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "15 Jun 1958 - 19:00 ",
        Stage: "Group 2",
        Stadium: "Eyravallen",
        City: "Orebro ",
        HomeTeamName: "France",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Scotland",
        WinConditions: " ",
        Attendance: 13554,
        RoundID: "group",
        MatchID: 1387,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "SCO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.93483,
          57.73573
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "15 Jun 1958 - 19:00 ",
        Stage: "Group 4",
        Stadium: "Ryavallen",
        City: "Boras ",
        HomeTeamName: "England",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Austria",
        WinConditions: " ",
        Attendance: 15872,
        RoundID: "group",
        MatchID: 1327,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "AUT"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.70668,
          56.04994
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "15 Jun 1958 - 19:00 ",
        Stage: "Group 1",
        Stadium: "Olympia Stadium",
        City: "Helsingborg ",
        HomeTeamName: "Czechoslovakia",
        HomeTeamGoals: 6,
        AwayTeamGoals: 1,
        AwayTeamName: "Argentina",
        WinConditions: " ",
        Attendance: 16418,
        RoundID: "group",
        MatchID: 1325,
        HomeTeamInitials: "TCH",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.98734,
          57.70585
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "17 Jun 1958 - 19:00 ",
        Stage: "Group 4",
        Stadium: "Nya Ullevi",
        City: "Gothenburg ",
        HomeTeamName: "Soviet Union",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 23182,
        RoundID: "group",
        MatchID: 1373,
        HomeTeamInitials: "URS",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.98925,
          55.58601
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "17 Jun 1958 - 19:00 ",
        Stage: "Group 1",
        Stadium: "Malmo Stadion",
        City: "Malmo",
        HomeTeamName: "Northern Ireland",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Czechoslovakia",
        WinConditions: "win after extra time ",
        Attendance: 6196,
        RoundID: "group",
        MatchID: 1422,
        HomeTeamInitials: "NIR",
        AwayTeamInitials: "TCH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          18.0004,
          59.37244
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "17 Jun 1958 - 19:00 ",
        Stage: "Group 3",
        Stadium: "Rasunda Stadium",
        City: "Solna ",
        HomeTeamName: "Wales",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Hungary",
        WinConditions: " ",
        Attendance: 2823,
        RoundID: "group",
        MatchID: 1408,
        HomeTeamInitials: "WAL",
        AwayTeamInitials: "HUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.98734,
          57.70585
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "19 Jun 1958 - 19:00 ",
        Stage: "Quarter-finals",
        Stadium: "Nya Ullevi",
        City: "Gothenburg ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Wales",
        WinConditions: " ",
        Attendance: 25923,
        RoundID: "quart",
        MatchID: 1345,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "WAL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.98925,
          55.58601
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "19 Jun 1958 - 19:00 ",
        Stage: "Quarter-finals",
        Stadium: "Malmo Stadion",
        City: "Malmo",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Yugoslavia",
        WinConditions: " ",
        Attendance: 20055,
        RoundID: "quart",
        MatchID: 1392,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "YUG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          18.0004,
          59.37244
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "19 Jun 1958 - 19:00 ",
        Stage: "Quarter-finals",
        Stadium: "Rasunda Stadium",
        City: "Solna ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Soviet Union",
        WinConditions: " ",
        Attendance: 31900,
        RoundID: "quart",
        MatchID: 1437,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "URS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          16.17271,
          58.58458
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "19 Jun 1958 - 19:00 ",
        Stage: "Quarter-finals",
        Stadium: "Idrottsparken",
        City: "Norrkoping",
        HomeTeamName: "France",
        HomeTeamGoals: 4,
        AwayTeamGoals: 0,
        AwayTeamName: "Northern Ireland",
        WinConditions: " ",
        Attendance: 11800,
        RoundID: "quart",
        MatchID: 1385,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "NIR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.98734,
          57.70585
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "24 Jun 1958 - 19:00 ",
        Stage: "Semi-finals",
        Stadium: "Nya Ullevi",
        City: "Gothenburg ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Germany FR",
        WinConditions: " ",
        Attendance: 49471,
        RoundID: "semi",
        MatchID: 1390,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "FRG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          18.0004,
          59.37244
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "24 Jun 1958 - 19:00 ",
        Stage: "Semi-finals",
        Stadium: "Rasunda Stadium",
        City: "Solna ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 5,
        AwayTeamGoals: 2,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 27100,
        RoundID: "semi",
        MatchID: 1340,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.98734,
          57.70585
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "28 Jun 1958 - 17:00 ",
        Stage: "Match for third place",
        Stadium: "Nya Ullevi",
        City: "Gothenburg ",
        HomeTeamName: "France",
        HomeTeamGoals: 6,
        AwayTeamGoals: 3,
        AwayTeamName: "Germany FR",
        WinConditions: " ",
        Attendance: 32483,
        RoundID: "third",
        MatchID: 1382,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "FRG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          18.0004,
          59.37244
        ]
      },
      properties: {
        Year: 1958,
        Datetime: "29 Jun 1958 - 15:00 ",
        Stage: "Final",
        Stadium: "Rasunda Stadium",
        City: "Solna ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 5,
        AwayTeamGoals: 2,
        AwayTeamName: "Sweden",
        WinConditions: " ",
        Attendance: 49737,
        RoundID: "final",
        MatchID: 1343,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "SWE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.29917,
          -18.48764
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "30 May 1962 - 15:00 ",
        Stage: "Group 1",
        Stadium: "Carlos Dittborn",
        City: "Arica ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Colombia",
        WinConditions: " ",
        Attendance: 7908,
        RoundID: "group",
        MatchID: 1479,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "COL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -71.53522,
          -33.01452
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "30 May 1962 - 15:00 ",
        Stage: "Group 3",
        Stadium: "Estadio Sausalito",
        City: "Vina Del Mar ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 10484,
        RoundID: "group",
        MatchID: 1461,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.73749,
          -34.1779
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "30 May 1962 - 15:00 ",
        Stage: "Group 4",
        Stadium: "Estadio El Teniente-Codelco",
        City: "Rancagua ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Bulgaria",
        WinConditions: " ",
        Attendance: 7134,
        RoundID: "group",
        MatchID: 1447,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "BUL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.61063,
          -33.46472
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "30 May 1962 - 15:00 ",
        Stage: "Group 2",
        Stadium: "Nacional",
        City: "Santiago De Chile ",
        HomeTeamName: "Chile",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Switzerland",
        WinConditions: " ",
        Attendance: 65006,
        RoundID: "group",
        MatchID: 1473,
        HomeTeamInitials: "CHI",
        AwayTeamInitials: "SUI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.29917,
          -18.48764
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "31 May 1962 - 15:00 ",
        Stage: "Group 1",
        Stadium: "Carlos Dittborn",
        City: "Arica ",
        HomeTeamName: "Soviet Union",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Yugoslavia",
        WinConditions: " ",
        Attendance: 9622,
        RoundID: "group",
        MatchID: 1563,
        HomeTeamInitials: "URS",
        AwayTeamInitials: "YUG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -71.53522,
          -33.01452
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "31 May 1962 - 15:00 ",
        Stage: "Group 3",
        Stadium: "Estadio Sausalito",
        City: "Vina Del Mar ",
        HomeTeamName: "Czechoslovakia",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 12700,
        RoundID: "group",
        MatchID: 1498,
        HomeTeamInitials: "TCH",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.73749,
          -34.1779
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "31 May 1962 - 15:00 ",
        Stage: "Group 4",
        Stadium: "Estadio El Teniente-Codelco",
        City: "Rancagua ",
        HomeTeamName: "Hungary",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 7938,
        RoundID: "group",
        MatchID: 1490,
        HomeTeamInitials: "HUN",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.61063,
          -33.46472
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "31 May 1962 - 15:00 ",
        Stage: "Group 2",
        Stadium: "Nacional",
        City: "Santiago De Chile ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 65440,
        RoundID: "group",
        MatchID: 1507,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.29917,
          -18.48764
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "02 Jun 1962 - 15:00 ",
        Stage: "Group 1",
        Stadium: "Carlos Dittborn",
        City: "Arica ",
        HomeTeamName: "Yugoslavia",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 8829,
        RoundID: "group",
        MatchID: 1564,
        HomeTeamInitials: "YUG",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -71.53522,
          -33.01452
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "02 Jun 1962 - 15:00 ",
        Stage: "Group 3",
        Stadium: "Estadio Sausalito",
        City: "Vina Del Mar ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Czechoslovakia",
        WinConditions: " ",
        Attendance: 14903,
        RoundID: "group",
        MatchID: 1462,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "TCH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.73749,
          -34.1779
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "02 Jun 1962 - 15:00 ",
        Stage: "Group 4",
        Stadium: "Estadio El Teniente-Codelco",
        City: "Rancagua ",
        HomeTeamName: "England",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Argentina",
        WinConditions: " ",
        Attendance: 9794,
        RoundID: "group",
        MatchID: 1450,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.61063,
          -33.46472
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "02 Jun 1962 - 15:00 ",
        Stage: "Group 2",
        Stadium: "Nacional",
        City: "Santiago De Chile ",
        HomeTeamName: "Chile",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 66057,
        RoundID: "group",
        MatchID: 1472,
        HomeTeamInitials: "CHI",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.29917,
          -18.48764
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "03 Jun 1962 - 15:00 ",
        Stage: "Group 1",
        Stadium: "Carlos Dittborn",
        City: "Arica ",
        HomeTeamName: "Soviet Union",
        HomeTeamGoals: 4,
        AwayTeamGoals: 4,
        AwayTeamName: "Colombia",
        WinConditions: " ",
        Attendance: 8040,
        RoundID: "group",
        MatchID: 1478,
        HomeTeamInitials: "URS",
        AwayTeamInitials: "COL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -71.53522,
          -33.01452
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "03 Jun 1962 - 15:00 ",
        Stage: "Group 3",
        Stadium: "Estadio Sausalito",
        City: "Vina Del Mar ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 11875,
        RoundID: "group",
        MatchID: 1497,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.73749,
          -34.1779
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "03 Jun 1962 - 15:00 ",
        Stage: "Group 4",
        Stadium: "Estadio El Teniente-Codelco",
        City: "Rancagua ",
        HomeTeamName: "Hungary",
        HomeTeamGoals: 6,
        AwayTeamGoals: 1,
        AwayTeamName: "Bulgaria",
        WinConditions: " ",
        Attendance: 7442,
        RoundID: "group",
        MatchID: 1470,
        HomeTeamInitials: "HUN",
        AwayTeamInitials: "BUL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.61063,
          -33.46472
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "03 Jun 1962 - 15:00 ",
        Stage: "Group 2",
        Stadium: "Nacional",
        City: "Santiago De Chile ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Switzerland",
        WinConditions: " ",
        Attendance: 64922,
        RoundID: "group",
        MatchID: 1510,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "SUI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.29917,
          -18.48764
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "06 Jun 1962 - 15:00 ",
        Stage: "Group 1",
        Stadium: "Carlos Dittborn",
        City: "Arica ",
        HomeTeamName: "Soviet Union",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 9973,
        RoundID: "group",
        MatchID: 1562,
        HomeTeamInitials: "URS",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -71.53522,
          -33.01452
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "06 Jun 1962 - 15:00 ",
        Stage: "Group 3",
        Stadium: "Estadio Sausalito",
        City: "Vina Del Mar ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 18715,
        RoundID: "group",
        MatchID: 1460,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.73749,
          -34.1779
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "06 Jun 1962 - 15:00 ",
        Stage: "Group 4",
        Stadium: "Estadio El Teniente-Codelco",
        City: "Rancagua ",
        HomeTeamName: "Hungary",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Argentina",
        WinConditions: " ",
        Attendance: 7945,
        RoundID: "group",
        MatchID: 1451,
        HomeTeamInitials: "HUN",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.61063,
          -33.46472
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "06 Jun 1962 - 15:00 ",
        Stage: "Group 2",
        Stadium: "Nacional",
        City: "Santiago De Chile ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Chile",
        WinConditions: " ",
        Attendance: 67224,
        RoundID: "group",
        MatchID: 1471,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "CHI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.29917,
          -18.48764
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "07 Jun 1962 - 15:00 ",
        Stage: "Group 1",
        Stadium: "Carlos Dittborn",
        City: "Arica ",
        HomeTeamName: "Yugoslavia",
        HomeTeamGoals: 5,
        AwayTeamGoals: 0,
        AwayTeamName: "Colombia",
        WinConditions: " ",
        Attendance: 7167,
        RoundID: "group",
        MatchID: 1480,
        HomeTeamInitials: "YUG",
        AwayTeamInitials: "COL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -71.53522,
          -33.01452
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "07 Jun 1962 - 15:00 ",
        Stage: "Group 3",
        Stadium: "Estadio Sausalito",
        City: "Vina Del Mar ",
        HomeTeamName: "Mexico",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Czechoslovakia",
        WinConditions: " ",
        Attendance: 10648,
        RoundID: "group",
        MatchID: 1544,
        HomeTeamInitials: "MEX",
        AwayTeamInitials: "TCH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.73749,
          -34.1779
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "07 Jun 1962 - 15:00 ",
        Stage: "Group 4",
        Stadium: "Estadio El Teniente-Codelco",
        City: "Rancagua ",
        HomeTeamName: "England",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Bulgaria",
        WinConditions: " ",
        Attendance: 5700,
        RoundID: "group",
        MatchID: 1464,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "BUL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.61063,
          -33.46472
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "07 Jun 1962 - 15:00 ",
        Stage: "Group 2",
        Stadium: "Nacional",
        City: "Santiago De Chile ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Switzerland",
        WinConditions: " ",
        Attendance: 59828,
        RoundID: "group",
        MatchID: 1532,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "SUI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.29917,
          -18.48764
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "10 Jun 1962 - 14:30 ",
        Stage: "Quarter-finals",
        Stadium: "Carlos Dittborn",
        City: "Arica ",
        HomeTeamName: "Chile",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Soviet Union",
        WinConditions: " ",
        Attendance: 17268,
        RoundID: "quart",
        MatchID: 1474,
        HomeTeamInitials: "CHI",
        AwayTeamInitials: "URS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -71.53522,
          -33.01452
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "10 Jun 1962 - 14:30 ",
        Stage: "Quarter-finals",
        Stadium: "Estadio Sausalito",
        City: "Vina Del Mar ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 17736,
        RoundID: "quart",
        MatchID: 1459,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.73749,
          -34.1779
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "10 Jun 1962 - 14:30 ",
        Stage: "Quarter-finals",
        Stadium: "Estadio El Teniente-Codelco",
        City: "Rancagua ",
        HomeTeamName: "Czechoslovakia",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Hungary",
        WinConditions: " ",
        Attendance: 11690,
        RoundID: "quart",
        MatchID: 1525,
        HomeTeamInitials: "TCH",
        AwayTeamInitials: "HUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.61063,
          -33.46472
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "10 Jun 1962 - 14:30 ",
        Stage: "Quarter-finals",
        Stadium: "Nacional",
        City: "Santiago De Chile ",
        HomeTeamName: "Yugoslavia",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Germany FR",
        WinConditions: " ",
        Attendance: 63324,
        RoundID: "quart",
        MatchID: 1511,
        HomeTeamInitials: "YUG",
        AwayTeamInitials: "FRG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -71.53522,
          -33.01452
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "13 Jun 1962 - 14:30 ",
        Stage: "Semi-finals",
        Stadium: "Estadio Sausalito",
        City: "Vina Del Mar ",
        HomeTeamName: "Czechoslovakia",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Yugoslavia",
        WinConditions: " ",
        Attendance: 5890,
        RoundID: "semi",
        MatchID: 1559,
        HomeTeamInitials: "TCH",
        AwayTeamInitials: "YUG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.61063,
          -33.46472
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "13 Jun 1962 - 14:30 ",
        Stage: "Semi-finals",
        Stadium: "Nacional",
        City: "Santiago De Chile ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 4,
        AwayTeamGoals: 2,
        AwayTeamName: "Chile",
        WinConditions: " ",
        Attendance: 76594,
        RoundID: "semi",
        MatchID: 1458,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "CHI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.61063,
          -33.46472
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "16 Jun 1962 - 14:30 ",
        Stage: "Match for third place",
        Stadium: "Nacional",
        City: "Santiago De Chile ",
        HomeTeamName: "Chile",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Yugoslavia",
        WinConditions: " ",
        Attendance: 66697,
        RoundID: "third",
        MatchID: 1475,
        HomeTeamInitials: "CHI",
        AwayTeamInitials: "YUG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -70.61063,
          -33.46472
        ]
      },
      properties: {
        Year: 1962,
        Datetime: "17 Jun 1962 - 14:30 ",
        Stage: "Final",
        Stadium: "Nacional",
        City: "Santiago De Chile ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Czechoslovakia",
        WinConditions: " ",
        Attendance: 68679,
        RoundID: "final",
        MatchID: 1463,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "TCH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.28026,
          51.55613
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "11 Jul 1966 - 19:30 ",
        Stage: "Group 1",
        Stadium: "Wembley Stadium",
        City: "London ",
        HomeTeamName: "England",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 87148,
        RoundID: "group",
        MatchID: 1636,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.50053,
          53.4113
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "12 Jul 1966 - 19:30 ",
        Stage: "Group 2",
        Stadium: "Hillsborough",
        City: "Sheffield ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 5,
        AwayTeamGoals: 0,
        AwayTeamName: "Switzerland",
        WinConditions: " ",
        Attendance: 36127,
        RoundID: "group",
        MatchID: 1656,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "SUI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -2.96638,
          53.43868
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "12 Jul 1966 - 19:30 ",
        Stage: "Group 3",
        Stadium: "Goodison Park",
        City: "Liverpool ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Bulgaria",
        WinConditions: " ",
        Attendance: 47308,
        RoundID: "group",
        MatchID: 1596,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "BUL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.24685,
          54.56412
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "12 Jul 1966 - 19:30 ",
        Stage: "Group 4",
        Stadium: "Ayresome Park",
        City: "Middlesbrough ",
        HomeTeamName: "Soviet Union",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Korea DPR",
        WinConditions: " ",
        Attendance: 23006,
        RoundID: "group",
        MatchID: 1710,
        HomeTeamInitials: "URS",
        AwayTeamInitials: "PRK"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.28026,
          51.55613
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "13 Jul 1966 - 19:30 ",
        Stage: "Group 1",
        Stadium: "Wembley Stadium",
        City: "London ",
        HomeTeamName: "France",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 69237,
        RoundID: "group",
        MatchID: 1650,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -2.29161,
          53.46292
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "13 Jul 1966 - 19:30 ",
        Stage: "Group 3",
        Stadium: "Old Trafford Stadium",
        City: "Manchester ",
        HomeTeamName: "Portugal",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Hungary",
        WinConditions: " ",
        Attendance: 29886,
        RoundID: "group",
        MatchID: 1675,
        HomeTeamInitials: "POR",
        AwayTeamInitials: "HUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.88508,
          52.50901
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "13 Jul 1966 - 19:30 ",
        Stage: "Group 2",
        Stadium: "Villa Park",
        City: "Birmingham ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 42738,
        RoundID: "group",
        MatchID: 1578,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.37551,
          54.92129
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "13 Jul 1966 - 19:30 ",
        Stage: "Group 4",
        Stadium: "Roker Park Ground",
        City: "Sunderland ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Chile",
        WinConditions: " ",
        Attendance: 27199,
        RoundID: "group",
        MatchID: 1608,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "CHI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.22751,
          51.5135
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "15 Jul 1966 - 19:30 ",
        Stage: "Group 1",
        Stadium: "White City",
        City: "London ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 45662,
        RoundID: "group",
        MatchID: 1653,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.50053,
          53.4113
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "15 Jul 1966 - 19:30 ",
        Stage: "Group 2",
        Stadium: "Hillsborough",
        City: "Sheffield ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Switzerland",
        WinConditions: " ",
        Attendance: 32028,
        RoundID: "group",
        MatchID: 1641,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "SUI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -2.96638,
          53.43868
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "15 Jul 1966 - 19:30 ",
        Stage: "Group 3",
        Stadium: "Goodison Park",
        City: "Liverpool ",
        HomeTeamName: "Hungary",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 51387,
        RoundID: "group",
        MatchID: 1597,
        HomeTeamInitials: "HUN",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.24685,
          54.56412
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "15 Jul 1966 - 19:30 ",
        Stage: "Group 4",
        Stadium: "Ayresome Park",
        City: "Middlesbrough ",
        HomeTeamName: "Korea DPR",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Chile",
        WinConditions: " ",
        Attendance: 13792,
        RoundID: "group",
        MatchID: 1609,
        HomeTeamInitials: "PRK",
        AwayTeamInitials: "CHI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -2.29161,
          53.46292
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "16 Jul 1966 - 15:00 ",
        Stage: "Group 3",
        Stadium: "Old Trafford Stadium",
        City: "Manchester ",
        HomeTeamName: "Portugal",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Bulgaria",
        WinConditions: " ",
        Attendance: 25438,
        RoundID: "group",
        MatchID: 1602,
        HomeTeamInitials: "POR",
        AwayTeamInitials: "BUL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.88508,
          52.50901
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "16 Jul 1966 - 15:00 ",
        Stage: "Group 2",
        Stadium: "Villa Park",
        City: "Birmingham ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Argentina",
        WinConditions: " ",
        Attendance: 46587,
        RoundID: "group",
        MatchID: 1579,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.37551,
          54.92129
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "16 Jul 1966 - 15:00 ",
        Stage: "Group 4",
        Stadium: "Roker Park Ground",
        City: "Sunderland ",
        HomeTeamName: "Soviet Union",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 27793,
        RoundID: "group",
        MatchID: 1682,
        HomeTeamInitials: "URS",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.28026,
          51.55613
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "16 Jul 1966 - 19:30 ",
        Stage: "Group 1",
        Stadium: "Wembley Stadium",
        City: "London ",
        HomeTeamName: "England",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 92570,
        RoundID: "group",
        MatchID: 1634,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.28026,
          51.55613
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "19 Jul 1966 - 16:30 ",
        Stage: "Group 1",
        Stadium: "Wembley Stadium",
        City: "London ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 61112,
        RoundID: "group",
        MatchID: 1689,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.50053,
          53.4113
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "19 Jul 1966 - 19:30 ",
        Stage: "Group 2",
        Stadium: "Hillsborough",
        City: "Sheffield ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Switzerland",
        WinConditions: " ",
        Attendance: 32127,
        RoundID: "group",
        MatchID: 1582,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "SUI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -2.96638,
          53.43868
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "19 Jul 1966 - 19:30 ",
        Stage: "Group 3",
        Stadium: "Goodison Park",
        City: "Liverpool ",
        HomeTeamName: "Portugal",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 58479,
        RoundID: "group",
        MatchID: 1598,
        HomeTeamInitials: "POR",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.24685,
          54.56412
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "19 Jul 1966 - 19:30 ",
        Stage: "Group 4",
        Stadium: "Ayresome Park",
        City: "Middlesbrough ",
        HomeTeamName: "Korea DPR",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 17829,
        RoundID: "group",
        MatchID: 1679,
        HomeTeamInitials: "PRK",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.28026,
          51.55613
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "20 Jul 1966 - 19:30 ",
        Stage: "Group 1",
        Stadium: "Wembley Stadium",
        City: "London ",
        HomeTeamName: "England",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 98270,
        RoundID: "group",
        MatchID: 1632,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -2.29161,
          53.46292
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "20 Jul 1966 - 19:30 ",
        Stage: "Group 3",
        Stadium: "Old Trafford Stadium",
        City: "Manchester ",
        HomeTeamName: "Hungary",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Bulgaria",
        WinConditions: " ",
        Attendance: 24129,
        RoundID: "group",
        MatchID: 1599,
        HomeTeamInitials: "HUN",
        AwayTeamInitials: "BUL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.88508,
          52.50901
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "20 Jul 1966 - 19:30 ",
        Stage: "Group 2",
        Stadium: "Villa Park",
        City: "Birmingham ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 42187,
        RoundID: "group",
        MatchID: 1637,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.37551,
          54.92129
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "20 Jul 1966 - 19:30 ",
        Stage: "Group 4",
        Stadium: "Roker Park Ground",
        City: "Sunderland ",
        HomeTeamName: "Soviet Union",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Chile",
        WinConditions: " ",
        Attendance: 16027,
        RoundID: "group",
        MatchID: 1610,
        HomeTeamInitials: "URS",
        AwayTeamInitials: "CHI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.28026,
          51.55613
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "23 Jul 1966 - 15:00 ",
        Stage: "Quarter-finals",
        Stadium: "Wembley Stadium",
        City: "London ",
        HomeTeamName: "England",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Argentina",
        WinConditions: " ",
        Attendance: 90584,
        RoundID: "quart",
        MatchID: 1577,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.50053,
          53.4113
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "23 Jul 1966 - 15:00 ",
        Stage: "Quarter-finals",
        Stadium: "Hillsborough",
        City: "Sheffield ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 4,
        AwayTeamGoals: 0,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 40007,
        RoundID: "quart",
        MatchID: 1660,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.37551,
          54.92129
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "23 Jul 1966 - 15:00 ",
        Stage: "Quarter-finals",
        Stadium: "Roker Park Ground",
        City: "Sunderland ",
        HomeTeamName: "Soviet Union",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Hungary",
        WinConditions: " ",
        Attendance: 26844,
        RoundID: "quart",
        MatchID: 1676,
        HomeTeamInitials: "URS",
        AwayTeamInitials: "HUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -2.96638,
          53.43868
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "23 Jul 1966 - 15:00 ",
        Stage: "Quarter-finals",
        Stadium: "Goodison Park",
        City: "Liverpool ",
        HomeTeamName: "Portugal",
        HomeTeamGoals: 5,
        AwayTeamGoals: 3,
        AwayTeamName: "Korea DPR",
        WinConditions: " ",
        Attendance: 40248,
        RoundID: "quart",
        MatchID: 1702,
        HomeTeamInitials: "POR",
        AwayTeamInitials: "PRK"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -2.96638,
          53.43868
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "25 Jul 1966 - 19:30 ",
        Stage: "Semi-finals",
        Stadium: "Goodison Park",
        City: "Liverpool ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Soviet Union",
        WinConditions: " ",
        Attendance: 38273,
        RoundID: "semi",
        MatchID: 1659,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "URS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.28026,
          51.55613
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "26 Jul 1966 - 19:30 ",
        Stage: "Semi-finals",
        Stadium: "Wembley Stadium",
        City: "London ",
        HomeTeamName: "England",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Portugal",
        WinConditions: " ",
        Attendance: 94493,
        RoundID: "semi",
        MatchID: 1635,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "POR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.28026,
          51.55613
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "28 Jul 1966 - 19:30 ",
        Stage: "Match for third place",
        Stadium: "Wembley Stadium",
        City: "London ",
        HomeTeamName: "Portugal",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Soviet Union",
        WinConditions: " ",
        Attendance: 87696,
        RoundID: "third",
        MatchID: 1709,
        HomeTeamInitials: "POR",
        AwayTeamInitials: "URS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.28026,
          51.55613
        ]
      },
      properties: {
        Year: 1966,
        Datetime: "30 Jul 1966 - 15:00 ",
        Stage: "Final",
        Stadium: "Wembley Stadium",
        City: "London ",
        HomeTeamName: "England",
        HomeTeamGoals: 4,
        AwayTeamGoals: 2,
        AwayTeamName: "Germany FR",
        WinConditions: "win after extra time ",
        Attendance: 96924,
        RoundID: "final",
        MatchID: 1633,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "FRG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.15059,
          19.30279
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "31 May 1970 - 12:00 ",
        Stage: "Group 1",
        Stadium: "Estadio Azteca",
        City: "Mexico City ",
        HomeTeamName: "Mexico",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Soviet Union",
        WinConditions: " ",
        Attendance: 107160,
        RoundID: "group",
        MatchID: 1902,
        HomeTeamInitials: "MEX",
        AwayTeamInitials: "URS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -98.16458,
          19.07771
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "02 Jun 1970 - 16:00 ",
        Stage: "Group 2",
        Stadium: "Cuauhtemoc",
        City: "Puebla ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Israel",
        WinConditions: " ",
        Attendance: 20654,
        RoundID: "group",
        MatchID: 1881,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "ISR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -101.65785,
          21.11523
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "02 Jun 1970 - 16:00 ",
        Stage: "Group 4",
        Stadium: "Estadio Leon",
        City: "Leon ",
        HomeTeamName: "Peru",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Bulgaria",
        WinConditions: " ",
        Attendance: 13765,
        RoundID: "group",
        MatchID: 1780,
        HomeTeamInitials: "PER",
        AwayTeamInitials: "BUL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -103.32818,
          20.70479
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "02 Jun 1970 - 16:00 ",
        Stage: "Group 3",
        Stadium: "Jalisco",
        City: "Guadalajara ",
        HomeTeamName: "England",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Romania",
        WinConditions: " ",
        Attendance: 50560,
        RoundID: "group",
        MatchID: 1812,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "ROU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.66665,
          19.28713
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "03 Jun 1970 - 16:00 ",
        Stage: "Group 2",
        Stadium: "Luis Dosal",
        City: "Toluca ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Sweden",
        WinConditions: " ",
        Attendance: 13433,
        RoundID: "group",
        MatchID: 1883,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "SWE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -101.65785,
          21.11523
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "03 Jun 1970 - 16:00 ",
        Stage: "Group 4",
        Stadium: "Estadio Leon",
        City: "Leon ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Morocco",
        WinConditions: " ",
        Attendance: 12942,
        RoundID: "group",
        MatchID: 1839,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "MAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -103.32818,
          20.70479
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "03 Jun 1970 - 16:00 ",
        Stage: "Group 3",
        Stadium: "Jalisco",
        City: "Guadalajara ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "Czechoslovakia",
        WinConditions: " ",
        Attendance: 52897,
        RoundID: "group",
        MatchID: 1770,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "TCH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.15059,
          19.30279
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "03 Jun 1970 - 16:00 ",
        Stage: "Group 1",
        Stadium: "Estadio Azteca",
        City: "Mexico City ",
        HomeTeamName: "Belgium",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "El Salvador",
        WinConditions: " ",
        Attendance: 92205,
        RoundID: "group",
        MatchID: 1747,
        HomeTeamInitials: "BEL",
        AwayTeamInitials: "SLV"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -98.16458,
          19.07771
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "06 Jun 1970 - 16:00 ",
        Stage: "Group 2",
        Stadium: "Cuauhtemoc",
        City: "Puebla ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 29968,
        RoundID: "group",
        MatchID: 1884,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -101.65785,
          21.11523
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "06 Jun 1970 - 16:00 ",
        Stage: "Group 4",
        Stadium: "Estadio Leon",
        City: "Leon ",
        HomeTeamName: "Peru",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Morocco",
        WinConditions: " ",
        Attendance: 13537,
        RoundID: "group",
        MatchID: 1893,
        HomeTeamInitials: "PER",
        AwayTeamInitials: "MAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -103.32818,
          20.70479
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "06 Jun 1970 - 16:00 ",
        Stage: "Group 3",
        Stadium: "Jalisco",
        City: "Guadalajara ",
        HomeTeamName: "Romania",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Czechoslovakia",
        WinConditions: " ",
        Attendance: 56818,
        RoundID: "group",
        MatchID: 1919,
        HomeTeamInitials: "ROU",
        AwayTeamInitials: "TCH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.15059,
          19.30279
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "06 Jun 1970 - 16:00 ",
        Stage: "Group 1",
        Stadium: "Estadio Azteca",
        City: "Mexico City ",
        HomeTeamName: "Soviet Union",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "Belgium",
        WinConditions: " ",
        Attendance: 95261,
        RoundID: "group",
        MatchID: 1753,
        HomeTeamInitials: "URS",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.66665,
          19.28713
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "07 Jun 1970 - 12:00 ",
        Stage: "Group 2",
        Stadium: "Luis Dosal",
        City: "Toluca ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Israel",
        WinConditions: " ",
        Attendance: 9624,
        RoundID: "group",
        MatchID: 1880,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "ISR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -101.65785,
          21.11523
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "07 Jun 1970 - 12:00 ",
        Stage: "Group 4",
        Stadium: "Estadio Leon",
        City: "Leon ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 5,
        AwayTeamGoals: 2,
        AwayTeamName: "Bulgaria",
        WinConditions: " ",
        Attendance: 12710,
        RoundID: "group",
        MatchID: 1774,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "BUL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -103.32818,
          20.70479
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "07 Jun 1970 - 12:00 ",
        Stage: "Group 3",
        Stadium: "Jalisco",
        City: "Guadalajara ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 66843,
        RoundID: "group",
        MatchID: 1764,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.15059,
          19.30279
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "07 Jun 1970 - 12:00 ",
        Stage: "Group 1",
        Stadium: "Estadio Azteca",
        City: "Mexico City ",
        HomeTeamName: "Mexico",
        HomeTeamGoals: 4,
        AwayTeamGoals: 0,
        AwayTeamName: "El Salvador",
        WinConditions: " ",
        Attendance: 103058,
        RoundID: "group",
        MatchID: 1820,
        HomeTeamInitials: "MEX",
        AwayTeamInitials: "SLV"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -98.16458,
          19.07771
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "10 Jun 1970 - 16:00 ",
        Stage: "Group 2",
        Stadium: "Cuauhtemoc",
        City: "Puebla ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 18163,
        RoundID: "group",
        MatchID: 1922,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -101.65785,
          21.11523
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "10 Jun 1970 - 16:00 ",
        Stage: "Group 4",
        Stadium: "Estadio Leon",
        City: "Leon ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Peru",
        WinConditions: " ",
        Attendance: 17875,
        RoundID: "group",
        MatchID: 1840,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "PER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -103.32818,
          20.70479
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "10 Jun 1970 - 16:00 ",
        Stage: "Group 3",
        Stadium: "Jalisco",
        City: "Guadalajara ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Romania",
        WinConditions: " ",
        Attendance: 50804,
        RoundID: "group",
        MatchID: 1769,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "ROU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.15059,
          19.30279
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "10 Jun 1970 - 16:00 ",
        Stage: "Group 1",
        Stadium: "Estadio Azteca",
        City: "Mexico City ",
        HomeTeamName: "Soviet Union",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "El Salvador",
        WinConditions: " ",
        Attendance: 89979,
        RoundID: "group",
        MatchID: 1823,
        HomeTeamInitials: "URS",
        AwayTeamInitials: "SLV"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.66665,
          19.28713
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "11 Jun 1970 - 16:00 ",
        Stage: "Group 2",
        Stadium: "Luis Dosal",
        City: "Toluca ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Israel",
        WinConditions: " ",
        Attendance: 9890,
        RoundID: "group",
        MatchID: 1877,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "ISR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -101.65785,
          21.11523
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "11 Jun 1970 - 16:00 ",
        Stage: "Group 4",
        Stadium: "Estadio Leon",
        City: "Leon ",
        HomeTeamName: "Bulgaria",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Morocco",
        WinConditions: " ",
        Attendance: 12299,
        RoundID: "group",
        MatchID: 1779,
        HomeTeamInitials: "BUL",
        AwayTeamInitials: "MAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -103.32818,
          20.70479
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "11 Jun 1970 - 16:00 ",
        Stage: "Group 3",
        Stadium: "Jalisco",
        City: "Guadalajara ",
        HomeTeamName: "England",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Czechoslovakia",
        WinConditions: " ",
        Attendance: 49292,
        RoundID: "group",
        MatchID: 1813,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "TCH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.15059,
          19.30279
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "11 Jun 1970 - 16:00 ",
        Stage: "Group 1",
        Stadium: "Estadio Azteca",
        City: "Mexico City ",
        HomeTeamName: "Mexico",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Belgium",
        WinConditions: " ",
        Attendance: 108192,
        RoundID: "group",
        MatchID: 1752,
        HomeTeamInitials: "MEX",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.66665,
          19.28713
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "14 Jun 1970 - 12:00 ",
        Stage: "Quarter-finals",
        Stadium: "Luis Dosal",
        City: "Toluca ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 26851,
        RoundID: "quart",
        MatchID: 1882,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -101.65785,
          21.11523
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "14 Jun 1970 - 12:00 ",
        Stage: "Quarter-finals",
        Stadium: "Estadio Leon",
        City: "Leon ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "England",
        WinConditions: "win after extra time ",
        Attendance: 23357,
        RoundID: "quart",
        MatchID: 1811,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -103.32818,
          20.70479
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "14 Jun 1970 - 12:00 ",
        Stage: "Quarter-finals",
        Stadium: "Jalisco",
        City: "Guadalajara ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 4,
        AwayTeamGoals: 2,
        AwayTeamName: "Peru",
        WinConditions: " ",
        Attendance: 54233,
        RoundID: "quart",
        MatchID: 1768,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "PER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.15059,
          19.30279
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "14 Jun 1970 - 12:00 ",
        Stage: "Quarter-finals",
        Stadium: "Estadio Azteca",
        City: "Mexico City ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Soviet Union",
        WinConditions: "win after extra time ",
        Attendance: 26085,
        RoundID: "quart",
        MatchID: 1925,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "URS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -103.32818,
          20.70479
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "17 Jun 1970 - 16:00 ",
        Stage: "Semi-finals",
        Stadium: "Jalisco",
        City: "Guadalajara ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 51261,
        RoundID: "semi",
        MatchID: 1771,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.15059,
          19.30279
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "17 June 1970 - 16:00 ",
        Stage: "Semi-finals",
        Stadium: "Estadio Azteca",
        City: "Mexico City ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 4,
        AwayTeamGoals: 3,
        AwayTeamName: "Germany FR",
        WinConditions: "win after extra time ",
        Attendance: 102444,
        RoundID: "semi",
        MatchID: 1838,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "FRG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.15059,
          19.30279
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "20 Jun 1970 - 16:00 ",
        Stage: "Match for third place",
        Stadium: "Estadio Azteca",
        City: "Mexico City ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 104403,
        RoundID: "third",
        MatchID: 1843,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.15059,
          19.30279
        ]
      },
      properties: {
        Year: 1970,
        Datetime: "21 Jun 1970 - 12:00 ",
        Stage: "Final",
        Stadium: "Estadio Azteca",
        City: "Mexico City ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 107412,
        RoundID: "final",
        MatchID: 1765,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.64543,
          50.06852
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "13 Jun 1974 - 17:00 ",
        Stage: "Group 2",
        Stadium: "Waldstadion",
        City: "Frankfurt/Main ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Yugoslavia",
        WinConditions: " ",
        Attendance: 62000,
        RoundID: "group",
        MatchID: 1986,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "YUG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.23935,
          52.51464
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "14 Jun 1974 - 16:00 ",
        Stage: "Group 1",
        Stadium: "Olympiastadion",
        City: "Berlin West ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Chile",
        WinConditions: " ",
        Attendance: 81100,
        RoundID: "group",
        MatchID: 2003,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "CHI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.89863,
          53.58706
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "14 Jun 1974 - 19:30 ",
        Stage: "Group 1",
        Stadium: "Volksparkstadion",
        City: "Hamburg ",
        HomeTeamName: "German DR",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Australia",
        WinConditions: " ",
        Attendance: 17000,
        RoundID: "group",
        MatchID: 1955,
        HomeTeamInitials: "GDR",
        AwayTeamInitials: "AUS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.4519,
          51.4924
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "14 Jun 1974 - 19:30 ",
        Stage: "Group 2",
        Stadium: "Westfalenstadion",
        City: "Dortmund ",
        HomeTeamName: "Democratic Republic of the Congo",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Scotland",
        WinConditions: " ",
        Attendance: 27000,
        RoundID: "group",
        MatchID: 2176,
        HomeTeamInitials: "ZAI",
        AwayTeamInitials: "SCO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.72885,
          52.3601
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "15 Jun 1974 - 16:00 ",
        Stage: "Group 3",
        Stadium: "Niedersachsenstadion",
        City: "Hanover ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Netherlands",
        WinConditions: " ",
        Attendance: 55100,
        RoundID: "group",
        MatchID: 2098,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "NED"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          6.73308,
          51.26147
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "15 Jun 1974 - 16:00 ",
        Stage: "Group 3",
        Stadium: "Rheinstadion",
        City: "Dusseldorf",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Bulgaria",
        WinConditions: " ",
        Attendance: 23800,
        RoundID: "group",
        MatchID: 1995,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "BUL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.23935,
          52.51464
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "15 Jun 1974 - 18:00 ",
        Stage: "Group 4",
        Stadium: "Olympiastadion",
        City: "Munich ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Haiti",
        WinConditions: " ",
        Attendance: 53000,
        RoundID: "group",
        MatchID: 2083,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "HAI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.23191,
          48.79209
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "15 Jun 1974 - 18:00 ",
        Stage: "Group 4",
        Stadium: "Neckarstadion",
        City: "Stuttgart ",
        HomeTeamName: "Poland",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Argentina",
        WinConditions: " ",
        Attendance: 32700,
        RoundID: "group",
        MatchID: 1952,
        HomeTeamInitials: "POL",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.89863,
          53.58706
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "18 Jun 1974 - 16:00 ",
        Stage: "Group 1",
        Stadium: "Volksparkstadion",
        City: "Hamburg ",
        HomeTeamName: "Australia",
        HomeTeamGoals: 0,
        AwayTeamGoals: 3,
        AwayTeamName: "Germany FR",
        WinConditions: " ",
        Attendance: 53300,
        RoundID: "group",
        MatchID: 1954,
        HomeTeamInitials: "AUS",
        AwayTeamInitials: "FRG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.64543,
          50.06852
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "18 Jun 1974 - 19:30 ",
        Stage: "Group 2",
        Stadium: "Waldstadion",
        City: "Frankfurt/Main ",
        HomeTeamName: "Scotland",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 62000,
        RoundID: "group",
        MatchID: 1985,
        HomeTeamInitials: "SCO",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.23935,
          52.51464
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "18 Jun 1974 - 19:30 ",
        Stage: "Group 1",
        Stadium: "Olympiastadion",
        City: "Berlin West ",
        HomeTeamName: "Chile",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "German DR",
        WinConditions: " ",
        Attendance: 28300,
        RoundID: "group",
        MatchID: 2004,
        HomeTeamInitials: "CHI",
        AwayTeamInitials: "GDR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.06734,
          51.55926
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "18 Jun 1974 - 19:30 ",
        Stage: "Group 2",
        Stadium: "Parkstadion",
        City: "Gelsenkirchen ",
        HomeTeamName: "Yugoslavia",
        HomeTeamGoals: 9,
        AwayTeamGoals: 0,
        AwayTeamName: "Democratic Republic of the Congo",
        WinConditions: " ",
        Attendance: 31700,
        RoundID: "group",
        MatchID: 2186,
        HomeTeamInitials: "YUG",
        AwayTeamInitials: "ZAI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.4519,
          51.4924
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "19 Jun 1974 - 19:30 ",
        Stage: "Group 3",
        Stadium: "Westfalenstadion",
        City: "Dortmund ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Sweden",
        WinConditions: " ",
        Attendance: 53700,
        RoundID: "group",
        MatchID: 2097,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "SWE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.72885,
          52.3601
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "19 Jun 1974 - 19:30 ",
        Stage: "Group 3",
        Stadium: "Niedersachsenstadion",
        City: "Hanover ",
        HomeTeamName: "Bulgaria",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 13400,
        RoundID: "group",
        MatchID: 1996,
        HomeTeamInitials: "BUL",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.23935,
          52.51464
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "19 Jun 1974 - 19:30 ",
        Stage: "Group 4",
        Stadium: "Olympiastadion",
        City: "Munich ",
        HomeTeamName: "Haiti",
        HomeTeamGoals: 0,
        AwayTeamGoals: 7,
        AwayTeamName: "Poland",
        WinConditions: " ",
        Attendance: 25300,
        RoundID: "group",
        MatchID: 2085,
        HomeTeamInitials: "HAI",
        AwayTeamInitials: "POL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.23191,
          48.79209
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "19 Jun 1974 - 19:30 ",
        Stage: "Group 4",
        Stadium: "Neckarstadion",
        City: "Stuttgart ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 70100,
        RoundID: "group",
        MatchID: 1949,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.64543,
          50.06852
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "22 Jun 1974 - 16:00 ",
        Stage: "Group 2",
        Stadium: "Waldstadion",
        City: "Frankfurt/Main ",
        HomeTeamName: "Scotland",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Yugoslavia",
        WinConditions: " ",
        Attendance: 56000,
        RoundID: "group",
        MatchID: 2175,
        HomeTeamInitials: "SCO",
        AwayTeamInitials: "YUG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.23935,
          52.51464
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "22 Jun 1974 - 16:00 ",
        Stage: "Group 1",
        Stadium: "Olympiastadion",
        City: "Berlin West ",
        HomeTeamName: "Australia",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Chile",
        WinConditions: " ",
        Attendance: 17400,
        RoundID: "group",
        MatchID: 1953,
        HomeTeamInitials: "AUS",
        AwayTeamInitials: "CHI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.06734,
          51.55926
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "22 Jun 1974 - 16:00 ",
        Stage: "Group 2",
        Stadium: "Parkstadion",
        City: "Gelsenkirchen ",
        HomeTeamName: "Democratic Republic of the Congo",
        HomeTeamGoals: 0,
        AwayTeamGoals: 3,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 36200,
        RoundID: "group",
        MatchID: 1987,
        HomeTeamInitials: "ZAI",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.89863,
          53.58706
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "22 June 1974 - 19:30 ",
        Stage: "Group 1",
        Stadium: "Volksparkstadion",
        City: "Hamburg ",
        HomeTeamName: "German DR",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Germany FR",
        WinConditions: " ",
        Attendance: 60200,
        RoundID: "group",
        MatchID: 2062,
        HomeTeamInitials: "GDR",
        AwayTeamInitials: "FRG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.4519,
          51.4924
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "23 Jun 1974 - 16:00 ",
        Stage: "Group 3",
        Stadium: "Westfalenstadion",
        City: "Dortmund ",
        HomeTeamName: "Bulgaria",
        HomeTeamGoals: 1,
        AwayTeamGoals: 4,
        AwayTeamName: "Netherlands",
        WinConditions: " ",
        Attendance: 53300,
        RoundID: "group",
        MatchID: 1990,
        HomeTeamInitials: "BUL",
        AwayTeamInitials: "NED"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.23935,
          52.51464
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "23 Jun 1974 - 16:00 ",
        Stage: "Group 4",
        Stadium: "Olympiastadion",
        City: "Munich ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "Haiti",
        WinConditions: " ",
        Attendance: 25900,
        RoundID: "group",
        MatchID: 1947,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "HAI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          6.73308,
          51.26147
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "23 Jun 1974 - 16:00 ",
        Stage: "Group 3",
        Stadium: "Rheinstadion",
        City: "Dusseldorf",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 28300,
        RoundID: "group",
        MatchID: 2181,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.23191,
          48.79209
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "23 Jun 1974 - 16:00 ",
        Stage: "Group 4",
        Stadium: "Neckarstadion",
        City: "Stuttgart ",
        HomeTeamName: "Poland",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 70100,
        RoundID: "group",
        MatchID: 2129,
        HomeTeamInitials: "POL",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          6.73308,
          51.26147
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "26 Jun 1974 - 16:00 ",
        Stage: "Group B",
        Stadium: "Rheinstadion",
        City: "Dusseldorf",
        HomeTeamName: "Yugoslavia",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Germany FR",
        WinConditions: " ",
        Attendance: 67385,
        RoundID: "reight",
        MatchID: 2066,
        HomeTeamInitials: "YUG",
        AwayTeamInitials: "FRG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.72885,
          52.3601
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "26 Jun 1974 - 19:30 ",
        Stage: "Group A",
        Stadium: "Niedersachsenstadion",
        City: "Hanover ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "German DR",
        WinConditions: " ",
        Attendance: 59863,
        RoundID: "reight",
        MatchID: 1982,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "GDR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.06734,
          51.55926
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "26 Jun 1974 - 19:30 ",
        Stage: "Group A",
        Stadium: "Parkstadion",
        City: "Gelsenkirchen ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 4,
        AwayTeamGoals: 0,
        AwayTeamName: "Argentina",
        WinConditions: " ",
        Attendance: 56548,
        RoundID: "reight",
        MatchID: 1948,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.23191,
          48.79209
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "26 Jun 1974 - 19:30 ",
        Stage: "Group B",
        Stadium: "Neckarstadion",
        City: "Stuttgart ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Poland",
        WinConditions: " ",
        Attendance: 44955,
        RoundID: "reight",
        MatchID: 2167,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "POL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.72885,
          52.3601
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "30 Jun 1974 - 16:00 ",
        Stage: "Group A",
        Stadium: "Niedersachsenstadion",
        City: "Hanover ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 39400,
        RoundID: "reight",
        MatchID: 1945,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.64543,
          50.06852
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "30 Jun 1974 - 16:00 ",
        Stage: "Group B",
        Stadium: "Waldstadion",
        City: "Frankfurt/Main ",
        HomeTeamName: "Poland",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Yugoslavia",
        WinConditions: " ",
        Attendance: 58000,
        RoundID: "reight",
        MatchID: 2170,
        HomeTeamInitials: "POL",
        AwayTeamInitials: "YUG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.06734,
          51.55926
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "30 Jun 1974 - 16:00 ",
        Stage: "Group A",
        Stadium: "Parkstadion",
        City: "Gelsenkirchen ",
        HomeTeamName: "German DR",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Netherlands",
        WinConditions: " ",
        Attendance: 68348,
        RoundID: "reight",
        MatchID: 2067,
        HomeTeamInitials: "GDR",
        AwayTeamInitials: "NED"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          6.73308,
          51.26147
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "30 Jun 1974 - 19:30 ",
        Stage: "Group B",
        Stadium: "Rheinstadion",
        City: "Dusseldorf",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 4,
        AwayTeamGoals: 2,
        AwayTeamName: "Sweden",
        WinConditions: " ",
        Attendance: 67800,
        RoundID: "reight",
        MatchID: 2065,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "SWE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.64543,
          50.06852
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "03 Jul 1974 - 17:00 ",
        Stage: "Group B",
        Stadium: "Waldstadion",
        City: "Frankfurt/Main ",
        HomeTeamName: "Poland",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Germany FR",
        WinConditions: " ",
        Attendance: 62000,
        RoundID: "reight",
        MatchID: 2064,
        HomeTeamInitials: "POL",
        AwayTeamInitials: "FRG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.4519,
          51.4924
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "03 Jul 1974 - 19:30 ",
        Stage: "Group A",
        Stadium: "Westfalenstadion",
        City: "Dortmund ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 53700,
        RoundID: "reight",
        MatchID: 1983,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.06734,
          51.55926
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "03 Jul 1974 - 19:30 ",
        Stage: "Group A",
        Stadium: "Parkstadion",
        City: "Gelsenkirchen ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "German DR",
        WinConditions: " ",
        Attendance: 54254,
        RoundID: "reight",
        MatchID: 1946,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "GDR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          6.73308,
          51.26147
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "03 Jul 1974 - 19:30 ",
        Stage: "Group B",
        Stadium: "Rheinstadion",
        City: "Dusseldorf",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Yugoslavia",
        WinConditions: " ",
        Attendance: 41300,
        RoundID: "reight",
        MatchID: 2182,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "YUG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.23935,
          52.51464
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "06 Jul 1974 - 16:00 ",
        Stage: "Match for third place",
        Stadium: "Olympiastadion",
        City: "Munich ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Poland",
        WinConditions: " ",
        Attendance: 77100,
        RoundID: "third",
        MatchID: 1984,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "POL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.23935,
          52.51464
        ]
      },
      properties: {
        Year: 1974,
        Datetime: "07 July 1974 - 16:00 ",
        Stage: "Final",
        Stadium: "Olympiastadion",
        City: "Munich ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Germany FR",
        WinConditions: " ",
        Attendance: 78200,
        RoundID: "final",
        MatchID: 2063,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "FRG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -58.44973,
          -34.54532
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "01 Jun 1978 - 15:00 ",
        Stage: "Group 2",
        Stadium: "El Monumental - Estadio Monumental Antonio Vespuci",
        City: "Buenos Aires ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Poland",
        WinConditions: " ",
        Attendance: 67579,
        RoundID: "group",
        MatchID: 2351,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "POL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -57.58233,
          -38.01794
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "02 Jun 1978 - 13:45 ",
        Stage: "Group 1",
        Stadium: "Estadio Jose Maria Minella",
        City: "Mar Del Plata ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 42373,
        RoundID: "group",
        MatchID: 2347,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -60.67456,
          -32.91399
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "02 Jun 1978 - 16:45 ",
        Stage: "Group 2",
        Stadium: "Arroyito - Estadio Dr. Lisandro de la Torre",
        City: "Rosario ",
        HomeTeamName: "Tunisia",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 17396,
        RoundID: "group",
        MatchID: 2433,
        HomeTeamInitials: "TUN",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -58.44973,
          -34.54532
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "02 Jun 1978 - 19:15 ",
        Stage: "Group 1",
        Stadium: "El Monumental - Estadio Monumental Antonio Vespuci",
        City: "Buenos Aires ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Hungary",
        WinConditions: " ",
        Attendance: 71615,
        RoundID: "group",
        MatchID: 2199,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "HUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -57.58233,
          -38.01794
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "03 Jun 1978 - 13:45 ",
        Stage: "Group 3",
        Stadium: "Estadio Jose Maria Minella",
        City: "Mar Del Plata ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 32569,
        RoundID: "group",
        MatchID: 2253,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -58.52071,
          -34.63537
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "03 Jun 1978 - 13:45 ",
        Stage: "Group 3",
        Stadium: "Jose Amalfitani",
        City: "Buenos Aires ",
        HomeTeamName: "Austria",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 40841,
        RoundID: "group",
        MatchID: 2216,
        HomeTeamInitials: "AUT",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -64.24624,
          -31.36895
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "03 Jun 1978 - 16:45 ",
        Stage: "Group 4",
        Stadium: "Estadio Olimpico Chateau Carreras",
        City: "Cordoba ",
        HomeTeamName: "Peru",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Scotland",
        WinConditions: " ",
        Attendance: 37927,
        RoundID: "group",
        MatchID: 2451,
        HomeTeamInitials: "PER",
        AwayTeamInitials: "SCO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -68.87999,
          -32.88956
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "03 Jun 1978 - 16:45 ",
        Stage: "Group 4",
        Stadium: "San Martin",
        City: "Mendoza ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "IR Iran",
        WinConditions: " ",
        Attendance: 33431,
        RoundID: "group",
        MatchID: 2388,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "IRN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -57.58233,
          -38.01794
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "06 Jun 1978 - 13:45 ",
        Stage: "Group 1",
        Stadium: "Estadio Jose Maria Minella",
        City: "Mar Del Plata ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Hungary",
        WinConditions: " ",
        Attendance: 26533,
        RoundID: "group",
        MatchID: 2396,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "HUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -60.67456,
          -32.91399
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "06 Jun 1978 - 16:45 ",
        Stage: "Group 2",
        Stadium: "Arroyito - Estadio Dr. Lisandro de la Torre",
        City: "Rosario ",
        HomeTeamName: "Poland",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Tunisia",
        WinConditions: " ",
        Attendance: 9624,
        RoundID: "group",
        MatchID: 2454,
        HomeTeamInitials: "POL",
        AwayTeamInitials: "TUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -64.24624,
          -31.36895
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "06 Jun 1978 - 16:45 ",
        Stage: "Group 2",
        Stadium: "Estadio Olimpico Chateau Carreras",
        City: "Cordoba ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 6,
        AwayTeamGoals: 0,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 35258,
        RoundID: "group",
        MatchID: 2350,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -58.44973,
          -34.54532
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "06 Jun 1978 - 19:15 ",
        Stage: "Group 1",
        Stadium: "El Monumental - Estadio Monumental Antonio Vespuci",
        City: "Buenos Aires ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 71666,
        RoundID: "group",
        MatchID: 2197,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -57.58233,
          -38.01794
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "07 Jun 1978 - 13:45 ",
        Stage: "Group 3",
        Stadium: "Estadio Jose Maria Minella",
        City: "Mar Del Plata ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 34771,
        RoundID: "group",
        MatchID: 2246,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -58.52071,
          -34.63537
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "07 Jun 1978 - 13:45 ",
        Stage: "Group 3",
        Stadium: "Jose Amalfitani",
        City: "Buenos Aires ",
        HomeTeamName: "Austria",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Sweden",
        WinConditions: " ",
        Attendance: 41424,
        RoundID: "group",
        MatchID: 2224,
        HomeTeamInitials: "AUT",
        AwayTeamInitials: "SWE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -64.24624,
          -31.36895
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "07 Jun 1978 - 16:45 ",
        Stage: "Group 4",
        Stadium: "Estadio Olimpico Chateau Carreras",
        City: "Cordoba ",
        HomeTeamName: "Scotland",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "IR Iran",
        WinConditions: " ",
        Attendance: 7938,
        RoundID: "group",
        MatchID: 2408,
        HomeTeamInitials: "SCO",
        AwayTeamInitials: "IRN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -68.87999,
          -32.88956
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "07 Jun 1978 - 16:45 ",
        Stage: "Group 4",
        Stadium: "San Martin",
        City: "Mendoza ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Peru",
        WinConditions: " ",
        Attendance: 28125,
        RoundID: "group",
        MatchID: 2394,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "PER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -57.58233,
          -38.01794
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "10 Jun 1978 - 15:10 ",
        Stage: "Group 1",
        Stadium: "Estadio Jose Maria Minella",
        City: "Mar Del Plata ",
        HomeTeamName: "France",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Hungary",
        WinConditions: " ",
        Attendance: 23127,
        RoundID: "group",
        MatchID: 2344,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "HUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -60.67456,
          -32.91399
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "10 Jun 1978 - 16:45 ",
        Stage: "Group 2",
        Stadium: "Arroyito - Estadio Dr. Lisandro de la Torre",
        City: "Rosario ",
        HomeTeamName: "Poland",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 22651,
        RoundID: "group",
        MatchID: 2431,
        HomeTeamInitials: "POL",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -64.24624,
          -31.36895
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "10 Jun 1978 - 16:45 ",
        Stage: "Group 2",
        Stadium: "Estadio Olimpico Chateau Carreras",
        City: "Cordoba ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Tunisia",
        WinConditions: " ",
        Attendance: 30667,
        RoundID: "group",
        MatchID: 2352,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "TUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -58.44973,
          -34.54532
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "10 Jun 1978 - 19:15 ",
        Stage: "Group 1",
        Stadium: "El Monumental - Estadio Monumental Antonio Vespuci",
        City: "Buenos Aires ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Argentina",
        WinConditions: " ",
        Attendance: 71712,
        RoundID: "group",
        MatchID: 2200,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -57.58233,
          -38.01794
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "11 Jun 1978 - 13:45 ",
        Stage: "Group 3",
        Stadium: "Estadio Jose Maria Minella",
        City: "Mar Del Plata ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Austria",
        WinConditions: " ",
        Attendance: 35221,
        RoundID: "group",
        MatchID: 2215,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "AUT"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -58.52071,
          -34.63537
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "11 Jun 1978 - 13:45 ",
        Stage: "Group 3",
        Stadium: "Jose Amalfitani",
        City: "Buenos Aires ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Sweden",
        WinConditions: " ",
        Attendance: 42132,
        RoundID: "group",
        MatchID: 2337,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "SWE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -64.24624,
          -31.36895
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "11 Jun 1978 - 16:45 ",
        Stage: "Group 4",
        Stadium: "Estadio Olimpico Chateau Carreras",
        City: "Cordoba ",
        HomeTeamName: "Peru",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "Iran",
        WinConditions: " ",
        Attendance: 21262,
        RoundID: "group",
        MatchID: 2405,
        HomeTeamInitials: "PER",
        AwayTeamInitials: "IRN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -68.87999,
          -32.88956
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "11 Jun 1978 - 16:45 ",
        Stage: "Group 4",
        Stadium: "San Martin",
        City: "Mendoza ",
        HomeTeamName: "Scotland",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Netherlands",
        WinConditions: " ",
        Attendance: 35130,
        RoundID: "group",
        MatchID: 2395,
        HomeTeamInitials: "SCO",
        AwayTeamInitials: "NED"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -58.44973,
          -34.54532
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "14 Jun 1978 - 13:45 ",
        Stage: "Group A",
        Stadium: "El Monumental - Estadio Monumental Antonio Vespuci",
        City: "Buenos Aires ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 67547,
        RoundID: "reight",
        MatchID: 2349,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -64.24624,
          -31.36895
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "14 Jun 1978 - 13:45 ",
        Stage: "Group A",
        Stadium: "Estadio Olimpico Chateau Carreras",
        City: "Cordoba ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 5,
        AwayTeamGoals: 1,
        AwayTeamName: "Austria",
        WinConditions: " ",
        Attendance: 25050,
        RoundID: "reight",
        MatchID: 2220,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "AUT"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -68.87999,
          -32.88956
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "14 Jun 1978 - 16:45 ",
        Stage: "Group B",
        Stadium: "San Martin",
        City: "Mendoza ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Peru",
        WinConditions: " ",
        Attendance: 31278,
        RoundID: "reight",
        MatchID: 2251,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "PER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -60.67456,
          -32.91399
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "14 Jun 1978 - 19:15 ",
        Stage: "Group B",
        Stadium: "Arroyito - Estadio Dr. Lisandro de la Torre",
        City: "Rosario ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Poland",
        WinConditions: " ",
        Attendance: 37091,
        RoundID: "reight",
        MatchID: 2202,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "POL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -68.87999,
          -32.88956
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "18 Jun 1978 - 13:45 ",
        Stage: "Group B",
        Stadium: "San Martin",
        City: "Mendoza ",
        HomeTeamName: "Poland",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Peru",
        WinConditions: " ",
        Attendance: 35288,
        RoundID: "reight",
        MatchID: 2450,
        HomeTeamInitials: "POL",
        AwayTeamInitials: "PER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -58.44973,
          -34.54532
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "18 Jun 1978 - 16:45 ",
        Stage: "Group A",
        Stadium: "El Monumental - Estadio Monumental Antonio Vespuci",
        City: "Buenos Aires ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Austria",
        WinConditions: " ",
        Attendance: 66695,
        RoundID: "reight",
        MatchID: 2221,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "AUT"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -64.24624,
          -31.36895
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "18 Jun 1978 - 16:45 ",
        Stage: "Group A",
        Stadium: "Estadio Olimpico Chateau Carreras",
        City: "Cordoba ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Netherlands",
        WinConditions: " ",
        Attendance: 40750,
        RoundID: "reight",
        MatchID: 2348,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "NED"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -60.67456,
          -32.91399
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "18 Jun 1978 - 19:15 ",
        Stage: "Group B",
        Stadium: "Arroyito - Estadio Dr. Lisandro de la Torre",
        City: "Rosario ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 37326,
        RoundID: "reight",
        MatchID: 2196,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -58.44973,
          -34.54532
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "21 Jun 1978 - 13:45 ",
        Stage: "Group A",
        Stadium: "El Monumental - Estadio Monumental Antonio Vespuci",
        City: "Buenos Aires ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 67433,
        RoundID: "reight",
        MatchID: 2391,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -64.24624,
          -31.36895
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "21 Jun 1978 - 13:45 ",
        Stage: "Group A",
        Stadium: "Estadio Olimpico Chateau Carreras",
        City: "Cordoba ",
        HomeTeamName: "Austria",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Germany FR",
        WinConditions: " ",
        Attendance: 38318,
        RoundID: "reight",
        MatchID: 2217,
        HomeTeamInitials: "AUT",
        AwayTeamInitials: "FRG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -68.87999,
          -32.88956
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "21 Jun 1978 - 16:45 ",
        Stage: "Group B",
        Stadium: "San Martin",
        City: "Mendoza ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Poland",
        WinConditions: " ",
        Attendance: 39586,
        RoundID: "reight",
        MatchID: 2252,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "POL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -60.67456,
          -32.91399
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "21 Jun 1978 - 19:15 ",
        Stage: "Group B",
        Stadium: "Arroyito - Estadio Dr. Lisandro de la Torre",
        City: "Rosario ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 6,
        AwayTeamGoals: 0,
        AwayTeamName: "Peru",
        WinConditions: " ",
        Attendance: 37315,
        RoundID: "reight",
        MatchID: 2201,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "PER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -58.44973,
          -34.54532
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "24 Jun 1978 - 15:00 ",
        Stage: "Match for third place",
        Stadium: "El Monumental - Estadio Monumental Antonio Vespuci",
        City: "Buenos Aires ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 69659,
        RoundID: "third",
        MatchID: 2247,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -58.44973,
          -34.54532
        ]
      },
      properties: {
        Year: 1978,
        Datetime: "25 Jun 1978 - 15:00 ",
        Stage: "Final",
        Stadium: "El Monumental - Estadio Monumental Antonio Vespuci",
        City: "Buenos Aires ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Netherlands",
        WinConditions: "win after extra time ",
        Attendance: 71483,
        RoundID: "final",
        MatchID: 2198,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "NED"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.1229,
          41.38079
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "13 Jun 1982 - 20:00 ",
        Stage: "Group 3",
        Stadium: "Camp Nou",
        City: "Barcelona ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Belgium",
        WinConditions: " ",
        Attendance: 95000,
        RoundID: "group",
        MatchID: 749,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -8.7399,
          42.21212
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "14 Jun 1982 - 17:15 ",
        Stage: "Group 1",
        Stadium: "Estadio de Balaidos",
        City: "Vigo ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Poland",
        WinConditions: " ",
        Attendance: 33000,
        RoundID: "group",
        MatchID: 995,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "POL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -5.97061,
          37.38396
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "14 Jun 1982 - 21:00 ",
        Stage: "Group 6",
        Stadium: "Ramon Sanchez Pizjuan",
        City: "Seville ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Soviet Union",
        WinConditions: " ",
        Attendance: 68000,
        RoundID: "group",
        MatchID: 791,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "URS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -8.41752,
          43.36863
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "15 Jun 1982 - 17:15 ",
        Stage: "Group 1",
        Stadium: "Riazor",
        City: "La Coruna",
        HomeTeamName: "Peru",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Cameroon",
        WinConditions: " ",
        Attendance: 11000,
        RoundID: "group",
        MatchID: 833,
        HomeTeamInitials: "PER",
        AwayTeamInitials: "CMR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.66326,
          38.26703
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "15 Jun 1982 - 21:00 ",
        Stage: "Group 3",
        Stadium: "Nuevo Estadio",
        City: "Elche ",
        HomeTeamName: "Hungary",
        HomeTeamGoals: 10,
        AwayTeamGoals: 1,
        AwayTeamName: "El Salvador",
        WinConditions: " ",
        Attendance: 23000,
        RoundID: "group",
        MatchID: 896,
        HomeTeamInitials: "HUN",
        AwayTeamInitials: "SLV"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -4.42658,
          36.7343
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "15 Jun 1982 - 21:00 ",
        Stage: "Group 6",
        Stadium: "La Rosaleda",
        City: "Malaga ",
        HomeTeamName: "Scotland",
        HomeTeamGoals: 5,
        AwayTeamGoals: 2,
        AwayTeamName: "New Zealand",
        WinConditions: " ",
        Attendance: 36000,
        RoundID: "group",
        MatchID: 1051,
        HomeTeamInitials: "SCO",
        AwayTeamInitials: "NZL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -5.63742,
          43.53597
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "16 Jun 1982 - 17:15 ",
        Stage: "Group 2",
        Stadium: "El Molinon",
        City: "Gijon ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Algeria",
        WinConditions: " ",
        Attendance: 42000,
        RoundID: "group",
        MatchID: 741,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "ALG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -2.94928,
          43.26405
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "16 Jun 1982 - 17:15 ",
        Stage: "Group 4",
        Stadium: "San Mames",
        City: "Bilbao ",
        HomeTeamName: "England",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 44172,
        RoundID: "group",
        MatchID: 878,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.35831,
          39.47458
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "16 Jun 1982 - 21:00 ",
        Stage: "Group 5",
        Stadium: "Luis Casanova",
        City: "Valencia ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Honduras",
        WinConditions: " ",
        Attendance: 49562,
        RoundID: "group",
        MatchID: 901,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "HON"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -5.87017,
          43.36067
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "17 Jun 1982 - 17:15 ",
        Stage: "Group 2",
        Stadium: "Carlos Tartiere",
        City: "Oviedo ",
        HomeTeamName: "Chile",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Austria",
        WinConditions: " ",
        Attendance: 22500,
        RoundID: "group",
        MatchID: 764,
        HomeTeamInitials: "CHI",
        AwayTeamInitials: "AUT"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -4.761,
          41.64444
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "17 Jun 1982 - 17:45 ",
        Stage: "Group 4",
        Stadium: "Jose Zorrilla",
        City: "Valladolid ",
        HomeTeamName: "Czechoslovakia",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Kuwait",
        WinConditions: " ",
        Attendance: 25000,
        RoundID: "group",
        MatchID: 1012,
        HomeTeamInitials: "TCH",
        AwayTeamInitials: "KUW"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.90174,
          41.63635
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "17 Jun 1982 - 21:00 ",
        Stage: "Group 5",
        Stadium: "La Romareda",
        City: "Zaragoza ",
        HomeTeamName: "Yugoslavia",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Northern Ireland",
        WinConditions: " ",
        Attendance: 25000,
        RoundID: "group",
        MatchID: 1044,
        HomeTeamInitials: "YUG",
        AwayTeamInitials: "NIR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -8.7399,
          42.21212
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "18 Jun 1982 - 17:15 ",
        Stage: "Group 1",
        Stadium: "Estadio de Balaidos",
        City: "Vigo ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Peru",
        WinConditions: " ",
        Attendance: 25000,
        RoundID: "group",
        MatchID: 994,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "PER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.49267,
          38.35729
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "18 Jun 1982 - 21:00 ",
        Stage: "Group 3",
        Stadium: "Jose Rico Perez",
        City: "Alicante ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "Hungary",
        WinConditions: " ",
        Attendance: 32093,
        RoundID: "group",
        MatchID: 752,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "HUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -5.98171,
          37.35634
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "18 Jun 1982 - 21:00 ",
        Stage: "Group 6",
        Stadium: "Benito Villamarin",
        City: "Seville ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "Scotland",
        WinConditions: " ",
        Attendance: 47379,
        RoundID: "group",
        MatchID: 790,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "SCO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -8.41752,
          43.36863
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "19 Jun 1982 - 19:15 ",
        Stage: "Group 1",
        Stadium: "Riazor",
        City: "La Coruna",
        HomeTeamName: "Poland",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Cameroon",
        WinConditions: " ",
        Attendance: 19000,
        RoundID: "group",
        MatchID: 834,
        HomeTeamInitials: "POL",
        AwayTeamInitials: "CMR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.66326,
          38.26703
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "19 Jun 1982 - 21:00 ",
        Stage: "Group 3",
        Stadium: "Nuevo Estadio",
        City: "Elche ",
        HomeTeamName: "Belgium",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "El Salvador",
        WinConditions: " ",
        Attendance: 15000,
        RoundID: "group",
        MatchID: 774,
        HomeTeamInitials: "BEL",
        AwayTeamInitials: "SLV"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -4.42658,
          36.7343
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "19 Jun 1982 - 21:00 ",
        Stage: "Group 6",
        Stadium: "La Rosaleda",
        City: "Malaga ",
        HomeTeamName: "Soviet Union",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "New Zealand",
        WinConditions: " ",
        Attendance: 19000,
        RoundID: "group",
        MatchID: 1054,
        HomeTeamInitials: "URS",
        AwayTeamInitials: "NZL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -5.63742,
          43.53597
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "20 Jun 1982 - 17:15 ",
        Stage: "Group 2",
        Stadium: "El Molinon",
        City: "Gijon ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "Chile",
        WinConditions: " ",
        Attendance: 42000,
        RoundID: "group",
        MatchID: 813,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "CHI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -2.94928,
          43.26405
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "20 Jun 1982 - 17:15 ",
        Stage: "Group 4",
        Stadium: "San Mames",
        City: "Bilbao ",
        HomeTeamName: "England",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Czechoslovakia",
        WinConditions: " ",
        Attendance: 41123,
        RoundID: "group",
        MatchID: 889,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "TCH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.35831,
          39.47458
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "20 Jun 1982 - 21:00 ",
        Stage: "Group 5",
        Stadium: "Luis Casanova",
        City: "Valencia ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Yugoslavia",
        WinConditions: " ",
        Attendance: 48000,
        RoundID: "group",
        MatchID: 903,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "YUG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -5.87017,
          43.36067
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "21 Jun 1982 - 17:15 ",
        Stage: "Group 2",
        Stadium: "Carlos Tartiere",
        City: "Oviedo ",
        HomeTeamName: "Algeria",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Austria",
        WinConditions: " ",
        Attendance: 22000,
        RoundID: "group",
        MatchID: 739,
        HomeTeamInitials: "ALG",
        AwayTeamInitials: "AUT"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -4.761,
          41.64444
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "21 Jun 1982 - 17:15 ",
        Stage: "Group 4",
        Stadium: "Jose Zorrilla",
        City: "Valladolid ",
        HomeTeamName: "France",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "Kuwait",
        WinConditions: " ",
        Attendance: 30043,
        RoundID: "group",
        MatchID: 919,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "KUW"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.90174,
          41.63635
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "21 Jun 1982 - 21:00 ",
        Stage: "Group 5",
        Stadium: "La Romareda",
        City: "Zaragoza ",
        HomeTeamName: "Honduras",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Northern Ireland",
        WinConditions: " ",
        Attendance: 15000,
        RoundID: "group",
        MatchID: 959,
        HomeTeamInitials: "HON",
        AwayTeamInitials: "NIR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -8.41752,
          43.36863
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "22 Jun 1982 - 17:15 ",
        Stage: "Group 1",
        Stadium: "Riazor",
        City: "La Coruna",
        HomeTeamName: "Poland",
        HomeTeamGoals: 5,
        AwayTeamGoals: 1,
        AwayTeamName: "Peru",
        WinConditions: " ",
        Attendance: 25000,
        RoundID: "group",
        MatchID: 1055,
        HomeTeamInitials: "POL",
        AwayTeamInitials: "PER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.66326,
          38.26703
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "22 Jun 1982 - 21:00 ",
        Stage: "Group 3",
        Stadium: "Nuevo Estadio",
        City: "Elche ",
        HomeTeamName: "Belgium",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Hungary",
        WinConditions: " ",
        Attendance: 37000,
        RoundID: "group",
        MatchID: 779,
        HomeTeamInitials: "BEL",
        AwayTeamInitials: "HUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -4.42658,
          36.7343
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "22 Jun 1982 - 21:00 ",
        Stage: "Group 6",
        Stadium: "La Rosaleda",
        City: "Malaga ",
        HomeTeamName: "Soviet Union",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Scotland",
        WinConditions: " ",
        Attendance: 45000,
        RoundID: "group",
        MatchID: 1071,
        HomeTeamInitials: "URS",
        AwayTeamInitials: "SCO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -8.7399,
          42.21212
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "23 Jun 1982 - 17:15 ",
        Stage: "Group 1",
        Stadium: "Estadio de Balaidos",
        City: "Vigo ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Cameroon",
        WinConditions: " ",
        Attendance: 20000,
        RoundID: "group",
        MatchID: 828,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "CMR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.49267,
          38.35729
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "23 Jun 1982 - 21:00 ",
        Stage: "Group 3",
        Stadium: "Jose Rico Perez",
        City: "Alicante ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "El Salvador",
        WinConditions: " ",
        Attendance: 32500,
        RoundID: "group",
        MatchID: 751,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "SLV"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -5.98171,
          37.35634
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "23 Jun 1982 - 21:00 ",
        Stage: "Group 6",
        Stadium: "Benito Villamarin",
        City: "Seville ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 4,
        AwayTeamGoals: 0,
        AwayTeamName: "New Zealand",
        WinConditions: " ",
        Attendance: 43000,
        RoundID: "group",
        MatchID: 789,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "NZL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -5.87017,
          43.36067
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "24 Jun 1982 - 17:15 ",
        Stage: "Group 2",
        Stadium: "Carlos Tartiere",
        City: "Oviedo ",
        HomeTeamName: "Algeria",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Chile",
        WinConditions: " ",
        Attendance: 16000,
        RoundID: "group",
        MatchID: 740,
        HomeTeamInitials: "ALG",
        AwayTeamInitials: "CHI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -4.761,
          41.64444
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "24 Jun 1982 - 17:15 ",
        Stage: "Group 4",
        Stadium: "Jose Zorrilla",
        City: "Valladolid ",
        HomeTeamName: "France",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Czechoslovakia",
        WinConditions: " ",
        Attendance: 28000,
        RoundID: "group",
        MatchID: 922,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "TCH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.90174,
          41.63635
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "24 Jun 1982 - 21:00 ",
        Stage: "Group 5",
        Stadium: "La Romareda",
        City: "Zaragoza ",
        HomeTeamName: "Honduras",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Yugoslavia",
        WinConditions: " ",
        Attendance: 25000,
        RoundID: "group",
        MatchID: 962,
        HomeTeamInitials: "HON",
        AwayTeamInitials: "YUG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -5.63742,
          43.53597
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "25 Jun 1982 - 17:15 ",
        Stage: "Group 2",
        Stadium: "El Molinon",
        City: "Gijon ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Austria",
        WinConditions: " ",
        Attendance: 41000,
        RoundID: "group",
        MatchID: 770,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "AUT"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -2.94928,
          43.26405
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "25 Jun 1982 - 17:15 ",
        Stage: "Group 4",
        Stadium: "San Mames",
        City: "Bilbao ",
        HomeTeamName: "England",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Kuwait",
        WinConditions: " ",
        Attendance: 39700,
        RoundID: "group",
        MatchID: 882,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "KUW"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.35831,
          39.47458
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "25 Jun 1982 - 21:00 ",
        Stage: "Group 5",
        Stadium: "Luis Casanova",
        City: "Valencia ",
        HomeTeamName: "Northern Ireland",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 49562,
        RoundID: "group",
        MatchID: 902,
        HomeTeamInitials: "NIR",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -3.72065,
          40.40164
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "28 Jun 1982 - 17:15 ",
        Stage: "Group 4",
        Stadium: "Vicente Calderon",
        City: "Madrid ",
        HomeTeamName: "Austria",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 37000,
        RoundID: "rtwelve",
        MatchID: 767,
        HomeTeamInitials: "AUT",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.1229,
          41.38079
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "28 Jun 1982 - 21:00 ",
        Stage: "Group 1",
        Stadium: "Camp Nou",
        City: "Barcelona ",
        HomeTeamName: "Poland",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Belgium",
        WinConditions: " ",
        Attendance: 65000,
        RoundID: "rtwelve",
        MatchID: 782,
        HomeTeamInitials: "POL",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.13327,
          41.39304
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "29 Jun 1982 - 17:15 ",
        Stage: "Group 3",
        Stadium: "Sarria",
        City: "Barcelona ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Argentina",
        WinConditions: " ",
        Attendance: 43000,
        RoundID: "rtwelve",
        MatchID: 753,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -3.68834,
          40.4529
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "29 Jun 1982 - 21:00 ",
        Stage: "Group 2",
        Stadium: "Santiago Bernabeu",
        City: "Madrid ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 75000,
        RoundID: "rtwelve",
        MatchID: 879,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -3.72065,
          40.40164
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "01 Jul 1982 - 17:15 ",
        Stage: "Group 4",
        Stadium: "Vicente Calderon",
        City: "Madrid ",
        HomeTeamName: "Austria",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Northern Ireland",
        WinConditions: " ",
        Attendance: 20000,
        RoundID: "rtwelve",
        MatchID: 771,
        HomeTeamInitials: "AUT",
        AwayTeamInitials: "NIR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.1229,
          41.38079
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "01 Jul 1982 - 21:00 ",
        Stage: "Group 1",
        Stadium: "Camp Nou",
        City: "Barcelona ",
        HomeTeamName: "Belgium",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Soviet Union",
        WinConditions: " ",
        Attendance: 45000,
        RoundID: "rtwelve",
        MatchID: 783,
        HomeTeamInitials: "BEL",
        AwayTeamInitials: "URS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.13327,
          41.39304
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "02 Jul 1982 - 17:15 ",
        Stage: "Group 3",
        Stadium: "Sarria",
        City: "Barcelona ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 1,
        AwayTeamGoals: 3,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 44000,
        RoundID: "rtwelve",
        MatchID: 750,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -3.68834,
          40.4529
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "02 Jul 1982 - 21:00 ",
        Stage: "Group 2",
        Stadium: "Santiago Bernabeu",
        City: "Madrid ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 90089,
        RoundID: "rtwelve",
        MatchID: 900,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -3.72065,
          40.40164
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "04 Jul 1982 - 17:15 ",
        Stage: "Group 4",
        Stadium: "Vicente Calderon",
        City: "Madrid ",
        HomeTeamName: "France",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "Northern Ireland",
        WinConditions: " ",
        Attendance: 37000,
        RoundID: "rtwelve",
        MatchID: 920,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "NIR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.1229,
          41.38079
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "04 Jul 1982 - 21:00 ",
        Stage: "Group 1",
        Stadium: "Camp Nou",
        City: "Barcelona ",
        HomeTeamName: "Poland",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Soviet Union",
        WinConditions: " ",
        Attendance: 65000,
        RoundID: "rtwelve",
        MatchID: 1058,
        HomeTeamInitials: "POL",
        AwayTeamInitials: "URS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.13327,
          41.39304
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "05 Jul 1982 - 17:15 ",
        Stage: "Group 3",
        Stadium: "Sarria",
        City: "Barcelona ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 44000,
        RoundID: "rtwelve",
        MatchID: 788,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -3.68834,
          40.4529
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "05 Jul 1982 - 21:00 ",
        Stage: "Group 2",
        Stadium: "Santiago Bernabeu",
        City: "Madrid ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 75000,
        RoundID: "rtwelve",
        MatchID: 877,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.1229,
          41.38079
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "08 Jul 1982 - 17:15 ",
        Stage: "Semi-finals",
        Stadium: "Camp Nou",
        City: "Barcelona ",
        HomeTeamName: "Poland",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 50000,
        RoundID: "semi",
        MatchID: 996,
        HomeTeamInitials: "POL",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -5.97061,
          37.38396
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "08 Jul 1982 - 21:00 ",
        Stage: "Semi-finals",
        Stadium: "Ramon Sanchez Pizjuan",
        City: "Seville ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 3,
        AwayTeamGoals: 3,
        AwayTeamName: "France",
        WinConditions: "Germany FR win on penalties (5 - 4) ",
        Attendance: 70000,
        RoundID: "semi",
        MatchID: 914,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.49267,
          38.35729
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "10 Jul 1982 - 20:00 ",
        Stage: "Match for third place",
        Stadium: "Jose Rico Perez",
        City: "Alicante ",
        HomeTeamName: "Poland",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 28000,
        RoundID: "third",
        MatchID: 921,
        HomeTeamInitials: "POL",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -3.68834,
          40.4529
        ]
      },
      properties: {
        Year: 1982,
        Datetime: "11 Jul 1982 - 20:00 ",
        Stage: "Final",
        Stadium: "Santiago Bernabeu",
        City: "Madrid ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Germany FR",
        WinConditions: " ",
        Attendance: 90000,
        RoundID: "final",
        MatchID: 923,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "FRG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.15059,
          19.30279
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "31 May 1986 - 12:00 ",
        Stage: "Group A",
        Stadium: "Estadio Azteca",
        City: "Mexico City ",
        HomeTeamName: "Bulgaria",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 96000,
        RoundID: "group",
        MatchID: 459,
        HomeTeamInitials: "BUL",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -101.65785,
          21.11523
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "01 Jun 1986 - 16:00 ",
        Stage: "Group C",
        Stadium: "Estadio Leon",
        City: "Leon ",
        HomeTeamName: "Canada",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 65500,
        RoundID: "group",
        MatchID: 468,
        HomeTeamInitials: "CAN",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -103.32818,
          20.70479
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "01 Jun 1986 - 12:00 ",
        Stage: "Group D",
        Stadium: "Jalisco",
        City: "Guadalajara ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 35748,
        RoundID: "group",
        MatchID: 439,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -101.35629,
          20.68447
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "02 Jun 1986 - 12:00 ",
        Stage: "Group C",
        Stadium: "Estadio Irapuato",
        City: "Irapuato ",
        HomeTeamName: "Soviet Union",
        HomeTeamGoals: 6,
        AwayTeamGoals: 0,
        AwayTeamName: "Hungary",
        WinConditions: " ",
        Attendance: 16500,
        RoundID: "group",
        MatchID: 610,
        HomeTeamInitials: "URS",
        AwayTeamInitials: "HUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -64.24624,
          -31.36895
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "02 Jun 1986 - 12:00 ",
        Stage: "Group A",
        Stadium: "Estadio Olimpico Chateau Carreras",
        City: "Mexico City ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Korea Republic",
        WinConditions: " ",
        Attendance: 60000,
        RoundID: "group",
        MatchID: 395,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "KOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -100.31201,
          25.72247
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "02 Jun 1986 - 16:00 ",
        Stage: "Group F",
        Stadium: "Estadio Universitario",
        City: "Monterrey ",
        HomeTeamName: "Morocco",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Poland",
        WinConditions: " ",
        Attendance: 19900,
        RoundID: "group",
        MatchID: 674,
        HomeTeamInitials: "MAR",
        AwayTeamInitials: "POL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -103.41619,
          20.69379
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "03 Jun 1986 - 12:00 ",
        Stage: "Group D",
        Stadium: "Tres de Marzo",
        City: "Guadalajara ",
        HomeTeamName: "Algeria",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Northern Ireland",
        WinConditions: " ",
        Attendance: 22000,
        RoundID: "group",
        MatchID: 379,
        HomeTeamInitials: "ALG",
        AwayTeamInitials: "NIR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.15059,
          19.30279
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "03 Jun 1986 - 12:00 ",
        Stage: "Group B",
        Stadium: "Estadio Azteca",
        City: "Mexico City ",
        HomeTeamName: "Belgium",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 110000,
        RoundID: "group",
        MatchID: 428,
        HomeTeamInitials: "BEL",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -100.28639,
          25.6522
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "03 Jun 1986 - 16:00 ",
        Stage: "Group F",
        Stadium: "Tecnologico",
        City: "Monterrey ",
        HomeTeamName: "Portugal",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 23000,
        RoundID: "group",
        MatchID: 538,
        HomeTeamInitials: "POR",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.66689,
          19.28727
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "04 Jun 1986 - 12:00 ",
        Stage: "Group B",
        Stadium: "Bombonera - Estadio Nemesio Diez",
        City: "Toluca ",
        HomeTeamName: "Paraguay",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Iraq",
        WinConditions: " ",
        Attendance: 24000,
        RoundID: "group",
        MatchID: 628,
        HomeTeamInitials: "PAR",
        AwayTeamInitials: "IRQ"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -98.98713,
          19.40568
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "04 Jun 1986 - 16:00 ",
        Stage: "Group E",
        Stadium: "Neza",
        City: "Nezahualcoyotl ",
        HomeTeamName: "Scotland",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Denmark",
        WinConditions: " ",
        Attendance: 18000,
        RoundID: "group",
        MatchID: 517,
        HomeTeamInitials: "SCO",
        AwayTeamInitials: "DEN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -100.36639,
          20.57752
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "04 Jun 1986 - 12:00 ",
        Stage: "Group E",
        Stadium: "Estadio Corregidora",
        City: "Queretaro ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Germany FR",
        WinConditions: " ",
        Attendance: 30500,
        RoundID: "group",
        MatchID: 585,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "FRG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -98.16458,
          19.07771
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "05 Jun 1986 - 12:00 ",
        Stage: "Group A",
        Stadium: "Cuauhtemoc",
        City: "Puebla ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Argentina",
        WinConditions: " ",
        Attendance: 32000,
        RoundID: "group",
        MatchID: 394,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -101.65785,
          21.11523
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "05 Jun 1986 - 12:00 ",
        Stage: "Group C",
        Stadium: "Estadio Leon",
        City: "Leon ",
        HomeTeamName: "France",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Soviet Union",
        WinConditions: " ",
        Attendance: 36540,
        RoundID: "group",
        MatchID: 571,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "URS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -64.24624,
          -31.36895
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "05 Jun 1986 - 16:00 ",
        Stage: "Group A",
        Stadium: "Estadio Olimpico Chateau Carreras",
        City: "Mexico City ",
        HomeTeamName: "Korea Republic",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Bulgaria",
        WinConditions: " ",
        Attendance: 45000,
        RoundID: "group",
        MatchID: 460,
        HomeTeamInitials: "KOR",
        AwayTeamInitials: "BUL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -101.35629,
          20.68447
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "06 Jun 1986 - 12:00 ",
        Stage: "Group C",
        Stadium: "Estadio Irapuato",
        City: "Irapuato ",
        HomeTeamName: "Hungary",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Canada",
        WinConditions: " ",
        Attendance: 13800,
        RoundID: "group",
        MatchID: 475,
        HomeTeamInitials: "HUN",
        AwayTeamInitials: "CAN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -103.32818,
          20.70479
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "06 Jun 1986 - 12:00 ",
        Stage: "Group D",
        Stadium: "Jalisco",
        City: "Guadalajara ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Algeria",
        WinConditions: " ",
        Attendance: 48000,
        RoundID: "group",
        MatchID: 377,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "ALG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -100.28639,
          25.6522
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "06 Jun 1986 - 16:00 ",
        Stage: "Group F",
        Stadium: "Tecnologico",
        City: "Monterrey ",
        HomeTeamName: "England",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Morocco",
        WinConditions: " ",
        Attendance: 20200,
        RoundID: "group",
        MatchID: 533,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "MAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -103.41619,
          20.69379
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "07 Jun 1986 - 12:00 ",
        Stage: "Group D",
        Stadium: "Tres de Marzo",
        City: "Guadalajara ",
        HomeTeamName: "Northern Ireland",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 28000,
        RoundID: "group",
        MatchID: 551,
        HomeTeamInitials: "NIR",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.15059,
          19.30279
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "07 Jun 1986 - 12:00 ",
        Stage: "Group B",
        Stadium: "Estadio Azteca",
        City: "Mexico City ",
        HomeTeamName: "Mexico",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Paraguay",
        WinConditions: " ",
        Attendance: 114600,
        RoundID: "group",
        MatchID: 680,
        HomeTeamInitials: "MEX",
        AwayTeamInitials: "PAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -100.31201,
          25.72247
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "07 Jun 1986 - 16:00 ",
        Stage: "Group F",
        Stadium: "Estadio Universitario",
        City: "Monterrey ",
        HomeTeamName: "Poland",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Portugal",
        WinConditions: " ",
        Attendance: 19915,
        RoundID: "group",
        MatchID: 701,
        HomeTeamInitials: "POL",
        AwayTeamInitials: "POR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.66689,
          19.28727
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "08 Jun 1986 - 12:00 ",
        Stage: "Group B",
        Stadium: "Bombonera - Estadio Nemesio Diez",
        City: "Toluca ",
        HomeTeamName: "Iraq",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Belgium",
        WinConditions: " ",
        Attendance: 20000,
        RoundID: "group",
        MatchID: 427,
        HomeTeamInitials: "IRQ",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -98.98713,
          19.40568
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "08 Jun 1986 - 16:00 ",
        Stage: "Group E",
        Stadium: "Neza",
        City: "Nezahualcoyotl ",
        HomeTeamName: "Denmark",
        HomeTeamGoals: 6,
        AwayTeamGoals: 1,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 26500,
        RoundID: "group",
        MatchID: 522,
        HomeTeamInitials: "DEN",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -100.36639,
          20.57752
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "08 Jun 1986 - 12:00 ",
        Stage: "Group E",
        Stadium: "Estadio Corregidora",
        City: "Queretaro ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Scotland",
        WinConditions: " ",
        Attendance: 30000,
        RoundID: "group",
        MatchID: 580,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "SCO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -101.65785,
          21.11523
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "09 Jun 1986 - 12:00 ",
        Stage: "Group C",
        Stadium: "Estadio Leon",
        City: "Leon ",
        HomeTeamName: "Hungary",
        HomeTeamGoals: 0,
        AwayTeamGoals: 3,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 31420,
        RoundID: "group",
        MatchID: 567,
        HomeTeamInitials: "HUN",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -101.35629,
          20.68447
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "09 Jun 1986 - 12:00 ",
        Stage: "Group C",
        Stadium: "Estadio Irapuato",
        City: "Irapuato ",
        HomeTeamName: "Soviet Union",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Canada",
        WinConditions: " ",
        Attendance: 14200,
        RoundID: "group",
        MatchID: 476,
        HomeTeamInitials: "URS",
        AwayTeamInitials: "CAN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -98.16458,
          19.07771
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "10 Jun 1986 - 12:00 ",
        Stage: "Group A",
        Stadium: "Cuauhtemoc",
        City: "Puebla ",
        HomeTeamName: "Korea Republic",
        HomeTeamGoals: 2,
        AwayTeamGoals: 3,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 20000,
        RoundID: "group",
        MatchID: 643,
        HomeTeamInitials: "KOR",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -64.24624,
          -31.36895
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "10 Jun 1986 - 12:00 ",
        Stage: "Group A",
        Stadium: "Estadio Olimpico Chateau Carreras",
        City: "Mexico City ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Bulgaria",
        WinConditions: " ",
        Attendance: 65000,
        RoundID: "group",
        MatchID: 389,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "BUL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.66689,
          19.28727
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "11 Jun 1986 - 12:00 ",
        Stage: "Group B",
        Stadium: "Bombonera - Estadio Nemesio Diez",
        City: "Toluca ",
        HomeTeamName: "Paraguay",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Belgium",
        WinConditions: " ",
        Attendance: 16000,
        RoundID: "group",
        MatchID: 429,
        HomeTeamInitials: "PAR",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.15059,
          19.30279
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "11 Jun 1986 - 12:00 ",
        Stage: "Group B",
        Stadium: "Estadio Azteca",
        City: "Mexico City ",
        HomeTeamName: "Iraq",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 103763,
        RoundID: "group",
        MatchID: 627,
        HomeTeamInitials: "IRQ",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -103.41619,
          20.69379
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "11 Jun 1986 - 16:00 ",
        Stage: "Group F",
        Stadium: "Tres de Marzo",
        City: "Guadalajara ",
        HomeTeamName: "Portugal",
        HomeTeamGoals: 1,
        AwayTeamGoals: 3,
        AwayTeamName: "Morocco",
        WinConditions: " ",
        Attendance: 28000,
        RoundID: "group",
        MatchID: 675,
        HomeTeamInitials: "POR",
        AwayTeamInitials: "MAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -100.28639,
          25.6522
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "11 Jun 1986 - 16:00 ",
        Stage: "Group F",
        Stadium: "Tecnologico",
        City: "Monterrey ",
        HomeTeamName: "England",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Poland",
        WinConditions: " ",
        Attendance: 22700,
        RoundID: "group",
        MatchID: 537,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "POL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -103.32818,
          20.70479
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "12 Jun 1986 - 12:00 ",
        Stage: "Group D",
        Stadium: "Jalisco",
        City: "Guadalajara ",
        HomeTeamName: "Northern Ireland",
        HomeTeamGoals: 0,
        AwayTeamGoals: 3,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 51000,
        RoundID: "group",
        MatchID: 441,
        HomeTeamInitials: "NIR",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -100.28639,
          25.6522
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "12 Jun 1986 - 12:00 ",
        Stage: "Group D",
        Stadium: "Tecnologico",
        City: "Monterrey ",
        HomeTeamName: "Algeria",
        HomeTeamGoals: 0,
        AwayTeamGoals: 3,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 23980,
        RoundID: "group",
        MatchID: 378,
        HomeTeamInitials: "ALG",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -98.98713,
          19.40568
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "13 Jun 1986 - 12:00 ",
        Stage: "Group E",
        Stadium: "Neza",
        City: "Nezahualcoyotl ",
        HomeTeamName: "Scotland",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 20000,
        RoundID: "group",
        MatchID: 712,
        HomeTeamInitials: "SCO",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -100.36639,
          20.57752
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "13 Jun 1986 - 12:00 ",
        Stage: "Group E",
        Stadium: "Estadio Corregidora",
        City: "Queretaro ",
        HomeTeamName: "Denmark",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Germany FR",
        WinConditions: " ",
        Attendance: 36000,
        RoundID: "group",
        MatchID: 512,
        HomeTeamInitials: "DEN",
        AwayTeamInitials: "FRG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -101.65785,
          21.11523
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "15 Jun 1986 - 16:00 ",
        Stage: "Round of 16",
        Stadium: "Estadio Leon",
        City: "Leon ",
        HomeTeamName: "Soviet Union",
        HomeTeamGoals: 3,
        AwayTeamGoals: 4,
        AwayTeamName: "Belgium",
        WinConditions: "win after extra time ",
        Attendance: 32277,
        RoundID: "rsixteen",
        MatchID: 432,
        HomeTeamInitials: "URS",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.15059,
          19.30279
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "15 Jun 1986 - 12:00 ",
        Stage: "Round of 16",
        Stadium: "Estadio Azteca",
        City: "Mexico City ",
        HomeTeamName: "Mexico",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Bulgaria",
        WinConditions: " ",
        Attendance: 114580,
        RoundID: "rsixteen",
        MatchID: 463,
        HomeTeamInitials: "MEX",
        AwayTeamInitials: "BUL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -98.16458,
          19.07771
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "16 Jun 1986 - 16:00 ",
        Stage: "Round of 16",
        Stadium: "Cuauhtemoc",
        City: "Puebla ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 26000,
        RoundID: "rsixteen",
        MatchID: 398,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -103.32818,
          20.70479
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "16 Jun 1986 - 12:00 ",
        Stage: "Round of 16",
        Stadium: "Jalisco",
        City: "Guadalajara ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 4,
        AwayTeamGoals: 0,
        AwayTeamName: "Poland",
        WinConditions: " ",
        Attendance: 45000,
        RoundID: "rsixteen",
        MatchID: 444,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "POL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -64.24624,
          -31.36895
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "17 Jun 1986 - 12:00 ",
        Stage: "Round of 16",
        Stadium: "Estadio Olimpico Chateau Carreras",
        City: "Mexico City ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 70000,
        RoundID: "rsixteen",
        MatchID: 568,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -100.31201,
          25.72247
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "17 Jun 1986 - 16:00 ",
        Stage: "Round of 16",
        Stadium: "Estadio Universitario",
        City: "Monterrey ",
        HomeTeamName: "Morocco",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Germany FR",
        WinConditions: " ",
        Attendance: 19800,
        RoundID: "rsixteen",
        MatchID: 574,
        HomeTeamInitials: "MAR",
        AwayTeamInitials: "FRG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.15059,
          19.30279
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "18 Jun 1986 - 12:00 ",
        Stage: "Round of 16",
        Stadium: "Estadio Azteca",
        City: "Mexico City ",
        HomeTeamName: "England",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Paraguay",
        WinConditions: " ",
        Attendance: 98728,
        RoundID: "rsixteen",
        MatchID: 536,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "PAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -100.36639,
          20.57752
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "18 Jun 1986 - 16:00 ",
        Stage: "Round of 16",
        Stadium: "Estadio Corregidora",
        City: "Queretaro ",
        HomeTeamName: "Denmark",
        HomeTeamGoals: 1,
        AwayTeamGoals: 5,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 38500,
        RoundID: "rsixteen",
        MatchID: 511,
        HomeTeamInitials: "DEN",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -103.32818,
          20.70479
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "21 Jun 1986 - 12:00 ",
        Stage: "Quarter-finals",
        Stadium: "Jalisco",
        City: "Guadalajara ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "France",
        WinConditions: "France win on penalties (3 - 4) ",
        Attendance: 65000,
        RoundID: "quart",
        MatchID: 440,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -100.31201,
          25.72247
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "21 Jun 1986 - 16:00 ",
        Stage: "Quarter-finals",
        Stadium: "Estadio Universitario",
        City: "Monterrey ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Mexico",
        WinConditions: "Germany FR win on penalties (4 - 1) ",
        Attendance: 41700,
        RoundID: "quart",
        MatchID: 575,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -98.16458,
          19.07771
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "22 Jun 1986 - 16:00 ",
        Stage: "Quarter-finals",
        Stadium: "Cuauhtemoc",
        City: "Puebla ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Belgium",
        WinConditions: "Belgium win on penalties (4 - 5) ",
        Attendance: 45000,
        RoundID: "quart",
        MatchID: 421,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.15059,
          19.30279
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "22 Jun 1986 - 12:00 ",
        Stage: "Quarter-finals",
        Stadium: "Estadio Azteca",
        City: "Mexico City ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 114580,
        RoundID: "quart",
        MatchID: 392,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -103.32818,
          20.70479
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "25 Jun 1986 - 12:00 ",
        Stage: "Semi-finals",
        Stadium: "Jalisco",
        City: "Guadalajara ",
        HomeTeamName: "France",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Germany FR",
        WinConditions: " ",
        Attendance: 45000,
        RoundID: "semi",
        MatchID: 564,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "FRG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.15059,
          19.30279
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "25 Jun 1986 - 16:00 ",
        Stage: "Semi-finals",
        Stadium: "Estadio Azteca",
        City: "Mexico City ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Belgium",
        WinConditions: " ",
        Attendance: 114500,
        RoundID: "semi",
        MatchID: 388,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -98.16458,
          19.07771
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "28 Jun 1986 - 12:00 ",
        Stage: "Match for third place",
        Stadium: "Cuauhtemoc",
        City: "Puebla ",
        HomeTeamName: "France",
        HomeTeamGoals: 4,
        AwayTeamGoals: 2,
        AwayTeamName: "Belgium",
        WinConditions: "win after extra time ",
        Attendance: 21000,
        RoundID: "third",
        MatchID: 422,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -99.15059,
          19.30279
        ]
      },
      properties: {
        Year: 1986,
        Datetime: "29 Jun 1986 - 12:00 ",
        Stage: "Final",
        Stadium: "Estadio Azteca",
        City: "Mexico City ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Germany FR",
        WinConditions: " ",
        Attendance: 114600,
        RoundID: "final",
        MatchID: 393,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "FRG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.12388,
          45.47806
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "08 Jun 1990 - 18:00 ",
        Stage: "Group B",
        Stadium: "Giuseppe Meazza",
        City: "Milan ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Cameroon",
        WinConditions: " ",
        Attendance: 73780,
        RoundID: "group",
        MatchID: 26,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "CMR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          16.84015,
          41.08463
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "09 Jun 1990 - 17:00 ",
        Stage: "Group B",
        Stadium: "Stadio San Nicola",
        City: "Bari ",
        HomeTeamName: "Soviet Union",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Romania",
        WinConditions: " ",
        Attendance: 42907,
        RoundID: "group",
        MatchID: 342,
        HomeTeamInitials: "URS",
        AwayTeamInitials: "ROU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.31004,
          44.49209
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "09 Jun 1990 - 17:00 ",
        Stage: "Group D",
        Stadium: "Renato Dall Ara",
        City: "Bologna ",
        HomeTeamName: "United Arab Emirates",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Colombia",
        WinConditions: " ",
        Attendance: 30791,
        RoundID: "group",
        MatchID: 119,
        HomeTeamInitials: "UAE",
        AwayTeamInitials: "COL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.45478,
          41.93396
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "09 Jun 1990 - 21:00 ",
        Stage: "Group A",
        Stadium: "Stadio Olimpico",
        City: "Rome ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Austria",
        WinConditions: " ",
        Attendance: 73303,
        RoundID: "group",
        MatchID: 42,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "AUT"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.2826,
          43.7808
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "10 Jun 1990 - 17:00 ",
        Stage: "Group A",
        Stadium: "Comunale",
        City: "Florence ",
        HomeTeamName: "USA",
        HomeTeamGoals: 1,
        AwayTeamGoals: 5,
        AwayTeamName: "Czechoslovakia",
        WinConditions: " ",
        Attendance: 33266,
        RoundID: "group",
        MatchID: 355,
        HomeTeamInitials: "USA",
        AwayTeamInitials: "TCH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.64136,
          45.10942
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "10 Jun 1990 - 21:00 ",
        Stage: "Group C",
        Stadium: "Stadio delle Alpi",
        City: "Turin ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Sweden",
        WinConditions: " ",
        Attendance: 62628,
        RoundID: "group",
        MatchID: 75,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "SWE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.12388,
          45.47806
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "10 Jun 1990 - 21:00 ",
        Stage: "Group D",
        Stadium: "Giuseppe Meazza",
        City: "Milan ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "Yugoslavia",
        WinConditions: " ",
        Attendance: 74765,
        RoundID: "group",
        MatchID: 201,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "YUG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.95262,
          44.41645
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "11 Jun 1990 - 17:00 ",
        Stage: "Group C",
        Stadium: "Luigi Ferraris",
        City: "Genoa ",
        HomeTeamName: "Costa Rica",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Scotland",
        WinConditions: " ",
        Attendance: 30867,
        RoundID: "group",
        MatchID: 127,
        HomeTeamInitials: "CRC",
        AwayTeamInitials: "SCO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.13497,
          39.19932
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "11 Jun 1990 - 21:00 ",
        Stage: "Group F",
        Stadium: "Sant Elia",
        City: "Cagliari ",
        HomeTeamName: "England",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Ireland",
        WinConditions: " ",
        Attendance: 35238,
        RoundID: "group",
        MatchID: 161,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "IRL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          10.96858,
          45.43525
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "12 Jun 1990 - 17:00 ",
        Stage: "Group E",
        Stadium: "Marc Antonio Bentegodi",
        City: "Verona ",
        HomeTeamName: "Belgium",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Korea Republic",
        WinConditions: " ",
        Attendance: 32790,
        RoundID: "group",
        MatchID: 57,
        HomeTeamInitials: "BEL",
        AwayTeamInitials: "KOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.34224,
          38.15268
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "12 Jun 1990 - 21:00 ",
        Stage: "Group F",
        Stadium: "Della Favorita",
        City: "Palermo ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Egypt",
        WinConditions: " ",
        Attendance: 33288,
        RoundID: "group",
        MatchID: 151,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "EGY"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.19984,
          46.08139
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "13 Jun 1990 - 17:00 ",
        Stage: "Group E",
        Stadium: "Friuli",
        City: "Udine ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 35713,
        RoundID: "group",
        MatchID: 180,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          14.19307,
          40.82781
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "13 Jun 1990 - 21:00 ",
        Stage: "Group B",
        Stadium: "San Paolo",
        City: "Naples ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Soviet Union",
        WinConditions: " ",
        Attendance: 55759,
        RoundID: "group",
        MatchID: 30,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "URS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          16.84015,
          41.08463
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "14 Jun 1990 - 17:00 ",
        Stage: "Group B",
        Stadium: "Stadio San Nicola",
        City: "Bari ",
        HomeTeamName: "Cameroon",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Romania",
        WinConditions: " ",
        Attendance: 38687,
        RoundID: "group",
        MatchID: 108,
        HomeTeamInitials: "CMR",
        AwayTeamInitials: "ROU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.31004,
          44.49209
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "14 Jun 1990 - 17:00 ",
        Stage: "Group D",
        Stadium: "Renato Dall Ara",
        City: "Bologna ",
        HomeTeamName: "Yugoslavia",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Colombia",
        WinConditions: " ",
        Attendance: 32257,
        RoundID: "group",
        MatchID: 120,
        HomeTeamInitials: "YUG",
        AwayTeamInitials: "COL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.45478,
          41.93396
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "14 Jun 1990 - 21:00 ",
        Stage: "Group A",
        Stadium: "Stadio Olimpico",
        City: "Rome ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "USA",
        WinConditions: " ",
        Attendance: 73423,
        RoundID: "group",
        MatchID: 265,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "USA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.2826,
          43.7808
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "15 Jun 1990 - 17:00 ",
        Stage: "Group A",
        Stadium: "Comunale",
        City: "Florence ",
        HomeTeamName: "Austria",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Czechoslovakia",
        WinConditions: " ",
        Attendance: 38962,
        RoundID: "group",
        MatchID: 43,
        HomeTeamInitials: "AUT",
        AwayTeamInitials: "TCH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.12388,
          45.47806
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "15 Jun 1990 - 21:00 ",
        Stage: "Group D",
        Stadium: "Giuseppe Meazza",
        City: "Milan ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 5,
        AwayTeamGoals: 1,
        AwayTeamName: "United Arab Emirates",
        WinConditions: " ",
        Attendance: 71169,
        RoundID: "group",
        MatchID: 198,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "UAE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.64136,
          45.10942
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "16 Jun 1990 - 17:00 ",
        Stage: "Group C",
        Stadium: "Stadio delle Alpi",
        City: "Turin ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Costa Rica",
        WinConditions: " ",
        Attendance: 58007,
        RoundID: "group",
        MatchID: 73,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "CRC"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.95262,
          44.41645
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "16 Jun 1990 - 21:00 ",
        Stage: "Group C",
        Stadium: "Luigi Ferraris",
        City: "Genoa ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Scotland",
        WinConditions: " ",
        Attendance: 31823,
        RoundID: "group",
        MatchID: 348,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "SCO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.13497,
          39.19932
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "16 Jun 1990 - 21:00 ",
        Stage: "Group F",
        Stadium: "Sant Elia",
        City: "Cagliari ",
        HomeTeamName: "England",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Netherlands",
        WinConditions: " ",
        Attendance: 35267,
        RoundID: "group",
        MatchID: 160,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "NED"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.34224,
          38.15268
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "17 Jun 1990 - 17:00 ",
        Stage: "Group F",
        Stadium: "Della Favorita",
        City: "Palermo ",
        HomeTeamName: "Ireland",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Egypt",
        WinConditions: " ",
        Attendance: 33288,
        RoundID: "group",
        MatchID: 152,
        HomeTeamInitials: "IRL",
        AwayTeamInitials: "EGY"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.19984,
          46.08139
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "17 Jun 1990 - 21:00 ",
        Stage: "Group E",
        Stadium: "Friuli",
        City: "Udine ",
        HomeTeamName: "Korea Republic",
        HomeTeamGoals: 1,
        AwayTeamGoals: 3,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 32733,
        RoundID: "group",
        MatchID: 175,
        HomeTeamInitials: "KOR",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          10.96858,
          45.43525
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "17 Jun 1990 - 21:00 ",
        Stage: "Group E",
        Stadium: "Marc Antonio Bentegodi",
        City: "Verona ",
        HomeTeamName: "Belgium",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 33759,
        RoundID: "group",
        MatchID: 66,
        HomeTeamInitials: "BEL",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          14.19307,
          40.82781
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "18 Jun 1990 - 21:00 ",
        Stage: "Group B",
        Stadium: "San Paolo",
        City: "Naples ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Romania",
        WinConditions: " ",
        Attendance: 52733,
        RoundID: "group",
        MatchID: 29,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "ROU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          16.84015,
          41.08463
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "18 Jun 1990 - 21:00 ",
        Stage: "Group B",
        Stadium: "Stadio San Nicola",
        City: "Bari ",
        HomeTeamName: "Cameroon",
        HomeTeamGoals: 0,
        AwayTeamGoals: 4,
        AwayTeamName: "Soviet Union",
        WinConditions: " ",
        Attendance: 37307,
        RoundID: "group",
        MatchID: 111,
        HomeTeamInitials: "CMR",
        AwayTeamInitials: "URS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.12388,
          45.47806
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "19 Jun 1990 - 17:00 ",
        Stage: "Group D",
        Stadium: "Giuseppe Meazza",
        City: "Milan ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Colombia",
        WinConditions: " ",
        Attendance: 72510,
        RoundID: "group",
        MatchID: 114,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "COL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.31004,
          44.49209
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "19 Jun 1990 - 17:00 ",
        Stage: "Group D",
        Stadium: "Renato Dall Ara",
        City: "Bologna ",
        HomeTeamName: "Yugoslavia",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "United Arab Emirates",
        WinConditions: " ",
        Attendance: 27833,
        RoundID: "group",
        MatchID: 364,
        HomeTeamInitials: "YUG",
        AwayTeamInitials: "UAE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.45478,
          41.93396
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "19 Jun 1990 - 21:00 ",
        Stage: "Group A",
        Stadium: "Stadio Olimpico",
        City: "Rome ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Czechoslovakia",
        WinConditions: " ",
        Attendance: 73303,
        RoundID: "group",
        MatchID: 263,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "TCH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.2826,
          43.7808
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "19 Jun 1990 - 21:00 ",
        Stage: "Group A",
        Stadium: "Comunale",
        City: "Florence ",
        HomeTeamName: "Austria",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "USA",
        WinConditions: " ",
        Attendance: 34857,
        RoundID: "group",
        MatchID: 48,
        HomeTeamInitials: "AUT",
        AwayTeamInitials: "USA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.64136,
          45.10942
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "20 Jun 1990 - 21:00 ",
        Stage: "Group C",
        Stadium: "Stadio delle Alpi",
        City: "Turin ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Scotland",
        WinConditions: " ",
        Attendance: 62502,
        RoundID: "group",
        MatchID: 74,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "SCO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.95262,
          44.41645
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "20 Jun 1990 - 21:00 ",
        Stage: "Group C",
        Stadium: "Luigi Ferraris",
        City: "Genoa ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Costa Rica",
        WinConditions: " ",
        Attendance: 30223,
        RoundID: "group",
        MatchID: 128,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "CRC"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.19984,
          46.08139
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "21 Jun 1990 - 17:00 ",
        Stage: "Group E",
        Stadium: "Friuli",
        City: "Udine ",
        HomeTeamName: "Korea Republic",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 29039,
        RoundID: "group",
        MatchID: 290,
        HomeTeamInitials: "KOR",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          10.96858,
          45.43525
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "21 Jun 1990 - 17:00 ",
        Stage: "Group E",
        Stadium: "Marc Antonio Bentegodi",
        City: "Verona ",
        HomeTeamName: "Belgium",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 35950,
        RoundID: "group",
        MatchID: 56,
        HomeTeamInitials: "BEL",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.34224,
          38.15268
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "21 Jun 1990 - 21:00 ",
        Stage: "Group F",
        Stadium: "Della Favorita",
        City: "Palermo ",
        HomeTeamName: "Ireland",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Netherlands",
        WinConditions: " ",
        Attendance: 33288,
        RoundID: "group",
        MatchID: 228,
        HomeTeamInitials: "IRL",
        AwayTeamInitials: "NED"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.13497,
          39.19932
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "21 Jun 1990 - 21:00 ",
        Stage: "Group F",
        Stadium: "Sant Elia",
        City: "Cagliari ",
        HomeTeamName: "England",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Egypt",
        WinConditions: " ",
        Attendance: 34959,
        RoundID: "group",
        MatchID: 150,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "EGY"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          14.19307,
          40.82781
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "23 Jun 1990 - 17:00 ",
        Stage: "Round of 16",
        Stadium: "San Paolo",
        City: "Naples ",
        HomeTeamName: "Cameroon",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Colombia",
        WinConditions: "win after extra time ",
        Attendance: 50026,
        RoundID: "rsixteen",
        MatchID: 102,
        HomeTeamInitials: "CMR",
        AwayTeamInitials: "COL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          16.84015,
          41.08463
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "23 Jun 1990 - 21:00 ",
        Stage: "Round of 16",
        Stadium: "Stadio San Nicola",
        City: "Bari ",
        HomeTeamName: "Czechoslovakia",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "Costa Rica",
        WinConditions: " ",
        Attendance: 47673,
        RoundID: "rsixteen",
        MatchID: 129,
        HomeTeamInitials: "TCH",
        AwayTeamInitials: "CRC"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.64136,
          45.10942
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "24 Jun 1990 - 17:00 ",
        Stage: "Round of 16",
        Stadium: "Stadio delle Alpi",
        City: "Turin ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Argentina",
        WinConditions: " ",
        Attendance: 61381,
        RoundID: "rsixteen",
        MatchID: 25,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.12388,
          45.47806
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "24 Jun 1990 - 21:00 ",
        Stage: "Round of 16",
        Stadium: "Giuseppe Meazza",
        City: "Milan ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Netherlands",
        WinConditions: " ",
        Attendance: 74559,
        RoundID: "rsixteen",
        MatchID: 196,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "NED"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.95262,
          44.41645
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "25 Jun 1990 - 17:00 ",
        Stage: "Round of 16",
        Stadium: "Luigi Ferraris",
        City: "Genoa ",
        HomeTeamName: "Ireland",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Romania",
        WinConditions: "Republic of Ireland win on penalties (5 - 4) ",
        Attendance: 31818,
        RoundID: "rsixteen",
        MatchID: 248,
        HomeTeamInitials: "IRL",
        AwayTeamInitials: "ROU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.45478,
          41.93396
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "25 Jun 1990 - 21:00 ",
        Stage: "Round of 16",
        Stadium: "Stadio Olimpico",
        City: "Rome ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 73303,
        RoundID: "rsixteen",
        MatchID: 264,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          10.96858,
          45.43525
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "26 Jun 1990 - 17:00 ",
        Stage: "Round of 16",
        Stadium: "Marc Antonio Bentegodi",
        City: "Verona ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Yugoslavia",
        WinConditions: "win after extra time ",
        Attendance: 35500,
        RoundID: "rsixteen",
        MatchID: 181,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "YUG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.31004,
          44.49209
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "26 Jun 1990 - 21:00 ",
        Stage: "Round of 16",
        Stadium: "Renato Dall Ara",
        City: "Bologna ",
        HomeTeamName: "England",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Belgium",
        WinConditions: "win after extra time ",
        Attendance: 34520,
        RoundID: "rsixteen",
        MatchID: 55,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.2826,
          43.7808
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "30 Jun 1990 - 17:00 ",
        Stage: "Quarter-finals",
        Stadium: "Comunale",
        City: "Florence ",
        HomeTeamName: "Yugoslavia",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Argentina",
        WinConditions: "Argentina win on penalties (2 - 3) ",
        Attendance: 38971,
        RoundID: "quart",
        MatchID: 31,
        HomeTeamInitials: "YUG",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.45478,
          41.93396
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "30 Jun 1990 - 21:00 ",
        Stage: "Quarter-finals",
        Stadium: "Stadio Olimpico",
        City: "Rome ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Ireland",
        WinConditions: " ",
        Attendance: 73303,
        RoundID: "quart",
        MatchID: 243,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "IRL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.12388,
          45.47806
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "01 Jul 1990 - 17:00 ",
        Stage: "Quarter-finals",
        Stadium: "Giuseppe Meazza",
        City: "Milan ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Czechoslovakia",
        WinConditions: " ",
        Attendance: 73347,
        RoundID: "quart",
        MatchID: 197,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "TCH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          14.19307,
          40.82781
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "01 Jul 1990 - 21:00 ",
        Stage: "Quarter-finals",
        Stadium: "San Paolo",
        City: "Naples ",
        HomeTeamName: "England",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Cameroon",
        WinConditions: "win after extra time ",
        Attendance: 55205,
        RoundID: "quart",
        MatchID: 103,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "CMR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          14.19307,
          40.82781
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "03 Jul 1990 - 20:00 ",
        Stage: "Semi-finals",
        Stadium: "San Paolo",
        City: "Naples ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Argentina",
        WinConditions: "Argentina win on penalties (3 - 4) ",
        Attendance: 59978,
        RoundID: "semi",
        MatchID: 28,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.64136,
          45.10942
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "04 Jul 1990 - 20:00 ",
        Stage: "Semi-finals",
        Stadium: "Stadio delle Alpi",
        City: "Turin ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "England",
        WinConditions: "Germany FR win on penalties (4 - 3) ",
        Attendance: 62628,
        RoundID: "semi",
        MatchID: 159,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          16.84015,
          41.08463
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "07 Jul 1990 - 20:00 ",
        Stage: "Match for third place",
        Stadium: "Stadio San Nicola",
        City: "Bari ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 51426,
        RoundID: "third",
        MatchID: 162,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.45478,
          41.93396
        ]
      },
      properties: {
        Year: 1990,
        Datetime: "08 Jul 1990 - 20:00 ",
        Stage: "Final",
        Stadium: "Stadio Olimpico",
        City: "Rome ",
        HomeTeamName: "Germany FR",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Argentina",
        WinConditions: " ",
        Attendance: 73603,
        RoundID: "final",
        MatchID: 27,
        HomeTeamInitials: "FRG",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -96.75954,
          32.77954
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "17 Jun 1994 - 19:30 ",
        Stage: "Group C",
        Stadium: "Cotton Bowl",
        City: "Dallas ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Korea Republic",
        WinConditions: " ",
        Attendance: 56247,
        RoundID: "group",
        MatchID: 3050,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "KOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -87.61669,
          41.8622
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "17 Jun 1994 - 15:00 ",
        Stage: "Group C",
        Stadium: "Soldier Field",
        City: "Chicago ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Bolivia",
        WinConditions: " ",
        Attendance: 63117,
        RoundID: "group",
        MatchID: 3049,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "BOL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -83.25457,
          42.6455
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "18 Jun 1994 - 11:30 ",
        Stage: "Group A",
        Stadium: "Pontiac Silverdome",
        City: "Detroit ",
        HomeTeamName: "USA",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Switzerland",
        WinConditions: " ",
        Attendance: 73425,
        RoundID: "group",
        MatchID: 3051,
        HomeTeamInitials: "USA",
        AwayTeamInitials: "SUI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -74.07435,
          40.81344
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "18 Jun 1994 - 16:00 ",
        Stage: "Group E",
        Stadium: "Giants Stadium",
        City: "New York/New Jersey ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Ireland",
        WinConditions: " ",
        Attendance: 75338,
        RoundID: "group",
        MatchID: 3052,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "IRL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -118.16761,
          34.16125
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "18 Jun 1994 - 19:30 ",
        Stage: "Group A",
        Stadium: "Rose Bowl",
        City: "Los Angeles ",
        HomeTeamName: "Colombia",
        HomeTeamGoals: 1,
        AwayTeamGoals: 3,
        AwayTeamName: "Romania",
        WinConditions: " ",
        Attendance: 91856,
        RoundID: "group",
        MatchID: 3053,
        HomeTeamInitials: "COL",
        AwayTeamInitials: "ROU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -81.40278,
          28.53896
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "19 Jun 1994 - 12:30 ",
        Stage: "Group F",
        Stadium: "Citrus Bowl",
        City: "Orlando ",
        HomeTeamName: "Belgium",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Morocco",
        WinConditions: " ",
        Attendance: 61219,
        RoundID: "group",
        MatchID: 3054,
        HomeTeamInitials: "BEL",
        AwayTeamInitials: "MAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -76.97178,
          38.88984
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "19 Jun 1994 - 16:00 ",
        Stage: "Group E",
        Stadium: "RFK Stadium",
        City: "Washington Dc ",
        HomeTeamName: "Norway",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 52395,
        RoundID: "group",
        MatchID: 3055,
        HomeTeamInitials: "NOR",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -118.16761,
          34.16125
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "19 Jun 1994 - 19:30 ",
        Stage: "Group B",
        Stadium: "Rose Bowl",
        City: "Los Angeles ",
        HomeTeamName: "Cameroon",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Sweden",
        WinConditions: " ",
        Attendance: 93194,
        RoundID: "group",
        MatchID: 3056,
        HomeTeamInitials: "CMR",
        AwayTeamInitials: "SWE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -76.97178,
          38.88984
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "20 Jun 1994 - 19:30 ",
        Stage: "Group F",
        Stadium: "RFK Stadium",
        City: "Washington Dc ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Saudi Arabia",
        WinConditions: " ",
        Attendance: 50535,
        RoundID: "group",
        MatchID: 3058,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "KSA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -122.16107,
          37.43446
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "20 Jun 1994 - 16:00 ",
        Stage: "Group B",
        Stadium: "Stanford Stadium",
        City: "San Francisco ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Russia",
        WinConditions: " ",
        Attendance: 81061,
        RoundID: "group",
        MatchID: 3057,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "RUS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -71.26433,
          42.09086
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "21 Jun 1994 - 12:30 ",
        Stage: "Group D",
        Stadium: "Foxboro Stadium",
        City: "Boston ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 4,
        AwayTeamGoals: 0,
        AwayTeamName: "Greece",
        WinConditions: " ",
        Attendance: 54456,
        RoundID: "group",
        MatchID: 3059,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "GRE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -96.75954,
          32.77954
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "21 Jun 1994 - 19:30 ",
        Stage: "Group D",
        Stadium: "Cotton Bowl",
        City: "Dallas ",
        HomeTeamName: "Nigeria",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Bulgaria",
        WinConditions: " ",
        Attendance: 44132,
        RoundID: "group",
        MatchID: 3061,
        HomeTeamInitials: "NGA",
        AwayTeamInitials: "BUL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -87.61669,
          41.8622
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "21 Jun 1994 - 16:00 ",
        Stage: "Group C",
        Stadium: "Soldier Field",
        City: "Chicago ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 63113,
        RoundID: "group",
        MatchID: 3060,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -83.25457,
          42.6455
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "22 Jun 1994 - 16:00 ",
        Stage: "Group A",
        Stadium: "Pontiac Silverdome",
        City: "Detroit ",
        HomeTeamName: "Romania",
        HomeTeamGoals: 1,
        AwayTeamGoals: 4,
        AwayTeamName: "Switzerland",
        WinConditions: " ",
        Attendance: 61428,
        RoundID: "group",
        MatchID: 3062,
        HomeTeamInitials: "ROU",
        AwayTeamInitials: "SUI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -118.16761,
          34.16125
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "22 Jun 1994 - 19:30 ",
        Stage: "Group A",
        Stadium: "Rose Bowl",
        City: "Los Angeles ",
        HomeTeamName: "USA",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Colombia",
        WinConditions: " ",
        Attendance: 93869,
        RoundID: "group",
        MatchID: 3063,
        HomeTeamInitials: "USA",
        AwayTeamInitials: "COL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -74.07435,
          40.81344
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "23 Jun 1994 - 16:00 ",
        Stage: "Group E",
        Stadium: "Giants Stadium",
        City: "New York/New Jersey ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Norway",
        WinConditions: " ",
        Attendance: 74624,
        RoundID: "group",
        MatchID: 3064,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "NOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -71.26433,
          42.09086
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "23 Jun 1994 - 19:30 ",
        Stage: "Group C",
        Stadium: "Foxboro Stadium",
        City: "Boston ",
        HomeTeamName: "Korea Republic",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Bolivia",
        WinConditions: " ",
        Attendance: 54453,
        RoundID: "group",
        MatchID: 3065,
        HomeTeamInitials: "KOR",
        AwayTeamInitials: "BOL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -81.40278,
          28.53896
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "24 Jun 1994 - 12:30 ",
        Stage: "Group E",
        Stadium: "Citrus Bowl",
        City: "Orlando ",
        HomeTeamName: "Mexico",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Ireland",
        WinConditions: " ",
        Attendance: 60790,
        RoundID: "group",
        MatchID: 3066,
        HomeTeamInitials: "MEX",
        AwayTeamInitials: "IRL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -83.25457,
          42.6455
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "24 Jun 1994 - 19:30 ",
        Stage: "Group B",
        Stadium: "Pontiac Silverdome",
        City: "Detroit ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Russia",
        WinConditions: " ",
        Attendance: 71528,
        RoundID: "group",
        MatchID: 3068,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "RUS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -122.16107,
          37.43446
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "24 Jun 1994 - 16:00 ",
        Stage: "Group B",
        Stadium: "Stanford Stadium",
        City: "San Francisco ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Cameroon",
        WinConditions: " ",
        Attendance: 83401,
        RoundID: "group",
        MatchID: 3067,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "CMR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -81.40278,
          28.53896
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "25 Jun 1994 - 12:30 ",
        Stage: "Group F",
        Stadium: "Citrus Bowl",
        City: "Orlando ",
        HomeTeamName: "Belgium",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Netherlands",
        WinConditions: " ",
        Attendance: 62387,
        RoundID: "group",
        MatchID: 3069,
        HomeTeamInitials: "BEL",
        AwayTeamInitials: "NED"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -74.07435,
          40.81344
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "25 Jun 1994 - 12:30 ",
        Stage: "Group F",
        Stadium: "Giants Stadium",
        City: "New York/New Jersey ",
        HomeTeamName: "Saudi Arabia",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Morocco",
        WinConditions: " ",
        Attendance: 76322,
        RoundID: "group",
        MatchID: 3070,
        HomeTeamInitials: "KSA",
        AwayTeamInitials: "MAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -71.26433,
          42.09086
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "25 Jun 1994 - 16:00 ",
        Stage: "Group D",
        Stadium: "Foxboro Stadium",
        City: "Boston ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Nigeria",
        WinConditions: " ",
        Attendance: 54453,
        RoundID: "group",
        MatchID: 3071,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "NGA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -87.61669,
          41.8622
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "26 Jun 1994 - 12:30 ",
        Stage: "Group D",
        Stadium: "Soldier Field",
        City: "Chicago ",
        HomeTeamName: "Bulgaria",
        HomeTeamGoals: 4,
        AwayTeamGoals: 0,
        AwayTeamName: "Greece",
        WinConditions: " ",
        Attendance: 63160,
        RoundID: "group",
        MatchID: 3072,
        HomeTeamInitials: "BUL",
        AwayTeamInitials: "GRE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -118.16761,
          34.16125
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "26 Jun 1994 - 16:00 ",
        Stage: "Group A",
        Stadium: "Rose Bowl",
        City: "Los Angeles ",
        HomeTeamName: "USA",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Romania",
        WinConditions: " ",
        Attendance: 93869,
        RoundID: "group",
        MatchID: 3073,
        HomeTeamInitials: "USA",
        AwayTeamInitials: "ROU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -122.16107,
          37.43446
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "26 Jun 1994 - 16:00 ",
        Stage: "Group A",
        Stadium: "Stanford Stadium",
        City: "San Francisco ",
        HomeTeamName: "Switzerland",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Colombia",
        WinConditions: " ",
        Attendance: 83401,
        RoundID: "group",
        MatchID: 3074,
        HomeTeamInitials: "SUI",
        AwayTeamInitials: "COL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -96.75954,
          32.77954
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "27 Jun 1994 - 16:00 ",
        Stage: "Group C",
        Stadium: "Cotton Bowl",
        City: "Dallas ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Korea Republic",
        WinConditions: " ",
        Attendance: 63998,
        RoundID: "group",
        MatchID: 3076,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "KOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -87.61669,
          41.8622
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "27 Jun 1994 - 16:00 ",
        Stage: "Group C",
        Stadium: "Soldier Field",
        City: "Chicago ",
        HomeTeamName: "Bolivia",
        HomeTeamGoals: 1,
        AwayTeamGoals: 3,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 63089,
        RoundID: "group",
        MatchID: 3075,
        HomeTeamInitials: "BOL",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -74.07435,
          40.81344
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "28 Jun 1994 - 12:30 ",
        Stage: "Group E",
        Stadium: "Giants Stadium",
        City: "New York/New Jersey ",
        HomeTeamName: "Ireland",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Norway",
        WinConditions: " ",
        Attendance: 72404,
        RoundID: "group",
        MatchID: 3077,
        HomeTeamInitials: "IRL",
        AwayTeamInitials: "NOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -83.25457,
          42.6455
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "28 Jun 1994 - 16:00 ",
        Stage: "Group B",
        Stadium: "Pontiac Silverdome",
        City: "Detroit ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Sweden",
        WinConditions: " ",
        Attendance: 77217,
        RoundID: "group",
        MatchID: 3080,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "SWE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -76.97178,
          38.88984
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "28 Jun 1994 - 12:30 ",
        Stage: "Group E",
        Stadium: "RFK Stadium",
        City: "Washington Dc ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 52535,
        RoundID: "group",
        MatchID: 3078,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -122.16107,
          37.43446
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "28 Jun 1994 - 16:00 ",
        Stage: "Group B",
        Stadium: "Stanford Stadium",
        City: "San Francisco ",
        HomeTeamName: "Russia",
        HomeTeamGoals: 6,
        AwayTeamGoals: 1,
        AwayTeamName: "Cameroon",
        WinConditions: " ",
        Attendance: 74914,
        RoundID: "group",
        MatchID: 3079,
        HomeTeamInitials: "RUS",
        AwayTeamInitials: "CMR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -81.40278,
          28.53896
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "29 Jun 1994 - 12:30 ",
        Stage: "Group F",
        Stadium: "Citrus Bowl",
        City: "Orlando ",
        HomeTeamName: "Morocco",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Netherlands",
        WinConditions: " ",
        Attendance: 60578,
        RoundID: "group",
        MatchID: 3081,
        HomeTeamInitials: "MAR",
        AwayTeamInitials: "NED"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -76.97178,
          38.88984
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "29 Jun 1994 - 12:30 ",
        Stage: "Group F",
        Stadium: "RFK Stadium",
        City: "Washington Dc ",
        HomeTeamName: "Belgium",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Saudi Arabia",
        WinConditions: " ",
        Attendance: 52959,
        RoundID: "group",
        MatchID: 3082,
        HomeTeamInitials: "BEL",
        AwayTeamInitials: "KSA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -71.26433,
          42.09086
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "30 Jun 1994 - 19:30 ",
        Stage: "Group D",
        Stadium: "Foxboro Stadium",
        City: "Boston ",
        HomeTeamName: "Greece",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Nigeria",
        WinConditions: " ",
        Attendance: 53001,
        RoundID: "group",
        MatchID: 3083,
        HomeTeamInitials: "GRE",
        AwayTeamInitials: "NGA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -96.75954,
          32.77954
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "30 Jun 1994 - 19:30 ",
        Stage: "Group D",
        Stadium: "Cotton Bowl",
        City: "Dallas ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Bulgaria",
        WinConditions: " ",
        Attendance: 63998,
        RoundID: "group",
        MatchID: 3084,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "BUL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -87.61669,
          41.8622
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "02 Jul 1994 - 12:00 ",
        Stage: "Round of 16",
        Stadium: "Soldier Field",
        City: "Chicago ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Belgium",
        WinConditions: " ",
        Attendance: 60246,
        RoundID: "rsixteen",
        MatchID: 3085,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -76.97178,
          38.88984
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "02 Jul 1994 - 16:30 ",
        Stage: "Round of 16",
        Stadium: "RFK Stadium",
        City: "Washington Dc ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Switzerland",
        WinConditions: " ",
        Attendance: 53121,
        RoundID: "rsixteen",
        MatchID: 3086,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "SUI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -96.75954,
          32.77954
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "03 Jul 1994 - 12:00 ",
        Stage: "Round of 16",
        Stadium: "Cotton Bowl",
        City: "Dallas ",
        HomeTeamName: "Saudi Arabia",
        HomeTeamGoals: 1,
        AwayTeamGoals: 3,
        AwayTeamName: "Sweden",
        WinConditions: " ",
        Attendance: 60277,
        RoundID: "rsixteen",
        MatchID: 3087,
        HomeTeamInitials: "KSA",
        AwayTeamInitials: "SWE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -118.16761,
          34.16125
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "03 Jul 1994 - 13:30 ",
        Stage: "Round of 16",
        Stadium: "Rose Bowl",
        City: "Los Angeles ",
        HomeTeamName: "Romania",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Argentina",
        WinConditions: " ",
        Attendance: 90469,
        RoundID: "rsixteen",
        MatchID: 3088,
        HomeTeamInitials: "ROU",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -81.40278,
          28.53896
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "04 Jul 1994 - 12:00 ",
        Stage: "Round of 16",
        Stadium: "Citrus Bowl",
        City: "Orlando ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Ireland",
        WinConditions: " ",
        Attendance: 61355,
        RoundID: "rsixteen",
        MatchID: 3089,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "IRL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -122.16107,
          37.43446
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "04 Jul 1994 - 12:30 ",
        Stage: "Round of 16",
        Stadium: "Stanford Stadium",
        City: "San Francisco ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "USA",
        WinConditions: " ",
        Attendance: 84147,
        RoundID: "rsixteen",
        MatchID: 3090,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "USA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -71.26433,
          42.09086
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "05 Jul 1994 - 13:00 ",
        Stage: "Round of 16",
        Stadium: "Foxboro Stadium",
        City: "Boston ",
        HomeTeamName: "Nigeria",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Italy",
        WinConditions: "Iwin after extra time ",
        Attendance: 54367,
        RoundID: "rsixteen",
        MatchID: 3091,
        HomeTeamInitials: "NGA",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -74.07435,
          40.81344
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "05 Jul 1994 - 16:30 ",
        Stage: "Round of 16",
        Stadium: "Giants Stadium",
        City: "New York/New Jersey ",
        HomeTeamName: "Mexico",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Bulgaria",
        WinConditions: "Bulgaria win on penalties (1 - 3) ",
        Attendance: 71030,
        RoundID: "rsixteen",
        MatchID: 3092,
        HomeTeamInitials: "MEX",
        AwayTeamInitials: "BUL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -71.26433,
          42.09086
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "09 Jul 1994 - 12:00 ",
        Stage: "Quarter-finals",
        Stadium: "Foxboro Stadium",
        City: "Boston ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 53400,
        RoundID: "quart",
        MatchID: 3097,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -96.75954,
          32.77954
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "09 Jul 1994 - 14:30 ",
        Stage: "Quarter-finals",
        Stadium: "Cotton Bowl",
        City: "Dallas ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 2,
        AwayTeamGoals: 3,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 63500,
        RoundID: "quart",
        MatchID: 3098,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -74.07435,
          40.81344
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "10 Jul 1994 - 12:00 ",
        Stage: "Quarter-finals",
        Stadium: "Giants Stadium",
        City: "New York/New Jersey ",
        HomeTeamName: "Bulgaria",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Germany",
        WinConditions: " ",
        Attendance: 72000,
        RoundID: "quart",
        MatchID: 3096,
        HomeTeamInitials: "BUL",
        AwayTeamInitials: "GER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -122.16107,
          37.43446
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "10 Jul 1994 - 12:30 ",
        Stage: "Quarter-finals",
        Stadium: "Stanford Stadium",
        City: "San Francisco ",
        HomeTeamName: "Romania",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Sweden",
        WinConditions: "Sweden win on penalties (4 - 5) ",
        Attendance: 83500,
        RoundID: "quart",
        MatchID: 3095,
        HomeTeamInitials: "ROU",
        AwayTeamInitials: "SWE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -74.07435,
          40.81344
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "13 Jul 1994 - 16:00 ",
        Stage: "Semi-finals",
        Stadium: "Giants Stadium",
        City: "New York/New Jersey ",
        HomeTeamName: "Bulgaria",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 74110,
        RoundID: "semi",
        MatchID: 3100,
        HomeTeamInitials: "BUL",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -118.16761,
          34.16125
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "13 Jul 1994 - 16:30 ",
        Stage: "Semi-finals",
        Stadium: "Rose Bowl",
        City: "Los Angeles ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 91856,
        RoundID: "semi",
        MatchID: 3099,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -118.16761,
          34.16125
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "16 Jul 1994 - 12:30 ",
        Stage: "Match for third place",
        Stadium: "Rose Bowl",
        City: "Los Angeles ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 4,
        AwayTeamGoals: 0,
        AwayTeamName: "Bulgaria",
        WinConditions: " ",
        Attendance: 91500,
        RoundID: "third",
        MatchID: 3103,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "BUL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -118.16761,
          34.16125
        ]
      },
      properties: {
        Year: 1994,
        Datetime: "17 Jul 1994 - 12:30 ",
        Stage: "Final",
        Stadium: "Rose Bowl",
        City: "Los Angeles ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Italy",
        WinConditions: "Brazil win on penalties (3 - 2) ",
        Attendance: 94194,
        RoundID: "final",
        MatchID: 3104,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.36021,
          48.92409
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "10 Jun 1998 - 17:30 ",
        Stage: "Group A",
        Stadium: "Stade de France",
        City: "Saint-Denis ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Scotland",
        WinConditions: " ",
        Attendance: 80000,
        RoundID: "group",
        MatchID: 4000,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "SCO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          3.81218,
          43.62202
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "10 Jun 1998 - 21:00 ",
        Stage: "Group A",
        Stadium: "La Mosson",
        City: "Montpellier ",
        HomeTeamName: "Morocco",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Norway",
        WinConditions: " ",
        Attendance: 29800,
        RoundID: "group",
        MatchID: 8725,
        HomeTeamInitials: "MAR",
        AwayTeamInitials: "NOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.59838,
          44.82911
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "11 Jun 1998 - 17:30 ",
        Stage: "Group B",
        Stadium: "Stade du Parc Lescure",
        City: "Bordeaux ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Chile",
        WinConditions: " ",
        Attendance: 31800,
        RoundID: "group",
        MatchID: 8726,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "CHI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          1.43411,
          43.58321
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "11 Jun 1998 - 21:00 ",
        Stage: "Group B",
        Stadium: "Stade Municipal",
        City: "Toulouse ",
        HomeTeamName: "Cameroon",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Austria",
        WinConditions: " ",
        Attendance: 33500,
        RoundID: "group",
        MatchID: 8727,
        HomeTeamInitials: "CMR",
        AwayTeamInitials: "AUT"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          3.81218,
          43.62202
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "12 Jun 1998 - 14:30 ",
        Stage: "Group D",
        Stadium: "La Mosson",
        City: "Montpellier ",
        HomeTeamName: "Paraguay",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Bulgaria",
        WinConditions: " ",
        Attendance: 29800,
        RoundID: "group",
        MatchID: 8728,
        HomeTeamInitials: "PAR",
        AwayTeamInitials: "BUL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.81495,
          50.43285
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "12 Jun 1998 - 17:30 ",
        Stage: "Group C",
        Stadium: "Stade Felix Bollaert",
        City: "Lens ",
        HomeTeamName: "Saudi Arabia",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Denmark",
        WinConditions: " ",
        Attendance: 38100,
        RoundID: "group",
        MatchID: 8729,
        HomeTeamInitials: "KSA",
        AwayTeamInitials: "DEN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          5.39612,
          43.26962
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "12 Jun 1998 - 21:00 ",
        Stage: "Group C",
        Stadium: "Stade Velodrome",
        City: "Marseilles ",
        HomeTeamName: "France",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "South Africa",
        WinConditions: " ",
        Attendance: 55000,
        RoundID: "group",
        MatchID: 8730,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "RSA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.52466,
          47.25594
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "13 Jun 1998 - 14:30 ",
        Stage: "Group D",
        Stadium: "La Beaujoire",
        City: "Nantes ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 2,
        AwayTeamGoals: 3,
        AwayTeamName: "Nigeria",
        WinConditions: " ",
        Attendance: 35500,
        RoundID: "group",
        MatchID: 8731,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "NGA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          4.83213,
          45.72356
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "13 Jun 1998 - 17:30 ",
        Stage: "Group E",
        Stadium: "Stade de Gerland",
        City: "Lyon ",
        HomeTeamName: "Korea Republic",
        HomeTeamGoals: 1,
        AwayTeamGoals: 3,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 39100,
        RoundID: "group",
        MatchID: 8732,
        HomeTeamInitials: "KOR",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.36021,
          48.92409
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "13 Jun 1998 - 21:00 ",
        Stage: "Group E",
        Stadium: "Stade de France",
        City: "Saint-Denis ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Belgium",
        WinConditions: " ",
        Attendance: 77000,
        RoundID: "group",
        MatchID: 8733,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          1.43411,
          43.58321
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "14 Jun 1998 - 14:30 ",
        Stage: "Group H",
        Stadium: "Stade Municipal",
        City: "Toulouse ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Japan",
        WinConditions: " ",
        Attendance: 33500,
        RoundID: "group",
        MatchID: 8734,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "JPN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          4.39013,
          45.46066
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "14 Jun 1998 - 17:30 ",
        Stage: "Group F",
        Stadium: "Stade Geoffroy Guichard",
        City: "Saint-Etienne ",
        HomeTeamName: "Yugoslavia",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Iran",
        WinConditions: " ",
        Attendance: 30600,
        RoundID: "group",
        MatchID: 8735,
        HomeTeamInitials: "YUG",
        AwayTeamInitials: "IRN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.81495,
          50.43285
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "14 Jun 1998 - 21:00 ",
        Stage: "Group H",
        Stadium: "Stade Felix Bollaert",
        City: "Lens ",
        HomeTeamName: "Jamaica",
        HomeTeamGoals: 1,
        AwayTeamGoals: 3,
        AwayTeamName: "Croatia",
        WinConditions: " ",
        Attendance: 38100,
        RoundID: "group",
        MatchID: 8736,
        HomeTeamInitials: "JAM",
        AwayTeamInitials: "CRO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          5.39612,
          43.26962
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "15 Jun 1998 - 14:30 ",
        Stage: "Group G",
        Stadium: "Stade Velodrome",
        City: "Marseilles ",
        HomeTeamName: "England",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Tunisia",
        WinConditions: " ",
        Attendance: 55000,
        RoundID: "group",
        MatchID: 8740,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "TUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          4.83213,
          45.72356
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "15 Jun 1998 - 17:30 ",
        Stage: "Group G",
        Stadium: "Stade de Gerland",
        City: "Lyon ",
        HomeTeamName: "Romania",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Colombia",
        WinConditions: " ",
        Attendance: 39100,
        RoundID: "group",
        MatchID: 8739,
        HomeTeamInitials: "ROU",
        AwayTeamInitials: "COL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.25295,
          48.84138
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "15 Jun 1998 - 21:00 ",
        Stage: "Group F",
        Stadium: "Parc des Princes",
        City: "Paris ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "USA",
        WinConditions: " ",
        Attendance: 45500,
        RoundID: "group",
        MatchID: 8738,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "USA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.59838,
          44.82911
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "16 Jun 1998 - 17:30 ",
        Stage: "Group A",
        Stadium: "Stade du Parc Lescure",
        City: "Bordeaux ",
        HomeTeamName: "Scotland",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Norway",
        WinConditions: " ",
        Attendance: 31800,
        RoundID: "group",
        MatchID: 8741,
        HomeTeamInitials: "SCO",
        AwayTeamInitials: "NOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.52466,
          47.25594
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "16 Jun 1998 - 21:00 ",
        Stage: "Group A",
        Stadium: "La Beaujoire",
        City: "Nantes ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Morocco",
        WinConditions: " ",
        Attendance: 35500,
        RoundID: "group",
        MatchID: 8742,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "MAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          4.39013,
          45.46066
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "17 Jun 1998 - 17:30 ",
        Stage: "Group B",
        Stadium: "Stade Geoffroy Guichard",
        City: "Saint-Etienne ",
        HomeTeamName: "Chile",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Austria",
        WinConditions: " ",
        Attendance: 30600,
        RoundID: "group",
        MatchID: 8743,
        HomeTeamInitials: "CHI",
        AwayTeamInitials: "AUT"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          3.81218,
          43.62202
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "17 Jun 1998 - 21:00 ",
        Stage: "Group B",
        Stadium: "La Mosson",
        City: "Montpellier ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Cameroon",
        WinConditions: " ",
        Attendance: 29800,
        RoundID: "group",
        MatchID: 8744,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "CMR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          1.43411,
          43.58321
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "18 Jun 1998 - 17:30 ",
        Stage: "Group C",
        Stadium: "Stade Municipal",
        City: "Toulouse ",
        HomeTeamName: "South Africa",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Denmark",
        WinConditions: " ",
        Attendance: 33500,
        RoundID: "group",
        MatchID: 8746,
        HomeTeamInitials: "RSA",
        AwayTeamInitials: "DEN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.36021,
          48.92409
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "18 Jun 1998 - 21:00 ",
        Stage: "Group C",
        Stadium: "Stade de France",
        City: "Saint-Denis ",
        HomeTeamName: "France",
        HomeTeamGoals: 4,
        AwayTeamGoals: 0,
        AwayTeamName: "Saudi Arabia",
        WinConditions: " ",
        Attendance: 80000,
        RoundID: "group",
        MatchID: 8745,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "KSA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.25295,
          48.84138
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "19 Jun 1998 - 17:30 ",
        Stage: "Group D",
        Stadium: "Parc des Princes",
        City: "Paris ",
        HomeTeamName: "Nigeria",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Bulgaria",
        WinConditions: " ",
        Attendance: 45500,
        RoundID: "group",
        MatchID: 8747,
        HomeTeamInitials: "NGA",
        AwayTeamInitials: "BUL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          4.39013,
          45.46066
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "19 Jun 1998 - 21:00 ",
        Stage: "Group D",
        Stadium: "Stade Geoffroy Guichard",
        City: "Saint-Etienne ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Paraguay",
        WinConditions: " ",
        Attendance: 30600,
        RoundID: "group",
        MatchID: 8748,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "PAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.52466,
          47.25594
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "20 Jun 1998 - 14:30 ",
        Stage: "Group H",
        Stadium: "La Beaujoire",
        City: "Nantes ",
        HomeTeamName: "Japan",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Croatia",
        WinConditions: " ",
        Attendance: 35500,
        RoundID: "group",
        MatchID: 8751,
        HomeTeamInitials: "JPN",
        AwayTeamInitials: "CRO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.59838,
          44.82911
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "20 Jun 1998 - 17:30 ",
        Stage: "Group E",
        Stadium: "Stade du Parc Lescure",
        City: "Bordeaux ",
        HomeTeamName: "Belgium",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 31800,
        RoundID: "group",
        MatchID: 8750,
        HomeTeamInitials: "BEL",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          5.39612,
          43.26962
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "20 Jun 1998 - 21:00 ",
        Stage: "Group E",
        Stadium: "Stade Velodrome",
        City: "Marseilles ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 5,
        AwayTeamGoals: 0,
        AwayTeamName: "Korea Republic",
        WinConditions: " ",
        Attendance: 55000,
        RoundID: "group",
        MatchID: 8749,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "KOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.81495,
          50.43285
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "21 Jun 1998 - 14:30 ",
        Stage: "Group F",
        Stadium: "Stade Felix Bollaert",
        City: "Lens ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Yugoslavia",
        WinConditions: " ",
        Attendance: 38100,
        RoundID: "group",
        MatchID: 8753,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "YUG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.25295,
          48.84138
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "21 Jun 1998 - 17:30 ",
        Stage: "Group H",
        Stadium: "Parc des Princes",
        City: "Paris ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 5,
        AwayTeamGoals: 0,
        AwayTeamName: "Jamaica",
        WinConditions: " ",
        Attendance: 45500,
        RoundID: "group",
        MatchID: 8752,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "JAM"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          4.83213,
          45.72356
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "21 Jun 1998 - 21:00 ",
        Stage: "Group F",
        Stadium: "Stade de Gerland",
        City: "Lyon ",
        HomeTeamName: "USA",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Iran",
        WinConditions: " ",
        Attendance: 39100,
        RoundID: "group",
        MatchID: 8754,
        HomeTeamInitials: "USA",
        AwayTeamInitials: "IRN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          3.81218,
          43.62202
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "22 Jun 1998 - 17:30 ",
        Stage: "Group G",
        Stadium: "La Mosson",
        City: "Montpellier ",
        HomeTeamName: "Colombia",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Tunisia",
        WinConditions: " ",
        Attendance: 29800,
        RoundID: "group",
        MatchID: 8755,
        HomeTeamInitials: "COL",
        AwayTeamInitials: "TUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          1.43411,
          43.58321
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "22 Jun 1998 - 21:00 ",
        Stage: "Group G",
        Stadium: "Stade Municipal",
        City: "Toulouse ",
        HomeTeamName: "Romania",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 33500,
        RoundID: "group",
        MatchID: 8756,
        HomeTeamInitials: "ROU",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.36021,
          48.92409
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "23 Jun 1998 - 16:00 ",
        Stage: "Group B",
        Stadium: "Stade de France",
        City: "Saint-Denis ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Austria",
        WinConditions: " ",
        Attendance: 80000,
        RoundID: "group",
        MatchID: 8757,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "AUT"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.52466,
          47.25594
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "23 Jun 1998 - 16:00 ",
        Stage: "Group B",
        Stadium: "La Beaujoire",
        City: "Nantes ",
        HomeTeamName: "Chile",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Cameroon",
        WinConditions: " ",
        Attendance: 35500,
        RoundID: "group",
        MatchID: 8760,
        HomeTeamInitials: "CHI",
        AwayTeamInitials: "CMR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          4.39013,
          45.46066
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "23 Jun 1998 - 21:00 ",
        Stage: "Group A",
        Stadium: "Stade Geoffroy Guichard",
        City: "Saint-Etienne ",
        HomeTeamName: "Scotland",
        HomeTeamGoals: 0,
        AwayTeamGoals: 3,
        AwayTeamName: "Morocco",
        WinConditions: " ",
        Attendance: 30600,
        RoundID: "group",
        MatchID: 8758,
        HomeTeamInitials: "SCO",
        AwayTeamInitials: "MAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          5.39612,
          43.26962
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "23 Jun 1998 - 21:00 ",
        Stage: "Group A",
        Stadium: "Stade Velodrome",
        City: "Marseilles ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Norway",
        WinConditions: " ",
        Attendance: 55000,
        RoundID: "group",
        MatchID: 8759,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "NOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          4.83213,
          45.72356
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "24 Jun 1998 - 16:00 ",
        Stage: "Group C",
        Stadium: "Stade de Gerland",
        City: "Lyon ",
        HomeTeamName: "France",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Denmark",
        WinConditions: " ",
        Attendance: 39100,
        RoundID: "group",
        MatchID: 8762,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "DEN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.59838,
          44.82911
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "24 Jun 1998 - 16:00 ",
        Stage: "Group C",
        Stadium: "Stade du Parc Lescure",
        City: "Bordeaux ",
        HomeTeamName: "South Africa",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Saudi Arabia",
        WinConditions: " ",
        Attendance: 31800,
        RoundID: "group",
        MatchID: 8764,
        HomeTeamInitials: "RSA",
        AwayTeamInitials: "KSA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.81495,
          50.43285
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "24 Jun 1998 - 21:00 ",
        Stage: "Group D",
        Stadium: "Stade Felix Bollaert",
        City: "Lens ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 6,
        AwayTeamGoals: 1,
        AwayTeamName: "Bulgaria",
        WinConditions: " ",
        Attendance: 38100,
        RoundID: "group",
        MatchID: 8761,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "BUL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          1.43411,
          43.58321
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "24 Jun 1998 - 21:00 ",
        Stage: "Group D",
        Stadium: "Stade Municipal",
        City: "Toulouse ",
        HomeTeamName: "Nigeria",
        HomeTeamGoals: 1,
        AwayTeamGoals: 3,
        AwayTeamName: "Paraguay",
        WinConditions: " ",
        Attendance: 33500,
        RoundID: "group",
        MatchID: 8763,
        HomeTeamInitials: "NGA",
        AwayTeamInitials: "PAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.25295,
          48.84138
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "25 Jun 1998 - 16:00 ",
        Stage: "Group E",
        Stadium: "Parc des Princes",
        City: "Paris ",
        HomeTeamName: "Belgium",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Korea Republic",
        WinConditions: " ",
        Attendance: 45500,
        RoundID: "group",
        MatchID: 8765,
        HomeTeamInitials: "BEL",
        AwayTeamInitials: "KOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          4.39013,
          45.46066
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "25 Jun 1998 - 16:00 ",
        Stage: "Group E",
        Stadium: "Stade Geoffroy Guichard",
        City: "Saint-Etienne ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 30600,
        RoundID: "group",
        MatchID: 8766,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          3.81218,
          43.62202
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "25 Jun 1998 - 21:00 ",
        Stage: "Group F",
        Stadium: "La Mosson",
        City: "Montpellier ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Iran",
        WinConditions: " ",
        Attendance: 29800,
        RoundID: "group",
        MatchID: 8767,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "IRN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.52466,
          47.25594
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "25 Jun 1998 - 21:00 ",
        Stage: "Group F",
        Stadium: "La Beaujoire",
        City: "Nantes ",
        HomeTeamName: "USA",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Yugoslavia",
        WinConditions: " ",
        Attendance: 35500,
        RoundID: "group",
        MatchID: 8768,
        HomeTeamInitials: "USA",
        AwayTeamInitials: "YUG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          4.83213,
          45.72356
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "26 Jun 1998 - 16:00 ",
        Stage: "Group H",
        Stadium: "Stade de Gerland",
        City: "Lyon ",
        HomeTeamName: "Japan",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Jamaica",
        WinConditions: " ",
        Attendance: 39100,
        RoundID: "group",
        MatchID: 8771,
        HomeTeamInitials: "JPN",
        AwayTeamInitials: "JAM"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.59838,
          44.82911
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "26 Jun 1998 - 16:00 ",
        Stage: "Group H",
        Stadium: "Stade du Parc Lescure",
        City: "Bordeaux ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Croatia",
        WinConditions: " ",
        Attendance: 31800,
        RoundID: "group",
        MatchID: 8772,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "CRO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.36021,
          48.92409
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "26 Jun 1998 - 21:00 ",
        Stage: "Group G",
        Stadium: "Stade de France",
        City: "Saint-Denis ",
        HomeTeamName: "Romania",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Tunisia",
        WinConditions: " ",
        Attendance: 77000,
        RoundID: "group",
        MatchID: 8769,
        HomeTeamInitials: "ROU",
        AwayTeamInitials: "TUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.81495,
          50.43285
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "26 Jun 1998 - 21:00 ",
        Stage: "Group G",
        Stadium: "Stade Felix Bollaert",
        City: "Lens ",
        HomeTeamName: "Colombia",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 38100,
        RoundID: "group",
        MatchID: 8770,
        HomeTeamInitials: "COL",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          5.39612,
          43.26962
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "27 Jun 1998 - 16:30 ",
        Stage: "Round of 16",
        Stadium: "Stade Velodrome",
        City: "Marseilles ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Norway",
        WinConditions: " ",
        Attendance: 55000,
        RoundID: "rsixteen",
        MatchID: 8774,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "NOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.25295,
          48.84138
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "27 Jun 1998 - 21:00 ",
        Stage: "Round of 16",
        Stadium: "Parc des Princes",
        City: "Paris ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "Chile",
        WinConditions: " ",
        Attendance: 45500,
        RoundID: "rsixteen",
        MatchID: 8773,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "CHI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.81495,
          50.43285
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "28 Jun 1998 - 16:30 ",
        Stage: "Round of 16",
        Stadium: "Stade Felix Bollaert",
        City: "Lens ",
        HomeTeamName: "France",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Paraguay",
        WinConditions: "win after extra time ",
        Attendance: 31800,
        RoundID: "rsixteen",
        MatchID: 8776,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "PAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.36021,
          48.92409
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "28 Jun 1998 - 21:00 ",
        Stage: "Round of 16",
        Stadium: "Stade de France",
        City: "Saint-Denis ",
        HomeTeamName: "Nigeria",
        HomeTeamGoals: 1,
        AwayTeamGoals: 4,
        AwayTeamName: "Denmark",
        WinConditions: " ",
        Attendance: 77000,
        RoundID: "rsixteen",
        MatchID: 8775,
        HomeTeamInitials: "NGA",
        AwayTeamInitials: "DEN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          3.81218,
          43.62202
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "29 Jun 1998 - 16:30 ",
        Stage: "Round of 16",
        Stadium: "La Mosson",
        City: "Montpellier ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 29800,
        RoundID: "rsixteen",
        MatchID: 8777,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          1.43411,
          43.58321
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "29 Jun 1998 - 21:00 ",
        Stage: "Round of 16",
        Stadium: "Stade Municipal",
        City: "Toulouse ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Yugoslavia",
        WinConditions: " ",
        Attendance: 33500,
        RoundID: "rsixteen",
        MatchID: 8778,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "YUG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -0.59838,
          44.82911
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "30 Jun 1998 - 16:30 ",
        Stage: "Round of 16",
        Stadium: "Stade du Parc Lescure",
        City: "Bordeaux ",
        HomeTeamName: "Romania",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Croatia",
        WinConditions: " ",
        Attendance: 31800,
        RoundID: "rsixteen",
        MatchID: 8780,
        HomeTeamInitials: "ROU",
        AwayTeamInitials: "CRO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          4.39013,
          45.46066
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "30 Jun 1998 - 21:00 ",
        Stage: "Round of 16",
        Stadium: "Stade Geoffroy Guichard",
        City: "Saint-Etienne ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "England",
        WinConditions: "Argentina win on penalties (4 - 3) ",
        Attendance: 30600,
        RoundID: "rsixteen",
        MatchID: 8779,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.36021,
          48.92409
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "03 Jul 1998 - 16:30 ",
        Stage: "Quarter-finals",
        Stadium: "Stade de France",
        City: "Saint-Denis ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "France",
        WinConditions: "France win on penalties (3 - 4) ",
        Attendance: 77000,
        RoundID: "quart",
        MatchID: 8781,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -1.52466,
          47.25594
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "03 Jul 1998 - 21:00 ",
        Stage: "Quarter-finals",
        Stadium: "La Beaujoire",
        City: "Nantes ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Denmark",
        WinConditions: " ",
        Attendance: 35500,
        RoundID: "quart",
        MatchID: 8782,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "DEN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          5.39612,
          43.26962
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "04 Jul 1998 - 16:30 ",
        Stage: "Quarter-finals",
        Stadium: "Stade Velodrome",
        City: "Marseilles ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Argentina",
        WinConditions: " ",
        Attendance: 55000,
        RoundID: "quart",
        MatchID: 8784,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          4.83213,
          45.72356
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "04 Jul 1998 - 21:00 ",
        Stage: "Quarter-finals",
        Stadium: "Stade de Gerland",
        City: "Lyon ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 0,
        AwayTeamGoals: 3,
        AwayTeamName: "Croatia",
        WinConditions: " ",
        Attendance: 39100,
        RoundID: "quart",
        MatchID: 8783,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "CRO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          5.39612,
          43.26962
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "07 Jul 1998 - 21:00 ",
        Stage: "Semi-finals",
        Stadium: "Stade Velodrome",
        City: "Marseilles ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Netherlands",
        WinConditions: "Brazil win on penalties (4 - 2) ",
        Attendance: 54000,
        RoundID: "semi",
        MatchID: 8785,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "NED"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.36021,
          48.92409
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "08 Jul 1998 - 21:00 ",
        Stage: "Semi-finals",
        Stadium: "Stade de France",
        City: "Saint-Denis ",
        HomeTeamName: "France",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Croatia",
        WinConditions: " ",
        Attendance: 76000,
        RoundID: "semi",
        MatchID: 8786,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "CRO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.25295,
          48.84138
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "11 Jul 1998 - 21:00 ",
        Stage: "Match for third place",
        Stadium: "Parc des Princes",
        City: "Paris ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Croatia",
        WinConditions: " ",
        Attendance: 45500,
        RoundID: "third",
        MatchID: 8787,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "CRO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          2.36021,
          48.92409
        ]
      },
      properties: {
        Year: 1998,
        Datetime: "12 Jul 1998 - 21:00 ",
        Stage: "Final",
        Stadium: "Stade de France",
        City: "Saint-Denis ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 0,
        AwayTeamGoals: 3,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 80000,
        RoundID: "final",
        MatchID: 8788,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          126.89707,
          37.56817
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "31 May 2002 - 20:30 ",
        Stage: "Group A",
        Stadium: "Seoul World Cup Stadium",
        City: "Seoul ",
        HomeTeamName: "France",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Senegal",
        WinConditions: " ",
        Attendance: 62561,
        RoundID: "group",
        MatchID: 43950001,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "SEN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          129.25935,
          35.53536
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "01 Jun 2002 - 18:00 ",
        Stage: "Group A",
        Stadium: "Munsu Football Stadium",
        City: "Ulsan ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Denmark",
        WinConditions: " ",
        Attendance: 30157,
        RoundID: "group",
        MatchID: 43950003,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "DEN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          139.05917,
          37.88248
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "01 Jun 2002 - 15:30 ",
        Stage: "Group E",
        Stadium: "Niigata Stadium Big Swan",
        City: "Niigata ",
        HomeTeamName: "Ireland",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Cameroon",
        WinConditions: " ",
        Attendance: 33679,
        RoundID: "group",
        MatchID: 43950002,
        HomeTeamInitials: "IRL",
        AwayTeamInitials: "CMR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          141.40979,
          43.01507
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "01 Jun 2002 - 20:30 ",
        Stage: "Group E",
        Stadium: "Sapporo Dome",
        City: "Sapporo ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 8,
        AwayTeamGoals: 0,
        AwayTeamName: "Saudi Arabia",
        WinConditions: " ",
        Attendance: 32218,
        RoundID: "group",
        MatchID: 43950004,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "KSA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          140.64081,
          35.99173
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "02 Jun 2002 - 14:30 ",
        Stage: "Group F",
        Stadium: "Kashima Stadium",
        City: "Ibaraki ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Nigeria",
        WinConditions: " ",
        Attendance: 34050,
        RoundID: "group",
        MatchID: 43950007,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "NGA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          129.05815,
          35.1898
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "02 Jun 2002 - 16:30 ",
        Stage: "Group B",
        Stadium: "Busan Asiad Main Stadium",
        City: "Busan ",
        HomeTeamName: "Paraguay",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "South Africa",
        WinConditions: " ",
        Attendance: 25186,
        RoundID: "group",
        MatchID: 43950006,
        HomeTeamInitials: "PAR",
        AwayTeamInitials: "RSA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          139.71754,
          35.90295
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "02 Jun 2002 - 18:30 ",
        Stage: "Group F",
        Stadium: "Saitama Stadium 2002",
        City: "Saitama ",
        HomeTeamName: "England",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Sweden",
        WinConditions: " ",
        Attendance: 52721,
        RoundID: "group",
        MatchID: 43950005,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "SWE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          126.87482,
          35.13353
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "02 Jun 2002 - 20:30 ",
        Stage: "Group B",
        Stadium: "Gwangju World Cup Stadium",
        City: "Gwangju ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Slovenia",
        WinConditions: " ",
        Attendance: 28598,
        RoundID: "group",
        MatchID: 43950008,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "SVN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          129.25935,
          35.53536
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "03 June 2002 - 18:00 ",
        Stage: "Group C",
        Stadium: "Munsu Football Stadium",
        City: "Ulsan ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Turkey",
        WinConditions: " ",
        Attendance: 33842,
        RoundID: "group",
        MatchID: 43950010,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "TUR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          141.40979,
          43.01507
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "03 Jun 2002 - 20:30 ",
        Stage: "Group G",
        Stadium: "Sapporo Dome",
        City: "Sapporo ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Ecuador",
        WinConditions: " ",
        Attendance: 31081,
        RoundID: "group",
        MatchID: 43950011,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "ECU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          139.05917,
          37.88248
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "03 Jun 2002 - 15:30 ",
        Stage: "Group G",
        Stadium: "Niigata Stadium Big Swan",
        City: "Niigata ",
        HomeTeamName: "Croatia",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 32239,
        RoundID: "group",
        MatchID: 43950009,
        HomeTeamInitials: "CRO",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          126.87482,
          35.13353
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "04 June 2002 - 15:30 ",
        Stage: "Group C",
        Stadium: "Gwangju World Cup Stadium",
        City: "Gwangju ",
        HomeTeamName: "China PR",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Costa Rica",
        WinConditions: " ",
        Attendance: 27217,
        RoundID: "group",
        MatchID: 43950012,
        HomeTeamInitials: "CHN",
        AwayTeamInitials: "CRC"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          139.71754,
          35.90295
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "04 June 2002 - 18:00 ",
        Stage: "Group H",
        Stadium: "Saitama Stadium 2002",
        City: "Saitama ",
        HomeTeamName: "Japan",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Belgium",
        WinConditions: " ",
        Attendance: 55256,
        RoundID: "group",
        MatchID: 43950013,
        HomeTeamInitials: "JPN",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          129.05815,
          35.1898
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "04 Jun 2002 - 20:30 ",
        Stage: "Group D",
        Stadium: "Busan Asiad Main Stadium",
        City: "Busan ",
        HomeTeamName: "Korea Republic",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Poland",
        WinConditions: " ",
        Attendance: 48760,
        RoundID: "group",
        MatchID: 43950014,
        HomeTeamInitials: "KOR",
        AwayTeamInitials: "POL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          135.16903,
          34.65672
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "05 Jun 2002 - 15:30 ",
        Stage: "Group H",
        Stadium: "Kobe Wing Stadium",
        City: "Kobe ",
        HomeTeamName: "Russia",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Tunisia",
        WinConditions: " ",
        Attendance: 30957,
        RoundID: "group",
        MatchID: 43950015,
        HomeTeamInitials: "RUS",
        AwayTeamInitials: "TUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          127.03683,
          37.28637
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "05 Jun 2002 - 18:00 ",
        Stage: "Group D",
        Stadium: "Suwon World Cup Stadium",
        City: "Suwon ",
        HomeTeamName: "USA",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Portugal",
        WinConditions: " ",
        Attendance: 37306,
        RoundID: "group",
        MatchID: 43950016,
        HomeTeamInitials: "USA",
        AwayTeamInitials: "POR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          140.64081,
          35.99173
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "05 Jun 2002 - 20:30 ",
        Stage: "Group E",
        Stadium: "Kashima Stadium",
        City: "Ibaraki ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Ireland",
        WinConditions: " ",
        Attendance: 35854,
        RoundID: "group",
        MatchID: 43950017,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "IRL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          128.69028,
          35.82973
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "06 Jun 2002 - 15:30 ",
        Stage: "Group A",
        Stadium: "Daegu World Cup Stadium",
        City: "Daegu ",
        HomeTeamName: "Denmark",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Senegal",
        WinConditions: " ",
        Attendance: 43500,
        RoundID: "group",
        MatchID: 43950020,
        HomeTeamInitials: "DEN",
        AwayTeamInitials: "SEN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          139.71754,
          35.90295
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "06 Jun 2002 - 18:00 ",
        Stage: "Group E",
        Stadium: "Saitama Stadium 2002",
        City: "Saitama ",
        HomeTeamName: "Cameroon",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Saudi Arabia",
        WinConditions: " ",
        Attendance: 52328,
        RoundID: "group",
        MatchID: 43950019,
        HomeTeamInitials: "CMR",
        AwayTeamInitials: "KSA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          129.05815,
          35.1898
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "06 Jun 2002 - 20:30 ",
        Stage: "Group A",
        Stadium: "Busan Asiad Main Stadium",
        City: "Busan ",
        HomeTeamName: "France",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 38289,
        RoundID: "group",
        MatchID: 43950018,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          135.16903,
          34.65672
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "07 Jun 2002 - 15:30 ",
        Stage: "Group F",
        Stadium: "Kobe Wing Stadium",
        City: "Kobe ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Nigeria",
        WinConditions: " ",
        Attendance: 36194,
        RoundID: "group",
        MatchID: 43950021,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "NGA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          141.40979,
          43.01507
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "07 Jun 2002 - 20:30 ",
        Stage: "Group F",
        Stadium: "Sapporo Dome",
        City: "Sapporo ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 35927,
        RoundID: "group",
        MatchID: 43950023,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          127.06451,
          35.86792
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "07 June 2002 - 18:00 ",
        Stage: "Group B",
        Stadium: "Jeonju World Cup Stadium",
        City: "Jeonju ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Paraguay",
        WinConditions: " ",
        Attendance: 24000,
        RoundID: "group",
        MatchID: 43950022,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "PAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          128.69028,
          35.82973
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "08 Jun 2002 - 15:30 ",
        Stage: "Group B",
        Stadium: "Daegu World Cup Stadium",
        City: "Daegu ",
        HomeTeamName: "South Africa",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Slovenia",
        WinConditions: " ",
        Attendance: 47226,
        RoundID: "group",
        MatchID: 43950024,
        HomeTeamInitials: "RSA",
        AwayTeamInitials: "SVN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          126.5095,
          33.24606
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "08 Jun 2002 - 20:30 ",
        Stage: "Group C",
        Stadium: "Jeju World Cup Stadium",
        City: "Jeju ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 4,
        AwayTeamGoals: 0,
        AwayTeamName: "China PR",
        WinConditions: " ",
        Attendance: 36750,
        RoundID: "group",
        MatchID: 43950026,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "CHN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          140.64081,
          35.99173
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "08 June 2002 - 18:00 ",
        Stage: "Group G",
        Stadium: "Kashima Stadium",
        City: "Ibaraki ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Croatia",
        WinConditions: " ",
        Attendance: 36472,
        RoundID: "group",
        MatchID: 43950025,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "CRO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          126.64314,
          37.46601
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "09 Jun 2002 - 18:00 ",
        Stage: "Group C",
        Stadium: "Incheon Football Stadium",
        City: "Incheon ",
        HomeTeamName: "Costa Rica",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Turkey",
        WinConditions: " ",
        Attendance: 42299,
        RoundID: "group",
        MatchID: 43950028,
        HomeTeamInitials: "CRC",
        AwayTeamInitials: "TUR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          139.60649,
          35.50982
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "09 Jun 2002 - 20:30 ",
        Stage: "Group H",
        Stadium: "International Stadium Yokohama",
        City: "Yokohama ",
        HomeTeamName: "Japan",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Russia",
        WinConditions: " ",
        Attendance: 66108,
        RoundID: "group",
        MatchID: 43950029,
        HomeTeamInitials: "JPN",
        AwayTeamInitials: "RUS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          140.95055,
          38.33535
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "09 Jun 2002 - 15:30 ",
        Stage: "Group G",
        Stadium: "Miyagi Stadium",
        City: "Rifu ",
        HomeTeamName: "Mexico",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Ecuador",
        WinConditions: " ",
        Attendance: 45610,
        RoundID: "group",
        MatchID: 43950027,
        HomeTeamInitials: "MEX",
        AwayTeamInitials: "ECU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          128.69028,
          35.82973
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "10 Jun 2002 - 15:30 ",
        Stage: "Group D",
        Stadium: "Daegu World Cup Stadium",
        City: "Daegu ",
        HomeTeamName: "Korea Republic",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "USA",
        WinConditions: " ",
        Attendance: 60778,
        RoundID: "group",
        MatchID: 43950030,
        HomeTeamInitials: "KOR",
        AwayTeamInitials: "USA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          127.06451,
          35.86792
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "10 Jun 2002 - 20:30 ",
        Stage: "Group D",
        Stadium: "Jeonju World Cup Stadium",
        City: "Jeonju ",
        HomeTeamName: "Portugal",
        HomeTeamGoals: 4,
        AwayTeamGoals: 0,
        AwayTeamName: "Poland",
        WinConditions: " ",
        Attendance: 31000,
        RoundID: "group",
        MatchID: 43950032,
        HomeTeamInitials: "POR",
        AwayTeamInitials: "POL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          131.65752,
          33.20071
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "10 Jun 2002 - 18:00 ",
        Stage: "Group H",
        Stadium: "Oita Stadium Big Eye",
        City: "Oita ",
        HomeTeamName: "Tunisia",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Belgium",
        WinConditions: " ",
        Attendance: 39700,
        RoundID: "group",
        MatchID: 43950031,
        HomeTeamInitials: "TUN",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          126.64314,
          37.46601
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "11 Jun 2002 - 15:30 ",
        Stage: "Group A",
        Stadium: "Incheon Football Stadium",
        City: "Incheon ",
        HomeTeamName: "Denmark",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 48100,
        RoundID: "group",
        MatchID: 43950033,
        HomeTeamInitials: "DEN",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          127.03683,
          37.28637
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "11 June 2002 - 15:30 ",
        Stage: "Group A",
        Stadium: "Suwon World Cup Stadium",
        City: "Suwon ",
        HomeTeamName: "Senegal",
        HomeTeamGoals: 3,
        AwayTeamGoals: 3,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 33681,
        RoundID: "group",
        MatchID: 43950034,
        HomeTeamInitials: "SEN",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          139.60649,
          35.50982
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "11 Jun 2002 - 20:30 ",
        Stage: "Group E",
        Stadium: "International Stadium Yokohama",
        City: "Yokohama ",
        HomeTeamName: "Saudi Arabia",
        HomeTeamGoals: 0,
        AwayTeamGoals: 3,
        AwayTeamName: "Ireland",
        WinConditions: " ",
        Attendance: 65320,
        RoundID: "group",
        MatchID: 43950036,
        HomeTeamInitials: "KSA",
        AwayTeamInitials: "IRL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          137.9707,
          34.74332
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "11 Jun 2002 - 20:30 ",
        Stage: "Group E",
        Stadium: "Shizuoka Stadium Ecopa",
        City: "Shizuoka ",
        HomeTeamName: "Cameroon",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Germany",
        WinConditions: " ",
        Attendance: 47085,
        RoundID: "group",
        MatchID: 43950035,
        HomeTeamInitials: "CMR",
        AwayTeamInitials: "GER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          140.95055,
          38.33535
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "12 Jun 2002 - 15:30 ",
        Stage: "Group F",
        Stadium: "Miyagi Stadium",
        City: "Rifu ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Argentina",
        WinConditions: " ",
        Attendance: 45777,
        RoundID: "group",
        MatchID: 43950037,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          135.51857,
          34.61397
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "12 Jun 2002 - 15:30 ",
        Stage: "Group F",
        Stadium: "Osaka Nagai Stadium",
        City: "Osaka ",
        HomeTeamName: "Nigeria",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 44864,
        RoundID: "group",
        MatchID: 43950038,
        HomeTeamInitials: "NGA",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          126.5095,
          33.24606
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "12 Jun 2002 - 20:30 ",
        Stage: "Group B",
        Stadium: "Jeju World Cup Stadium",
        City: "Jeju ",
        HomeTeamName: "Slovenia",
        HomeTeamGoals: 1,
        AwayTeamGoals: 3,
        AwayTeamName: "Paraguay",
        WinConditions: " ",
        Attendance: 30176,
        RoundID: "group",
        MatchID: 43950040,
        HomeTeamInitials: "SVN",
        AwayTeamInitials: "PAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          127.325,
          36.3652
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "12 Jun 2002 - 20:30 ",
        Stage: "Group B",
        Stadium: "Daejeon World Cup Stadium",
        City: "Daejeon ",
        HomeTeamName: "South Africa",
        HomeTeamGoals: 2,
        AwayTeamGoals: 3,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 31024,
        RoundID: "group",
        MatchID: 43950039,
        HomeTeamInitials: "RSA",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          127.03683,
          37.28637
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "13 Jun 2002 - 15:30 ",
        Stage: "Group C",
        Stadium: "Suwon World Cup Stadium",
        City: "Suwon ",
        HomeTeamName: "Costa Rica",
        HomeTeamGoals: 2,
        AwayTeamGoals: 5,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 38524,
        RoundID: "group",
        MatchID: 43950041,
        HomeTeamInitials: "CRC",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          126.89707,
          37.56817
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "13 Jun 2002 - 15:30 ",
        Stage: "Group C",
        Stadium: "Seoul World Cup Stadium",
        City: "Seoul ",
        HomeTeamName: "Turkey",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "China PR",
        WinConditions: " ",
        Attendance: 43605,
        RoundID: "group",
        MatchID: 43950042,
        HomeTeamInitials: "TUR",
        AwayTeamInitials: "CHN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          139.60649,
          35.50982
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "13 Jun 2002 - 20:30 ",
        Stage: "Group G",
        Stadium: "International Stadium Yokohama",
        City: "Yokohama ",
        HomeTeamName: "Ecuador",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Croatia",
        WinConditions: " ",
        Attendance: 65862,
        RoundID: "group",
        MatchID: 43950044,
        HomeTeamInitials: "ECU",
        AwayTeamInitials: "CRO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          131.65752,
          33.20071
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "13 Jun 2002 - 20:30 ",
        Stage: "Group G",
        Stadium: "Oita Stadium Big Eye",
        City: "Oita ",
        HomeTeamName: "Mexico",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 39291,
        RoundID: "group",
        MatchID: 43950043,
        HomeTeamInitials: "MEX",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          135.51857,
          34.61397
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "14 Jun 2002 - 15:30 ",
        Stage: "Group H",
        Stadium: "Osaka Nagai Stadium",
        City: "Osaka ",
        HomeTeamName: "Tunisia",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Japan",
        WinConditions: " ",
        Attendance: 45213,
        RoundID: "group",
        MatchID: 43950045,
        HomeTeamInitials: "TUN",
        AwayTeamInitials: "JPN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          126.64314,
          37.46601
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "14 Jun 2002 - 20:30 ",
        Stage: "Group D",
        Stadium: "Incheon Football Stadium",
        City: "Incheon ",
        HomeTeamName: "Portugal",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Korea Republic",
        WinConditions: " ",
        Attendance: 50239,
        RoundID: "group",
        MatchID: 43950047,
        HomeTeamInitials: "POR",
        AwayTeamInitials: "KOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          127.325,
          36.3652
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "14 Jun 2002 - 20:30 ",
        Stage: "Group D",
        Stadium: "Daejeon World Cup Stadium",
        City: "Daejeon ",
        HomeTeamName: "Poland",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "USA",
        WinConditions: " ",
        Attendance: 26482,
        RoundID: "group",
        MatchID: 43950048,
        HomeTeamInitials: "POL",
        AwayTeamInitials: "USA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          137.9707,
          34.74332
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "14 Jun 2002 - 15:30 ",
        Stage: "Group H",
        Stadium: "Shizuoka Stadium Ecopa",
        City: "Shizuoka ",
        HomeTeamName: "Belgium",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Russia",
        WinConditions: " ",
        Attendance: 46640,
        RoundID: "group",
        MatchID: 43950046,
        HomeTeamInitials: "BEL",
        AwayTeamInitials: "RUS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          139.05917,
          37.88248
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "15 Jun 2002 - 20:30 ",
        Stage: "Round of 16",
        Stadium: "Niigata Stadium Big Swan",
        City: "Niigata ",
        HomeTeamName: "Denmark",
        HomeTeamGoals: 0,
        AwayTeamGoals: 3,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 40582,
        RoundID: "rsixteen",
        MatchID: 43950050,
        HomeTeamInitials: "DEN",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          126.5095,
          33.24606
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "15 Jun 2002 - 15:30 ",
        Stage: "Round of 16",
        Stadium: "Jeju World Cup Stadium",
        City: "Jeju ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Paraguay",
        WinConditions: " ",
        Attendance: 25176,
        RoundID: "rsixteen",
        MatchID: 43950049,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "PAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          127.03683,
          37.28637
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "16 Jun 2002 - 20:30 ",
        Stage: "Round of 16",
        Stadium: "Suwon World Cup Stadium",
        City: "Suwon ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Ireland",
        WinConditions: "Spain win on penalties (3 - 2) ",
        Attendance: 38926,
        RoundID: "rsixteen",
        MatchID: 43950052,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "IRL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          131.65752,
          33.20071
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "16 Jun 2002 - 15:30 ",
        Stage: "Round of 16",
        Stadium: "Oita Stadium Big Eye",
        City: "Oita ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Senegal",
        WinConditions: "win on Golden Goal ",
        Attendance: 39747,
        RoundID: "rsixteen",
        MatchID: 43950051,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "SEN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          135.16903,
          34.65672
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "17 Jun 2002 - 20:30 ",
        Stage: "Round of 16",
        Stadium: "Kobe Wing Stadium",
        City: "Kobe ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Belgium",
        WinConditions: " ",
        Attendance: 40440,
        RoundID: "rsixteen",
        MatchID: 43950054,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          127.06451,
          35.86792
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "17 June 2002 - 15:30 ",
        Stage: "Round of 16",
        Stadium: "Jeonju World Cup Stadium",
        City: "Jeonju ",
        HomeTeamName: "Mexico",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "USA",
        WinConditions: " ",
        Attendance: 36380,
        RoundID: "rsixteen",
        MatchID: 43950053,
        HomeTeamInitials: "MEX",
        AwayTeamInitials: "USA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          140.95055,
          38.33535
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "18 Jun 2002 - 15:30 ",
        Stage: "Round of 16",
        Stadium: "Miyagi Stadium",
        City: "Rifu ",
        HomeTeamName: "Japan",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Turkey",
        WinConditions: " ",
        Attendance: 45666,
        RoundID: "rsixteen",
        MatchID: 43950055,
        HomeTeamInitials: "JPN",
        AwayTeamInitials: "TUR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          127.325,
          36.3652
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "18 Jun 2002 - 20:30 ",
        Stage: "Round of 16",
        Stadium: "Daejeon World Cup Stadium",
        City: "Daejeon ",
        HomeTeamName: "Korea Republic",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Italy",
        WinConditions: "win on Golden Goal ",
        Attendance: 38588,
        RoundID: "rsixteen",
        MatchID: 43950056,
        HomeTeamInitials: "KOR",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          137.9707,
          34.74332
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "21 Jun 2002 - 15:30 ",
        Stage: "Quarter-finals",
        Stadium: "Shizuoka Stadium Ecopa",
        City: "Shizuoka ",
        HomeTeamName: "England",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 47436,
        RoundID: "quart",
        MatchID: 43950057,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          129.25935,
          35.53536
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "21 Jun 2002 - 20:30 ",
        Stage: "Quarter-finals",
        Stadium: "Munsu Football Stadium",
        City: "Ulsan ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "USA",
        WinConditions: " ",
        Attendance: 37337,
        RoundID: "quart",
        MatchID: 43950058,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "USA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          135.51857,
          34.61397
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "22 Jun 2002 - 20:30 ",
        Stage: "Quarter-finals",
        Stadium: "Osaka Nagai Stadium",
        City: "Osaka ",
        HomeTeamName: "Senegal",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Turkey",
        WinConditions: "win on Golden Goal ",
        Attendance: 44233,
        RoundID: "quart",
        MatchID: 43950060,
        HomeTeamInitials: "SEN",
        AwayTeamInitials: "TUR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          126.87482,
          35.13353
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "22 Jun 2002 - 15:30 ",
        Stage: "Quarter-finals",
        Stadium: "Gwangju World Cup Stadium",
        City: "Gwangju ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Korea Republic",
        WinConditions: "Korea Republic win on penalties (3 - 5) ",
        Attendance: 42114,
        RoundID: "quart",
        MatchID: 43950059,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "KOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          126.89707,
          37.56817
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "25 Jun 2002 - 20:30 ",
        Stage: "Semi-finals",
        Stadium: "Seoul World Cup Stadium",
        City: "Seoul ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Korea Republic",
        WinConditions: " ",
        Attendance: 65256,
        RoundID: "semi",
        MatchID: 43950061,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "KOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          139.71754,
          35.90295
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "26 Jun 2002 - 20:30 ",
        Stage: "Semi-finals",
        Stadium: "Saitama Stadium 2002",
        City: "Saitama ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Turkey",
        WinConditions: " ",
        Attendance: 61058,
        RoundID: "semi",
        MatchID: 43950062,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "TUR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          128.69028,
          35.82973
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "29 Jun 2002 - 20:00 ",
        Stage: "Match for third place",
        Stadium: "Daegu World Cup Stadium",
        City: "Daegu ",
        HomeTeamName: "Korea Republic",
        HomeTeamGoals: 2,
        AwayTeamGoals: 3,
        AwayTeamName: "Turkey",
        WinConditions: " ",
        Attendance: 63483,
        RoundID: "third",
        MatchID: 43950063,
        HomeTeamInitials: "KOR",
        AwayTeamInitials: "TUR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          139.60649,
          35.50982
        ]
      },
      properties: {
        Year: 2002,
        Datetime: "30 Jun 2002 - 20:00 ",
        Stage: "Final",
        Stadium: "International Stadium Yokohama",
        City: "Yokohama ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 69029,
        RoundID: "final",
        MatchID: 43950064,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.62464,
          48.21876
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "09 Jun 2006 - 18:00 ",
        Stage: "Group A",
        Stadium: "FIFA World Cup Stadium, Munich",
        City: "Munich ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 4,
        AwayTeamGoals: 2,
        AwayTeamName: "Costa Rica",
        WinConditions: " ",
        Attendance: 66000,
        RoundID: "group",
        MatchID: 97410001,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "CRC"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.06771,
          51.55454
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "09 Jun 2006 - 21:00 ",
        Stage: "Group A",
        Stadium: "FIFA World Cup Stadium, Gelsenkirchen",
        City: "Gelsenkirchen ",
        HomeTeamName: "Poland",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Ecuador",
        WinConditions: " ",
        Attendance: 52000,
        RoundID: "group",
        MatchID: 97410002,
        HomeTeamInitials: "POL",
        AwayTeamInitials: "ECU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.6452,
          50.06836
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "10 Jun 2006 - 15:00 ",
        Stage: "Group B",
        Stadium: "FIFA World Cup Stadium, Frankfurt",
        City: "Frankfurt/Main ",
        HomeTeamName: "England",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Paraguay",
        WinConditions: " ",
        Attendance: 48000,
        RoundID: "group",
        MatchID: 97410003,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "PAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.45185,
          51.49243
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "10 Jun 2006 - 18:00 ",
        Stage: "Group B",
        Stadium: "FIFA World Cup Stadium, Dortmund",
        City: "Dortmund ",
        HomeTeamName: "Trinidad and Tobago",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Sweden",
        WinConditions: " ",
        Attendance: 62959,
        RoundID: "group",
        MatchID: 97410004,
        HomeTeamInitials: "TRI",
        AwayTeamInitials: "SWE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.89857,
          53.58705
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "10 Jun 2006 - 21:00 ",
        Stage: "Group C",
        Stadium: "FIFA World Cup Stadium, Hamburg",
        City: "Hamburg ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Cote d'Ivoire",
        WinConditions: " ",
        Attendance: 49480,
        RoundID: "group",
        MatchID: 97410005,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "CIV"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.34838,
          51.34565
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "11 Jun 2006 - 15:00 ",
        Stage: "Group C",
        Stadium: "Zentralstadion",
        City: "Leipzig ",
        HomeTeamName: "Serbia and Montenegro",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Netherlands",
        WinConditions: " ",
        Attendance: 43000,
        RoundID: "group",
        MatchID: 97410006,
        HomeTeamInitials: "SCG",
        AwayTeamInitials: "NED"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.12574,
          49.42618
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "11 Jun 2006 - 18:00 ",
        Stage: "Group D",
        Stadium: "Franken-Stadion",
        City: "Nuremberg ",
        HomeTeamName: "Mexico",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Iran",
        WinConditions: " ",
        Attendance: 41000,
        RoundID: "group",
        MatchID: 97410007,
        HomeTeamInitials: "MEX",
        AwayTeamInitials: "IRN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          6.87512,
          50.93341
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "11 Jun 2006 - 21:00 ",
        Stage: "Group D",
        Stadium: "FIFA World Cup Stadium, Cologne",
        City: "Cologne ",
        HomeTeamName: "Angola",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Portugal",
        WinConditions: " ",
        Attendance: 45000,
        RoundID: "group",
        MatchID: 97410008,
        HomeTeamInitials: "ANG",
        AwayTeamInitials: "POR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.77659,
          49.43445
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "12 Jun 2006 - 15:00 ",
        Stage: "Group F",
        Stadium: "Fritz-Walter-Stadion",
        City: "Kaiserslautern ",
        HomeTeamName: "Australia",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Japan",
        WinConditions: " ",
        Attendance: 46000,
        RoundID: "group",
        MatchID: 97410012,
        HomeTeamInitials: "AUS",
        AwayTeamInitials: "JPN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.06771,
          51.55454
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "12 Jun 2006 - 18:00 ",
        Stage: "Group E",
        Stadium: "FIFA World Cup Stadium, Gelsenkirchen",
        City: "Gelsenkirchen ",
        HomeTeamName: "USA",
        HomeTeamGoals: 0,
        AwayTeamGoals: 3,
        AwayTeamName: "Czech Republic",
        WinConditions: " ",
        Attendance: 52000,
        RoundID: "group",
        MatchID: 97410010,
        HomeTeamInitials: "USA",
        AwayTeamInitials: "CZE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.73096,
          52.36048
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "12 Jun 2006 - 21:00 ",
        Stage: "Group E",
        Stadium: "FIFA World Cup Stadium, Hanover",
        City: "Hanover ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Ghana",
        WinConditions: " ",
        Attendance: 43000,
        RoundID: "group",
        MatchID: 97410009,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "GHA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.6452,
          50.06836
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "13 Jun 2006 - 15:00 ",
        Stage: "Group G",
        Stadium: "FIFA World Cup Stadium, Frankfurt",
        City: "Frankfurt/Main ",
        HomeTeamName: "Korea Republic",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Togo",
        WinConditions: " ",
        Attendance: 48000,
        RoundID: "group",
        MatchID: 97410014,
        HomeTeamInitials: "KOR",
        AwayTeamInitials: "TOG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.2319,
          48.79224
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "13 Jun 2006 - 18:00 ",
        Stage: "Group G",
        Stadium: "Gottlieb-Daimler-Stadion",
        City: "Stuttgart ",
        HomeTeamName: "France",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Switzerland",
        WinConditions: " ",
        Attendance: 52000,
        RoundID: "group",
        MatchID: 97410013,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "SUI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.23935,
          52.51464
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "13 Jun 2006 - 21:00 ",
        Stage: "Group F",
        Stadium: "Olympiastadion",
        City: "Berlin ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Croatia",
        WinConditions: " ",
        Attendance: 72000,
        RoundID: "group",
        MatchID: 97410011,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "CRO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.34838,
          51.34565
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "14 Jun 2006 - 15:00 ",
        Stage: "Group H",
        Stadium: "Zentralstadion",
        City: "Leipzig ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 4,
        AwayTeamGoals: 0,
        AwayTeamName: "Ukraine",
        WinConditions: " ",
        Attendance: 43000,
        RoundID: "group",
        MatchID: 97410015,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "UKR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.62464,
          48.21876
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "14 Jun 2006 - 18:00 ",
        Stage: "Group H",
        Stadium: "FIFA World Cup Stadium, Munich",
        City: "Munich ",
        HomeTeamName: "Tunisia",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Saudi Arabia",
        WinConditions: " ",
        Attendance: 66000,
        RoundID: "group",
        MatchID: 97410016,
        HomeTeamInitials: "TUN",
        AwayTeamInitials: "KSA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.45185,
          51.49243
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "14 Jun 2006 - 21:00 ",
        Stage: "Group A",
        Stadium: "FIFA World Cup Stadium, Dortmund",
        City: "Dortmund ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Poland",
        WinConditions: " ",
        Attendance: 65000,
        RoundID: "group",
        MatchID: 97410017,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "POL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.89857,
          53.58705
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "15 Jun 2006 - 15:00 ",
        Stage: "Group A",
        Stadium: "FIFA World Cup Stadium, Hamburg",
        City: "Hamburg ",
        HomeTeamName: "Ecuador",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Costa Rica",
        WinConditions: " ",
        Attendance: 50000,
        RoundID: "group",
        MatchID: 97410018,
        HomeTeamInitials: "ECU",
        AwayTeamInitials: "CRC"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.12574,
          49.42618
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "15 Jun 2006 - 18:00 ",
        Stage: "Group B",
        Stadium: "Franken-Stadion",
        City: "Nuremberg ",
        HomeTeamName: "England",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Trinidad and Tobago",
        WinConditions: " ",
        Attendance: 41000,
        RoundID: "group",
        MatchID: 97410019,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "TRI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.23935,
          52.51464
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "15 Jun 2006 - 21:00 ",
        Stage: "Group B",
        Stadium: "Olympiastadion",
        City: "Berlin ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Paraguay",
        WinConditions: " ",
        Attendance: 72000,
        RoundID: "group",
        MatchID: 97410020,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "PAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.06771,
          51.55454
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "16 Jun 2006 - 15:00 ",
        Stage: "Group C",
        Stadium: "FIFA World Cup Stadium, Gelsenkirchen",
        City: "Gelsenkirchen ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 6,
        AwayTeamGoals: 0,
        AwayTeamName: "Serbia and Montenegro",
        WinConditions: " ",
        Attendance: 52000,
        RoundID: "group",
        MatchID: 97410021,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "SCG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.2319,
          48.79224
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "16 Jun 2006 - 18:00 ",
        Stage: "Group C",
        Stadium: "Gottlieb-Daimler-Stadion",
        City: "Stuttgart ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Cote d'Ivoire",
        WinConditions: " ",
        Attendance: 52000,
        RoundID: "group",
        MatchID: 97410022,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "CIV"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.73096,
          52.36048
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "16 Jun 2006 - 21:00 ",
        Stage: "Group D",
        Stadium: "FIFA World Cup Stadium, Hanover",
        City: "Hanover ",
        HomeTeamName: "Mexico",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Angola",
        WinConditions: " ",
        Attendance: 43000,
        RoundID: "group",
        MatchID: 97410023,
        HomeTeamInitials: "MEX",
        AwayTeamInitials: "ANG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.6452,
          50.06836
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "17 Jun 2006 - 15:00 ",
        Stage: "Group D",
        Stadium: "FIFA World Cup Stadium, Frankfurt",
        City: "Frankfurt/Main ",
        HomeTeamName: "Portugal",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "IR Iran",
        WinConditions: " ",
        Attendance: 48000,
        RoundID: "group",
        MatchID: 97410024,
        HomeTeamInitials: "POR",
        AwayTeamInitials: "IRN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          6.87512,
          50.93341
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "17 Jun 2006 - 18:00 ",
        Stage: "Group E",
        Stadium: "FIFA World Cup Stadium, Cologne",
        City: "Cologne ",
        HomeTeamName: "Czech Republic",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Ghana",
        WinConditions: " ",
        Attendance: 45000,
        RoundID: "group",
        MatchID: 97410026,
        HomeTeamInitials: "CZE",
        AwayTeamInitials: "GHA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.77659,
          49.43445
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "17 Jun 2006 - 21:00 ",
        Stage: "Group E",
        Stadium: "Fritz-Walter-Stadion",
        City: "Kaiserslautern ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "USA",
        WinConditions: " ",
        Attendance: 46000,
        RoundID: "group",
        MatchID: 97410025,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "USA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.12574,
          49.42618
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "18 Jun 2006 - 15:00 ",
        Stage: "Group F",
        Stadium: "Franken-Stadion",
        City: "Nuremberg ",
        HomeTeamName: "Japan",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Croatia",
        WinConditions: " ",
        Attendance: 41000,
        RoundID: "group",
        MatchID: 97410028,
        HomeTeamInitials: "JPN",
        AwayTeamInitials: "CRO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.62464,
          48.21876
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "18 Jun 2006 - 18:00 ",
        Stage: "Group F",
        Stadium: "FIFA World Cup Stadium, Munich",
        City: "Munich ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Australia",
        WinConditions: " ",
        Attendance: 66000,
        RoundID: "group",
        MatchID: 97410027,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "AUS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.34838,
          51.34565
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "18 Jun 2006 - 21:00 ",
        Stage: "Group G",
        Stadium: "Zentralstadion",
        City: "Leipzig ",
        HomeTeamName: "France",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Korea Republic",
        WinConditions: " ",
        Attendance: 43000,
        RoundID: "group",
        MatchID: 97410029,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "KOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.45185,
          51.49243
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "19 Jun 2006 - 15:00 ",
        Stage: "Group G",
        Stadium: "FIFA World Cup Stadium, Dortmund",
        City: "Dortmund ",
        HomeTeamName: "Togo",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Switzerland",
        WinConditions: " ",
        Attendance: 65000,
        RoundID: "group",
        MatchID: 97410030,
        HomeTeamInitials: "TOG",
        AwayTeamInitials: "SUI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.89857,
          53.58705
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "19 Jun 2006 - 18:00 ",
        Stage: "Group H",
        Stadium: "FIFA World Cup Stadium, Hamburg",
        City: "Hamburg ",
        HomeTeamName: "Saudi Arabia",
        HomeTeamGoals: 0,
        AwayTeamGoals: 4,
        AwayTeamName: "Ukraine",
        WinConditions: " ",
        Attendance: 50000,
        RoundID: "group",
        MatchID: 97410032,
        HomeTeamInitials: "KSA",
        AwayTeamInitials: "UKR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.2319,
          48.79224
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "19 Jun 2006 - 21:00 ",
        Stage: "Group H",
        Stadium: "Gottlieb-Daimler-Stadion",
        City: "Stuttgart ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Tunisia",
        WinConditions: " ",
        Attendance: 52000,
        RoundID: "group",
        MatchID: 97410031,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "TUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.23935,
          52.51464
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "20 Jun 2006 - 16:00 ",
        Stage: "Group A",
        Stadium: "Olympiastadion",
        City: "Berlin ",
        HomeTeamName: "Ecuador",
        HomeTeamGoals: 0,
        AwayTeamGoals: 3,
        AwayTeamName: "Germany",
        WinConditions: " ",
        Attendance: 72000,
        RoundID: "group",
        MatchID: 97410033,
        HomeTeamInitials: "ECU",
        AwayTeamInitials: "GER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.73096,
          52.36048
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "20 Jun 2006 - 16:00 ",
        Stage: "Group A",
        Stadium: "FIFA World Cup Stadium, Hanover",
        City: "Hanover ",
        HomeTeamName: "Costa Rica",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Poland",
        WinConditions: " ",
        Attendance: 43000,
        RoundID: "group",
        MatchID: 97410034,
        HomeTeamInitials: "CRC",
        AwayTeamInitials: "POL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          6.87512,
          50.93341
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "20 Jun 2006 - 21:00 ",
        Stage: "Group B",
        Stadium: "FIFA World Cup Stadium, Cologne",
        City: "Cologne ",
        HomeTeamName: "Sweden",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 45000,
        RoundID: "group",
        MatchID: 97410035,
        HomeTeamInitials: "SWE",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.77659,
          49.43445
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "20 Jun 2006 - 21:00 ",
        Stage: "Group B",
        Stadium: "Fritz-Walter-Stadion",
        City: "Kaiserslautern ",
        HomeTeamName: "Paraguay",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Trinidad and Tobago",
        WinConditions: " ",
        Attendance: 46000,
        RoundID: "group",
        MatchID: 97410036,
        HomeTeamInitials: "PAR",
        AwayTeamInitials: "TRI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.34838,
          51.34565
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "21 Jun 2006 - 16:00 ",
        Stage: "Group D",
        Stadium: "Zentralstadion",
        City: "Leipzig ",
        HomeTeamName: "Iran",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Angola",
        WinConditions: " ",
        Attendance: 38000,
        RoundID: "group",
        MatchID: 97410040,
        HomeTeamInitials: "IRN",
        AwayTeamInitials: "ANG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.06771,
          51.55454
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "21 Jun 2006 - 16:00 ",
        Stage: "Group D",
        Stadium: "FIFA World Cup Stadium, Gelsenkirchen",
        City: "Gelsenkirchen ",
        HomeTeamName: "Portugal",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 52000,
        RoundID: "group",
        MatchID: 97410039,
        HomeTeamInitials: "POR",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.6452,
          50.06836
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "21 Jun 2006 - 21:00 ",
        Stage: "Group C",
        Stadium: "FIFA World Cup Stadium, Frankfurt",
        City: "Frankfurt/Main ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Argentina",
        WinConditions: " ",
        Attendance: 48000,
        RoundID: "group",
        MatchID: 97410037,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.62464,
          48.21876
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "21 Jun 2006 - 21:00 ",
        Stage: "Group C",
        Stadium: "FIFA World Cup Stadium, Munich",
        City: "Munich ",
        HomeTeamName: "Cote d'Ivoire",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Serbia and Montenegro",
        WinConditions: " ",
        Attendance: 66000,
        RoundID: "group",
        MatchID: 97410038,
        HomeTeamInitials: "CIV",
        AwayTeamInitials: "SCG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.89857,
          53.58705
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "22 Jun 2006 - 16:00 ",
        Stage: "Group E",
        Stadium: "FIFA World Cup Stadium, Hamburg",
        City: "Hamburg ",
        HomeTeamName: "Czech Republic",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 50000,
        RoundID: "group",
        MatchID: 97410041,
        HomeTeamInitials: "CZE",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.12574,
          49.42618
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "22 Jun 2006 - 16:00 ",
        Stage: "Group E",
        Stadium: "Franken-Stadion",
        City: "Nuremberg ",
        HomeTeamName: "Ghana",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "USA",
        WinConditions: " ",
        Attendance: 41000,
        RoundID: "group",
        MatchID: 97410042,
        HomeTeamInitials: "GHA",
        AwayTeamInitials: "USA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.45185,
          51.49243
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "22 Jun 2006 - 21:00 ",
        Stage: "Group F",
        Stadium: "FIFA World Cup Stadium, Dortmund",
        City: "Dortmund ",
        HomeTeamName: "Japan",
        HomeTeamGoals: 1,
        AwayTeamGoals: 4,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 65000,
        RoundID: "group",
        MatchID: 97410043,
        HomeTeamInitials: "JPN",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.2319,
          48.79224
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "22 Jun 2006 - 21:00 ",
        Stage: "Group F",
        Stadium: "Gottlieb-Daimler-Stadion",
        City: "Stuttgart ",
        HomeTeamName: "Croatia",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Australia",
        WinConditions: " ",
        Attendance: 52000,
        RoundID: "group",
        MatchID: 97410044,
        HomeTeamInitials: "CRO",
        AwayTeamInitials: "AUS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.23935,
          52.51464
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "23 Jun 2006 - 16:00 ",
        Stage: "Group H",
        Stadium: "Olympiastadion",
        City: "Berlin ",
        HomeTeamName: "Ukraine",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Tunisia",
        WinConditions: " ",
        Attendance: 72000,
        RoundID: "group",
        MatchID: 97410048,
        HomeTeamInitials: "UKR",
        AwayTeamInitials: "TUN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.77659,
          49.43445
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "23 Jun 2006 - 16:00 ",
        Stage: "Group H",
        Stadium: "Fritz-Walter-Stadion",
        City: "Kaiserslautern ",
        HomeTeamName: "Saudi Arabia",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 46000,
        RoundID: "group",
        MatchID: 97410047,
        HomeTeamInitials: "KSA",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          6.87512,
          50.93341
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "23 Jun 2006 - 21:00 ",
        Stage: "Group G",
        Stadium: "FIFA World Cup Stadium, Cologne",
        City: "Cologne ",
        HomeTeamName: "Togo",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 45000,
        RoundID: "group",
        MatchID: 97410045,
        HomeTeamInitials: "TOG",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.73096,
          52.36048
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "23 Jun 2006 - 21:00 ",
        Stage: "Group G",
        Stadium: "FIFA World Cup Stadium, Hanover",
        City: "Hanover ",
        HomeTeamName: "Switzerland",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Korea Republic",
        WinConditions: " ",
        Attendance: 43000,
        RoundID: "group",
        MatchID: 97410046,
        HomeTeamInitials: "SUI",
        AwayTeamInitials: "KOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.62464,
          48.21876
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "24 Jun 2006 - 17:00 ",
        Stage: "Round of 16",
        Stadium: "FIFA World Cup Stadium, Munich",
        City: "Munich ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Sweden",
        WinConditions: " ",
        Attendance: 66000,
        RoundID: "rsixteen",
        MatchID: 97410049,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "SWE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          12.34838,
          51.34565
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "24 Jun 2006 - 21:00 ",
        Stage: "Round of 16",
        Stadium: "Zentralstadion",
        City: "Leipzig ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Mexico",
        WinConditions: "win after extra time ",
        Attendance: 43000,
        RoundID: "rsixteen",
        MatchID: 97410050,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.2319,
          48.79224
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "25 Jun 2006 - 17:00 ",
        Stage: "Round of 16",
        Stadium: "Gottlieb-Daimler-Stadion",
        City: "Stuttgart ",
        HomeTeamName: "England",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Ecuador",
        WinConditions: " ",
        Attendance: 52000,
        RoundID: "rsixteen",
        MatchID: 97410051,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "ECU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.12574,
          49.42618
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "25 Jun 2006 - 21:00 ",
        Stage: "Round of 16",
        Stadium: "Franken-Stadion",
        City: "Nuremberg ",
        HomeTeamName: "Portugal",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Netherlands",
        WinConditions: " ",
        Attendance: 41000,
        RoundID: "rsixteen",
        MatchID: 97410052,
        HomeTeamInitials: "POR",
        AwayTeamInitials: "NED"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.77659,
          49.43445
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "26 Jun 2006 - 17:00 ",
        Stage: "Round of 16",
        Stadium: "Fritz-Walter-Stadion",
        City: "Kaiserslautern ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Australia",
        WinConditions: " ",
        Attendance: 46000,
        RoundID: "rsixteen",
        MatchID: 97410053,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "AUS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          6.87512,
          50.93341
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "26 Jun 2006 - 21:00 ",
        Stage: "Round of 16",
        Stadium: "FIFA World Cup Stadium, Cologne",
        City: "Cologne ",
        HomeTeamName: "Switzerland",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Ukraine",
        WinConditions: "Ukraine win on penalties (0 - 3) ",
        Attendance: 45000,
        RoundID: "rsixteen",
        MatchID: 97410054,
        HomeTeamInitials: "SUI",
        AwayTeamInitials: "UKR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.45185,
          51.49243
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "27 Jun 2006 - 17:00 ",
        Stage: "Round of 16",
        Stadium: "FIFA World Cup Stadium, Dortmund",
        City: "Dortmund ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Ghana",
        WinConditions: " ",
        Attendance: 65000,
        RoundID: "rsixteen",
        MatchID: 97410055,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "GHA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.73096,
          52.36048
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "27 Jun 2006 - 21:00 ",
        Stage: "Round of 16",
        Stadium: "FIFA World Cup Stadium, Hanover",
        City: "Hanover ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 1,
        AwayTeamGoals: 3,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 43000,
        RoundID: "rsixteen",
        MatchID: 97410056,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.23935,
          52.51464
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "30 Jun 2006 - 17:00 ",
        Stage: "Quarter-finals",
        Stadium: "Olympiastadion",
        City: "Berlin ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Argentina",
        WinConditions: "Germany win on penalties (4 - 2) ",
        Attendance: 72000,
        RoundID: "quart",
        MatchID: 97410057,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.89857,
          53.58705
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "30 Jun 2006 - 21:00 ",
        Stage: "Quarter-finals",
        Stadium: "FIFA World Cup Stadium, Hamburg",
        City: "Hamburg ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Ukraine",
        WinConditions: " ",
        Attendance: 50000,
        RoundID: "quart",
        MatchID: 97410058,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "UKR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.06771,
          51.55454
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "01 Jul 2006 - 17:00 ",
        Stage: "Quarter-finals",
        Stadium: "FIFA World Cup Stadium, Gelsenkirchen",
        City: "Gelsenkirchen ",
        HomeTeamName: "England",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Portugal",
        WinConditions: "Portugal win on penalties (1 - 3) ",
        Attendance: 52000,
        RoundID: "quart",
        MatchID: 97410059,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "POR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          8.6452,
          50.06836
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "01 Jul 2006 - 21:00 ",
        Stage: "Quarter-finals",
        Stadium: "FIFA World Cup Stadium, Frankfurt",
        City: "Frankfurt/Main ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 48000,
        RoundID: "quart",
        MatchID: 97410060,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          7.45185,
          51.49243
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "04 Jul 2006 - 21:00 ",
        Stage: "Semi-finals",
        Stadium: "FIFA World Cup Stadium, Dortmund",
        City: "Dortmund ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Italy",
        WinConditions: "win after extra time ",
        Attendance: 65000,
        RoundID: "semi",
        MatchID: 97410061,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          11.62464,
          48.21876
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "05 Jul 2006 - 21:00 ",
        Stage: "Semi-finals",
        Stadium: "FIFA World Cup Stadium, Munich",
        City: "Munich ",
        HomeTeamName: "Portugal",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 66000,
        RoundID: "semi",
        MatchID: 97410062,
        HomeTeamInitials: "POR",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          9.2319,
          48.79224
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "08 Jul 2006 - 21:00 ",
        Stage: "Match for third place",
        Stadium: "Gottlieb-Daimler-Stadion",
        City: "Stuttgart ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Portugal",
        WinConditions: " ",
        Attendance: 52000,
        RoundID: "third",
        MatchID: 97410063,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "POR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          13.23935,
          52.51464
        ]
      },
      properties: {
        Year: 2006,
        Datetime: "09 Jul 2006 - 20:00 ",
        Stage: "Final",
        Stadium: "Olympiastadion",
        City: "Berlin ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "France",
        WinConditions: "Italy win on penalties (5 - 3) ",
        Attendance: 69000,
        RoundID: "final",
        MatchID: 97410064,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          27.98271,
          -26.23493
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "11 Jun 2010 - 16:00 ",
        Stage: "Group A",
        Stadium: "Soccer City Stadium",
        City: "Johannesburg ",
        HomeTeamName: "South Africa",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 84490,
        RoundID: "group",
        MatchID: 300061454,
        HomeTeamInitials: "RSA",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          18.41067,
          -33.90403
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "11 Jun 2010 - 20:30 ",
        Stage: "Group A",
        Stadium: "Cape Town Stadium",
        City: "Cape Town ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 64100,
        RoundID: "group",
        MatchID: 300061453,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          25.59928,
          -33.93798
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "12 Jun 2010 - 13:30 ",
        Stage: "Group B",
        Stadium: "Port Elizabeth Stadium",
        City: "Nelson Mandela Bay/Port Elizabeth ",
        HomeTeamName: "Korea Republic",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Greece",
        WinConditions: " ",
        Attendance: 31513,
        RoundID: "group",
        MatchID: 300061459,
        HomeTeamInitials: "KOR",
        AwayTeamInitials: "GRE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          28.06101,
          -26.19766
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "12 Jun 2010 - 16:00 ",
        Stage: "Group B",
        Stadium: "Ellis Park Stadium",
        City: "Johannesburg ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Nigeria",
        WinConditions: " ",
        Attendance: 55686,
        RoundID: "group",
        MatchID: 300061460,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "NGA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          27.161,
          -25.57883
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "12 Jun 2010 - 20:30 ",
        Stage: "Group C",
        Stadium: "Royal Bafokeng Sports Palace",
        City: "Phokeng ",
        HomeTeamName: "England",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "USA",
        WinConditions: " ",
        Attendance: 38646,
        RoundID: "group",
        MatchID: 300061466,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "USA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          29.46891,
          -23.92516
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "13 Jun 2010 - 13:30 ",
        Stage: "Group C",
        Stadium: "Peter Mokaba Stadium",
        City: "Polokwane ",
        HomeTeamName: "Algeria",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Slovenia",
        WinConditions: " ",
        Attendance: 30325,
        RoundID: "group",
        MatchID: 300061465,
        HomeTeamInitials: "ALG",
        AwayTeamInitials: "SVN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          28.22285,
          -25.75346
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "13 Jun 2010 - 16:00 ",
        Stage: "Group D",
        Stadium: "Loftus Versfeld Stadium",
        City: "Tshwane/Pretoria ",
        HomeTeamName: "Serbia",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Ghana",
        WinConditions: " ",
        Attendance: 38833,
        RoundID: "group",
        MatchID: 300061471,
        HomeTeamInitials: "SRB",
        AwayTeamInitials: "GHA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          31.03051,
          -29.82912
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "13 Jun 2010 - 20:30 ",
        Stage: "Group D",
        Stadium: "Durban Stadium",
        City: "Durban ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 4,
        AwayTeamGoals: 0,
        AwayTeamName: "Australia",
        WinConditions: " ",
        Attendance: 62660,
        RoundID: "group",
        MatchID: 300111116,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "AUS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          27.98271,
          -26.23493
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "14 Jun 2010 - 13:30 ",
        Stage: "Group E",
        Stadium: "Soccer City Stadium",
        City: "Johannesburg ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Denmark",
        WinConditions: " ",
        Attendance: 83465,
        RoundID: "group",
        MatchID: 300061478,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "DEN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          26.2087,
          -29.1175
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "14 Jun 2010 - 16:00 ",
        Stage: "Group E",
        Stadium: "Free State Stadium",
        City: "Mangaung/Bloemfontein ",
        HomeTeamName: "Japan",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Cameroon",
        WinConditions: " ",
        Attendance: 30620,
        RoundID: "group",
        MatchID: 300061477,
        HomeTeamInitials: "JPN",
        AwayTeamInitials: "CMR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          18.41067,
          -33.90403
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "14 Jun 2010 - 20:30 ",
        Stage: "Group F",
        Stadium: "Cape Town Stadium",
        City: "Cape Town ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Paraguay",
        WinConditions: " ",
        Attendance: 62869,
        RoundID: "group",
        MatchID: 300061484,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "PAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          27.161,
          -25.57883
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "15 Jun 2010 - 13:30 ",
        Stage: "Group F",
        Stadium: "Royal Bafokeng Sports Palace",
        City: "Phokeng ",
        HomeTeamName: "New Zealand",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Slovakia",
        WinConditions: " ",
        Attendance: 23871,
        RoundID: "group",
        MatchID: 300061483,
        HomeTeamInitials: "NZL",
        AwayTeamInitials: "SVK"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          25.59928,
          -33.93798
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "15 Jun 2010 - 16:00 ",
        Stage: "Group G",
        Stadium: "Port Elizabeth Stadium",
        City: "Nelson Mandela Bay/Port Elizabeth ",
        HomeTeamName: "Cote d'Ivoire",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Portugal",
        WinConditions: " ",
        Attendance: 37034,
        RoundID: "group",
        MatchID: 300061489,
        HomeTeamInitials: "CIV",
        AwayTeamInitials: "POR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          28.06101,
          -26.19766
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "15 Jun 2010 - 20:30 ",
        Stage: "Group G",
        Stadium: "Ellis Park Stadium",
        City: "Johannesburg ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Korea DPR",
        WinConditions: " ",
        Attendance: 54331,
        RoundID: "group",
        MatchID: 300061490,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "PRK"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          30.92977,
          -25.46181
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "16 Jun 2010 - 13:30 ",
        Stage: "Group H",
        Stadium: "Mbombela Stadium",
        City: "Nelspruit ",
        HomeTeamName: "Honduras",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Chile",
        WinConditions: " ",
        Attendance: 32664,
        RoundID: "group",
        MatchID: 300061495,
        HomeTeamInitials: "HON",
        AwayTeamInitials: "CHI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          31.03051,
          -29.82912
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "16 Jun 2010 - 16:00 ",
        Stage: "Group H",
        Stadium: "Durban Stadium",
        City: "Durban ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Switzerland",
        WinConditions: " ",
        Attendance: 62453,
        RoundID: "group",
        MatchID: 300111112,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "SUI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          28.22285,
          -25.75346
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "16 Jun 2010 - 20:30 ",
        Stage: "Group A",
        Stadium: "Loftus Versfeld Stadium",
        City: "Tshwane/Pretoria ",
        HomeTeamName: "South Africa",
        HomeTeamGoals: 0,
        AwayTeamGoals: 3,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 42658,
        RoundID: "group",
        MatchID: 300061452,
        HomeTeamInitials: "RSA",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          27.98271,
          -26.23493
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "17 Jun 2010 - 13:30 ",
        Stage: "Group B",
        Stadium: "Soccer City Stadium",
        City: "Johannesburg ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "Korea Republic",
        WinConditions: " ",
        Attendance: 82174,
        RoundID: "group",
        MatchID: 300061458,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "KOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          26.2087,
          -29.1175
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "17 Jun 2010 - 16:00 ",
        Stage: "Group B",
        Stadium: "Free State Stadium",
        City: "Mangaung/Bloemfontein ",
        HomeTeamName: "Greece",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Nigeria",
        WinConditions: " ",
        Attendance: 31593,
        RoundID: "group",
        MatchID: 300061457,
        HomeTeamInitials: "GRE",
        AwayTeamInitials: "NGA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          29.46891,
          -23.92516
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "17 Jun 2010 - 20:30 ",
        Stage: "Group A",
        Stadium: "Peter Mokaba Stadium",
        City: "Polokwane ",
        HomeTeamName: "France",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 35370,
        RoundID: "group",
        MatchID: 300061451,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          25.59928,
          -33.93798
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "18 Jun 2010 - 13:30 ",
        Stage: "Group D",
        Stadium: "Port Elizabeth Stadium",
        City: "Nelson Mandela Bay/Port Elizabeth ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Serbia",
        WinConditions: " ",
        Attendance: 38294,
        RoundID: "group",
        MatchID: 300061470,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "SRB"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          28.06101,
          -26.19766
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "18 Jun 2010 - 16:00 ",
        Stage: "Group C",
        Stadium: "Ellis Park Stadium",
        City: "Johannesburg ",
        HomeTeamName: "Slovenia",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "USA",
        WinConditions: " ",
        Attendance: 45573,
        RoundID: "group",
        MatchID: 300061463,
        HomeTeamInitials: "SVN",
        AwayTeamInitials: "USA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          18.41067,
          -33.90403
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "18 Jun 2010 - 20:30 ",
        Stage: "Group C",
        Stadium: "Cape Town Stadium",
        City: "Cape Town ",
        HomeTeamName: "England",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Algeria",
        WinConditions: " ",
        Attendance: 64100,
        RoundID: "group",
        MatchID: 300061464,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "ALG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          31.03051,
          -29.82912
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "19 Jun 2010 - 13:30 ",
        Stage: "Group E",
        Stadium: "Durban Stadium",
        City: "Durban ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Japan",
        WinConditions: " ",
        Attendance: 62010,
        RoundID: "group",
        MatchID: 300111117,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "JPN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          27.161,
          -25.57883
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "19 Jun 2010 - 16:00 ",
        Stage: "Group D",
        Stadium: "Royal Bafokeng Sports Palace",
        City: "Phokeng ",
        HomeTeamName: "Ghana",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Australia",
        WinConditions: " ",
        Attendance: 34812,
        RoundID: "group",
        MatchID: 300061469,
        HomeTeamInitials: "GHA",
        AwayTeamInitials: "AUS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          28.22285,
          -25.75346
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "19 Jun 2010 - 20:30 ",
        Stage: "Group E",
        Stadium: "Loftus Versfeld Stadium",
        City: "Tshwane/Pretoria ",
        HomeTeamName: "Cameroon",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Denmark",
        WinConditions: " ",
        Attendance: 38074,
        RoundID: "group",
        MatchID: 300061475,
        HomeTeamInitials: "CMR",
        AwayTeamInitials: "DEN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          26.2087,
          -29.1175
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "20 Jun 2010 - 13:30 ",
        Stage: "Group F",
        Stadium: "Free State Stadium",
        City: "Mangaung/Bloemfontein ",
        HomeTeamName: "Slovakia",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Paraguay",
        WinConditions: " ",
        Attendance: 26643,
        RoundID: "group",
        MatchID: 300061481,
        HomeTeamInitials: "SVK",
        AwayTeamInitials: "PAR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          30.92977,
          -25.46181
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "20 Jun 2010 - 16:00 ",
        Stage: "Group F",
        Stadium: "Mbombela Stadium",
        City: "Nelspruit ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "New Zealand",
        WinConditions: " ",
        Attendance: 38229,
        RoundID: "group",
        MatchID: 300061482,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "NZL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          27.98271,
          -26.23493
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "20 Jun 2010 - 20:30 ",
        Stage: "Group G",
        Stadium: "Soccer City Stadium",
        City: "Johannesburg ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Cote d'Ivoire",
        WinConditions: " ",
        Attendance: 84455,
        RoundID: "group",
        MatchID: 300061488,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "CIV"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          18.41067,
          -33.90403
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "21 Jun 2010 - 13:30 ",
        Stage: "Group G",
        Stadium: "Cape Town Stadium",
        City: "Cape Town ",
        HomeTeamName: "Portugal",
        HomeTeamGoals: 7,
        AwayTeamGoals: 0,
        AwayTeamName: "Korea DPR",
        WinConditions: " ",
        Attendance: 63644,
        RoundID: "group",
        MatchID: 300061487,
        HomeTeamInitials: "POR",
        AwayTeamInitials: "PRK"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          25.59928,
          -33.93798
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "21 Jun 2010 - 16:00 ",
        Stage: "Group H",
        Stadium: "Port Elizabeth Stadium",
        City: "Nelson Mandela Bay/Port Elizabeth ",
        HomeTeamName: "Chile",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Switzerland",
        WinConditions: " ",
        Attendance: 34872,
        RoundID: "group",
        MatchID: 300061493,
        HomeTeamInitials: "CHI",
        AwayTeamInitials: "SUI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          28.06101,
          -26.19766
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "21 Jun 2010 - 20:30 ",
        Stage: "Group H",
        Stadium: "Ellis Park Stadium",
        City: "Johannesburg ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Honduras",
        WinConditions: " ",
        Attendance: 54386,
        RoundID: "group",
        MatchID: 300061494,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "HON"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          27.161,
          -25.57883
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "22 Jun 2010 - 16:00 ",
        Stage: "Group A",
        Stadium: "Royal Bafokeng Sports Palace",
        City: "Phokeng ",
        HomeTeamName: "Mexico",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 33425,
        RoundID: "group",
        MatchID: 300061450,
        HomeTeamInitials: "MEX",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          26.2087,
          -29.1175
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "22 Jun 2010 - 16:00 ",
        Stage: "Group A",
        Stadium: "Free State Stadium",
        City: "Mangaung/Bloemfontein ",
        HomeTeamName: "France",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "South Africa",
        WinConditions: " ",
        Attendance: 39415,
        RoundID: "group",
        MatchID: 300061449,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "RSA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          31.03051,
          -29.82912
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "22 Jun 2010 - 20:30 ",
        Stage: "Group B",
        Stadium: "Durban Stadium",
        City: "Durban ",
        HomeTeamName: "Nigeria",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Korea Republic",
        WinConditions: " ",
        Attendance: 61874,
        RoundID: "group",
        MatchID: 300111115,
        HomeTeamInitials: "NGA",
        AwayTeamInitials: "KOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          29.46891,
          -23.92516
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "22 Jun 2010 - 20:30 ",
        Stage: "Group B",
        Stadium: "Peter Mokaba Stadium",
        City: "Polokwane ",
        HomeTeamName: "Greece",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Argentina",
        WinConditions: " ",
        Attendance: 38891,
        RoundID: "group",
        MatchID: 300061455,
        HomeTeamInitials: "GRE",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          25.59928,
          -33.93798
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "23 Jun 2010 - 16:00 ",
        Stage: "Group C",
        Stadium: "Port Elizabeth Stadium",
        City: "Nelson Mandela Bay/Port Elizabeth ",
        HomeTeamName: "Slovenia",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 36893,
        RoundID: "group",
        MatchID: 300061462,
        HomeTeamInitials: "SVN",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          28.22285,
          -25.75346
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "23 Jun 2010 - 16:00 ",
        Stage: "Group C",
        Stadium: "Loftus Versfeld Stadium",
        City: "Tshwane/Pretoria ",
        HomeTeamName: "USA",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Algeria",
        WinConditions: " ",
        Attendance: 35827,
        RoundID: "group",
        MatchID: 300061461,
        HomeTeamInitials: "USA",
        AwayTeamInitials: "ALG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          27.98271,
          -26.23493
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "23 Jun 2010 - 20:30 ",
        Stage: "Group D",
        Stadium: "Soccer City Stadium",
        City: "Johannesburg ",
        HomeTeamName: "Ghana",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Germany",
        WinConditions: " ",
        Attendance: 83391,
        RoundID: "group",
        MatchID: 300061468,
        HomeTeamInitials: "GHA",
        AwayTeamInitials: "GER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          30.92977,
          -25.46181
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "23 Jun 2010 - 20:30 ",
        Stage: "Group D",
        Stadium: "Mbombela Stadium",
        City: "Nelspruit ",
        HomeTeamName: "Australia",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Serbia",
        WinConditions: " ",
        Attendance: 37836,
        RoundID: "group",
        MatchID: 300061467,
        HomeTeamInitials: "AUS",
        AwayTeamInitials: "SRB"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          28.06101,
          -26.19766
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "24 Jun 2010 - 16:00 ",
        Stage: "Group F",
        Stadium: "Ellis Park Stadium",
        City: "Johannesburg ",
        HomeTeamName: "Slovakia",
        HomeTeamGoals: 3,
        AwayTeamGoals: 2,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 53412,
        RoundID: "group",
        MatchID: 300061480,
        HomeTeamInitials: "SVK",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          29.46891,
          -23.92516
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "24 Jun 2010 - 16:00 ",
        Stage: "Group F",
        Stadium: "Peter Mokaba Stadium",
        City: "Polokwane ",
        HomeTeamName: "Paraguay",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "New Zealand",
        WinConditions: " ",
        Attendance: 34850,
        RoundID: "group",
        MatchID: 300061479,
        HomeTeamInitials: "PAR",
        AwayTeamInitials: "NZL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          27.161,
          -25.57883
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "24 Jun 2010 - 20:30 ",
        Stage: "Group E",
        Stadium: "Royal Bafokeng Sports Palace",
        City: "Phokeng ",
        HomeTeamName: "Denmark",
        HomeTeamGoals: 1,
        AwayTeamGoals: 3,
        AwayTeamName: "Japan",
        WinConditions: " ",
        Attendance: 27967,
        RoundID: "group",
        MatchID: 300061474,
        HomeTeamInitials: "DEN",
        AwayTeamInitials: "JPN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          18.41067,
          -33.90403
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "24 Jun 2010 - 20:30 ",
        Stage: "Group E",
        Stadium: "Cape Town Stadium",
        City: "Cape Town ",
        HomeTeamName: "Cameroon",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Netherlands",
        WinConditions: " ",
        Attendance: 63093,
        RoundID: "group",
        MatchID: 300061473,
        HomeTeamInitials: "CMR",
        AwayTeamInitials: "NED"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          31.03051,
          -29.82912
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "25 Jun 2010 - 16:00 ",
        Stage: "Group G",
        Stadium: "Durban Stadium",
        City: "Durban ",
        HomeTeamName: "Portugal",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 62712,
        RoundID: "group",
        MatchID: 300111111,
        HomeTeamInitials: "POR",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          30.92977,
          -25.46181
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "25 Jun 2010 - 16:00 ",
        Stage: "Group G",
        Stadium: "Mbombela Stadium",
        City: "Nelspruit ",
        HomeTeamName: "Korea DPR",
        HomeTeamGoals: 0,
        AwayTeamGoals: 3,
        AwayTeamName: "Cote d'Ivoire",
        WinConditions: " ",
        Attendance: 34763,
        RoundID: "group",
        MatchID: 300061486,
        HomeTeamInitials: "PRK",
        AwayTeamInitials: "CIV"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          28.22285,
          -25.75346
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "25 Jun 2010 - 20:30 ",
        Stage: "Group H",
        Stadium: "Loftus Versfeld Stadium",
        City: "Tshwane/Pretoria ",
        HomeTeamName: "Chile",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 41958,
        RoundID: "group",
        MatchID: 300061491,
        HomeTeamInitials: "CHI",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          26.2087,
          -29.1175
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "25 Jun 2010 - 20:30 ",
        Stage: "Group H",
        Stadium: "Free State Stadium",
        City: "Mangaung/Bloemfontein ",
        HomeTeamName: "Switzerland",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Honduras",
        WinConditions: " ",
        Attendance: 28042,
        RoundID: "group",
        MatchID: 300061492,
        HomeTeamInitials: "SUI",
        AwayTeamInitials: "HON"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          25.59928,
          -33.93798
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "26 Jun 2010 - 16:00 ",
        Stage: "Round of 16",
        Stadium: "Port Elizabeth Stadium",
        City: "Nelson Mandela Bay/Port Elizabeth ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Korea Republic",
        WinConditions: " ",
        Attendance: 30597,
        RoundID: "rsixteen",
        MatchID: 300061504,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "KOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          27.161,
          -25.57883
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "26 Jun 2010 - 20:30 ",
        Stage: "Round of 16",
        Stadium: "Royal Bafokeng Sports Palace",
        City: "Phokeng ",
        HomeTeamName: "USA",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Ghana",
        WinConditions: "win after extra time ",
        Attendance: 34976,
        RoundID: "rsixteen",
        MatchID: 300061503,
        HomeTeamInitials: "USA",
        AwayTeamInitials: "GHA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          26.2087,
          -29.1175
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "27 Jun 2010 - 16:00 ",
        Stage: "Round of 16",
        Stadium: "Free State Stadium",
        City: "Mangaung/Bloemfontein ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 4,
        AwayTeamGoals: 1,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 40510,
        RoundID: "rsixteen",
        MatchID: 300061501,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          27.98271,
          -26.23493
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "27 Jun 2010 - 20:30 ",
        Stage: "Round of 16",
        Stadium: "Soccer City Stadium",
        City: "Johannesburg ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 84377,
        RoundID: "rsixteen",
        MatchID: 300061502,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          31.03051,
          -29.82912
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "28 Jun 2010 - 16:00 ",
        Stage: "Round of 16",
        Stadium: "Durban Stadium",
        City: "Durban ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Slovakia",
        WinConditions: " ",
        Attendance: 61962,
        RoundID: "rsixteen",
        MatchID: 300111113,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "SVK"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          28.06101,
          -26.19766
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "28 Jun 2010 - 20:30 ",
        Stage: "Round of 16",
        Stadium: "Ellis Park Stadium",
        City: "Johannesburg ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Chile",
        WinConditions: " ",
        Attendance: 54096,
        RoundID: "rsixteen",
        MatchID: 300061500,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "CHI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          28.22285,
          -25.75346
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "29 Jun 2010 - 16:00 ",
        Stage: "Round of 16",
        Stadium: "Loftus Versfeld Stadium",
        City: "Tshwane/Pretoria ",
        HomeTeamName: "Paraguay",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Japan",
        WinConditions: "Paraguay win on penalties (5 - 3) ",
        Attendance: 36742,
        RoundID: "rsixteen",
        MatchID: 300061497,
        HomeTeamInitials: "PAR",
        AwayTeamInitials: "JPN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          18.41067,
          -33.90403
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "29 Jun 2010 - 20:30 ",
        Stage: "Round of 16",
        Stadium: "Cape Town Stadium",
        City: "Cape Town ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Portugal",
        WinConditions: " ",
        Attendance: 62955,
        RoundID: "rsixteen",
        MatchID: 300061498,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "POR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          25.59928,
          -33.93798
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "02 Jul 2010 - 16:00 ",
        Stage: "Quarter-finals",
        Stadium: "Port Elizabeth Stadium",
        City: "Nelson Mandela Bay/Port Elizabeth ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 40186,
        RoundID: "quart",
        MatchID: 300061507,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          27.98271,
          -26.23493
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "02 Jul 2010 - 20:30 ",
        Stage: "Quarter-finals",
        Stadium: "Soccer City Stadium",
        City: "Johannesburg ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Ghana",
        WinConditions: "Uruguay win on penalties (4 - 2) ",
        Attendance: 84017,
        RoundID: "quart",
        MatchID: 300061508,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "GHA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          18.41067,
          -33.90403
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "03 Jul 2010 - 16:00 ",
        Stage: "Quarter-finals",
        Stadium: "Cape Town Stadium",
        City: "Cape Town ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 0,
        AwayTeamGoals: 4,
        AwayTeamName: "Germany",
        WinConditions: " ",
        Attendance: 64100,
        RoundID: "quart",
        MatchID: 300061505,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "GER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          28.06101,
          -26.19766
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "03 Jul 2010 - 20:30 ",
        Stage: "Quarter-finals",
        Stadium: "Ellis Park Stadium",
        City: "Johannesburg ",
        HomeTeamName: "Paraguay",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 55359,
        RoundID: "quart",
        MatchID: 300061506,
        HomeTeamInitials: "PAR",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          18.41067,
          -33.90403
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "06 Jul 2010 - 20:30 ",
        Stage: "Semi-finals",
        Stadium: "Cape Town Stadium",
        City: "Cape Town ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 2,
        AwayTeamGoals: 3,
        AwayTeamName: "Netherlands",
        WinConditions: " ",
        Attendance: 62479,
        RoundID: "semi",
        MatchID: 300061512,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "NED"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          31.03051,
          -29.82912
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "07 Jul 2010 - 20:30 ",
        Stage: "Semi-finals",
        Stadium: "Durban Stadium",
        City: "Durban ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 60960,
        RoundID: "semi",
        MatchID: 300111114,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          25.59928,
          -33.93798
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "10 Jul 2010 - 20:30 ",
        Stage: "Match for third place",
        Stadium: "Port Elizabeth Stadium",
        City: "Nelson Mandela Bay/Port Elizabeth ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 2,
        AwayTeamGoals: 3,
        AwayTeamName: "Germany",
        WinConditions: " ",
        Attendance: 36254,
        RoundID: "third",
        MatchID: 300061510,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "GER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          27.98271,
          -26.23493
        ]
      },
      properties: {
        Year: 2010,
        Datetime: "11 Jul 2010 - 20:30 ",
        Stage: "Final",
        Stadium: "Soccer City Stadium",
        City: "Johannesburg ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Spain",
        WinConditions: "win after extra time ",
        Attendance: 84490,
        RoundID: "final",
        MatchID: 300061509,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -46.474117,
          -23.545548
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "12 Jun 2014 - 17:00 ",
        Stage: "Group A",
        Stadium: "Arena de Sao Paulo",
        City: "Sao Paulo ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Croatia",
        WinConditions: " ",
        Attendance: 62103,
        RoundID: "group",
        MatchID: 300186456,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "CRO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -35.212593,
          -5.825535
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "13 Jun 2014 - 13:00 ",
        Stage: "Group A",
        Stadium: "Estadio das Dunas",
        City: "Natal ",
        HomeTeamName: "Mexico",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Cameroon",
        WinConditions: " ",
        Attendance: 39216,
        RoundID: "group",
        MatchID: 300186492,
        HomeTeamInitials: "MEX",
        AwayTeamInitials: "CMR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -38.50429,
          -12.97891
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "13 Jun 2014 - 16:00 ",
        Stage: "Group B",
        Stadium: "Arena Fonte Nova",
        City: "Salvador ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 1,
        AwayTeamGoals: 5,
        AwayTeamName: "Netherlands",
        WinConditions: " ",
        Attendance: 48173,
        RoundID: "group",
        MatchID: 300186510,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "NED"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.12162,
          -15.60409
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "13 Jun 2014 - 18:00 ",
        Stage: "Group B",
        Stadium: "Arena Pantanal",
        City: "Cuiaba ",
        HomeTeamName: "Chile",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "Australia",
        WinConditions: " ",
        Attendance: 40275,
        RoundID: "group",
        MatchID: 300186473,
        HomeTeamInitials: "CHI",
        AwayTeamInitials: "AUS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.97105,
          -19.86591
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "14 Jun 2014 - 13:00 ",
        Stage: "Group C",
        Stadium: "Estadio Mineirao",
        City: "Belo Horizonte ",
        HomeTeamName: "Colombia",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Greece",
        WinConditions: " ",
        Attendance: 57174,
        RoundID: "group",
        MatchID: 300186471,
        HomeTeamInitials: "COL",
        AwayTeamInitials: "GRE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -38.52241,
          -3.80739
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "14 Jun 2014 - 16:00 ",
        Stage: "Group D",
        Stadium: "Estadio Castelao",
        City: "Fortaleza ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 1,
        AwayTeamGoals: 3,
        AwayTeamName: "Costa Rica",
        WinConditions: " ",
        Attendance: 58679,
        RoundID: "group",
        MatchID: 300186489,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "CRC"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -60.02827,
          -3.08372
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "14 Jun 2014 - 18:00 ",
        Stage: "Group D",
        Stadium: "Arena Amazonia",
        City: "Manaus ",
        HomeTeamName: "England",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Italy",
        WinConditions: " ",
        Attendance: 39800,
        RoundID: "group",
        MatchID: 300186513,
        HomeTeamInitials: "ENG",
        AwayTeamInitials: "ITA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -35.008131,
          -8.040877
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "14 Jun 2014 - 22:00 ",
        Stage: "Group C",
        Stadium: "Arena Pernambuco",
        City: "Recife ",
        HomeTeamName: "Cote d'Ivoire",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Japan",
        WinConditions: " ",
        Attendance: 40267,
        RoundID: "group",
        MatchID: 300186507,
        HomeTeamInitials: "CIV",
        AwayTeamInitials: "JPN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -47.8992,
          -15.78364
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "15 Jun 2014 - 13:00 ",
        Stage: "Group E",
        Stadium: "Estadio Nacional",
        City: "Brasilia ",
        HomeTeamName: "Switzerland",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Ecuador",
        WinConditions: " ",
        Attendance: 68351,
        RoundID: "group",
        MatchID: 300186494,
        HomeTeamInitials: "SUI",
        AwayTeamInitials: "ECU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -51.23599,
          -30.06547
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "15 Jun 2014 - 16:00 ",
        Stage: "Group E",
        Stadium: "Estadio Beira-Rio",
        City: "Porto Alegre ",
        HomeTeamName: "France",
        HomeTeamGoals: 3,
        AwayTeamGoals: 0,
        AwayTeamName: "Honduras",
        WinConditions: " ",
        Attendance: 43012,
        RoundID: "group",
        MatchID: 300186496,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "HON"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.23032,
          -22.91215
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "15 Jun 2014 - 19:00 ",
        Stage: "Group F",
        Stadium: "Estadio do Maracana",
        City: "Rio De Janeiro ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Bosnia and Herzegovina",
        WinConditions: " ",
        Attendance: 74738,
        RoundID: "group",
        MatchID: 300186477,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "BIH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -38.50429,
          -12.97891
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "16 Jun 2014 - 13:00 ",
        Stage: "Group G",
        Stadium: "Arena Fonte Nova",
        City: "Salvador ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 4,
        AwayTeamGoals: 0,
        AwayTeamName: "Portugal",
        WinConditions: " ",
        Attendance: 51081,
        RoundID: "group",
        MatchID: 300186475,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "POR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -49.27706,
          -25.44834
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "16 Jun 2014 - 16:00 ",
        Stage: "Group F",
        Stadium: "Arena da Baixada",
        City: "Curitiba ",
        HomeTeamName: "IR Iran",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Nigeria",
        WinConditions: " ",
        Attendance: 39081,
        RoundID: "group",
        MatchID: 300186505,
        HomeTeamInitials: "IRN",
        AwayTeamInitials: "NGA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -35.212593,
          -5.825535
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "16 Jun 2014 - 19:00 ",
        Stage: "Group G",
        Stadium: "Estadio das Dunas",
        City: "Natal ",
        HomeTeamName: "Ghana",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "USA",
        WinConditions: " ",
        Attendance: 39760,
        RoundID: "group",
        MatchID: 300186512,
        HomeTeamInitials: "GHA",
        AwayTeamInitials: "USA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.97105,
          -19.86591
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "17 Jun 2014 - 13:00 ",
        Stage: "Group H",
        Stadium: "Estadio Mineirao",
        City: "Belo Horizonte ",
        HomeTeamName: "Belgium",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Algeria",
        WinConditions: " ",
        Attendance: 56800,
        RoundID: "group",
        MatchID: 300186479,
        HomeTeamInitials: "BEL",
        AwayTeamInitials: "ALG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -38.52241,
          -3.80739
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "17 Jun 2014 - 16:00 ",
        Stage: "Group A",
        Stadium: "Estadio Castelao",
        City: "Fortaleza ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 60342,
        RoundID: "group",
        MatchID: 300186509,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.12162,
          -15.60409
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "17 Jun 2014 - 18:00 ",
        Stage: "Group H",
        Stadium: "Arena Pantanal",
        City: "Cuiaba ",
        HomeTeamName: "Russia",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Korea Republic",
        WinConditions: " ",
        Attendance: 37603,
        RoundID: "group",
        MatchID: 300186499,
        HomeTeamInitials: "RUS",
        AwayTeamInitials: "KOR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -51.23599,
          -30.06547
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "18 Jun 2014 - 13:00 ",
        Stage: "Group B",
        Stadium: "Estadio Beira-Rio",
        City: "Porto Alegre ",
        HomeTeamName: "Australia",
        HomeTeamGoals: 2,
        AwayTeamGoals: 3,
        AwayTeamName: "Netherlands",
        WinConditions: " ",
        Attendance: 42877,
        RoundID: "group",
        MatchID: 300186478,
        HomeTeamInitials: "AUS",
        AwayTeamInitials: "NED"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.23032,
          -22.91215
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "18 Jun 2014 - 16:00 ",
        Stage: "Group B",
        Stadium: "Estadio do Maracana",
        City: "Rio De Janeiro ",
        HomeTeamName: "Spain",
        HomeTeamGoals: 0,
        AwayTeamGoals: 2,
        AwayTeamName: "Chile",
        WinConditions: " ",
        Attendance: 74101,
        RoundID: "group",
        MatchID: 300186498,
        HomeTeamInitials: "ESP",
        AwayTeamInitials: "CHI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -60.02827,
          -3.08372
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "18 Jun 2014 - 18:00 ",
        Stage: "Group A",
        Stadium: "Arena Amazonia",
        City: "Manaus ",
        HomeTeamName: "Cameroon",
        HomeTeamGoals: 0,
        AwayTeamGoals: 4,
        AwayTeamName: "Croatia",
        WinConditions: " ",
        Attendance: 39982,
        RoundID: "group",
        MatchID: 300186453,
        HomeTeamInitials: "CMR",
        AwayTeamInitials: "CRO"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -47.8992,
          -15.78364
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "19 Jun 2014 - 13:00 ",
        Stage: "Group C",
        Stadium: "Estadio Nacional",
        City: "Brasilia ",
        HomeTeamName: "Colombia",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Cote d'Ivoire",
        WinConditions: " ",
        Attendance: 68748,
        RoundID: "group",
        MatchID: 300186468,
        HomeTeamInitials: "COL",
        AwayTeamInitials: "CIV"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -46.474117,
          -23.545548
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "19 Jun 2014 - 16:00 ",
        Stage: "Group D",
        Stadium: "Arena de Sao Paulo",
        City: "Sao Paulo ",
        HomeTeamName: "Uruguay",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 62575,
        RoundID: "group",
        MatchID: 300186486,
        HomeTeamInitials: "URU",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -35.212593,
          -5.825535
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "19 Jun 2014 - 19:00 ",
        Stage: "Group C",
        Stadium: "Estadio das Dunas",
        City: "Natal ",
        HomeTeamName: "Japan",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Greece",
        WinConditions: " ",
        Attendance: 39485,
        RoundID: "group",
        MatchID: 300186454,
        HomeTeamInitials: "JPN",
        AwayTeamInitials: "GRE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -35.008131,
          -8.040877
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "20 Jun 2014 - 13:00 ",
        Stage: "Group D",
        Stadium: "Arena Pernambuco",
        City: "Recife ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Costa Rica",
        WinConditions: " ",
        Attendance: 40285,
        RoundID: "group",
        MatchID: 300186500,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "CRC"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -38.50429,
          -12.97891
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "20 Jun 2014 - 16:00 ",
        Stage: "Group E",
        Stadium: "Arena Fonte Nova",
        City: "Salvador ",
        HomeTeamName: "Switzerland",
        HomeTeamGoals: 2,
        AwayTeamGoals: 5,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 51003,
        RoundID: "group",
        MatchID: 300186514,
        HomeTeamInitials: "SUI",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -49.27706,
          -25.44834
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "20 Jun 2014 - 19:00 ",
        Stage: "Group E",
        Stadium: "Arena da Baixada",
        City: "Curitiba ",
        HomeTeamName: "Honduras",
        HomeTeamGoals: 1,
        AwayTeamGoals: 2,
        AwayTeamName: "Ecuador",
        WinConditions: " ",
        Attendance: 39224,
        RoundID: "group",
        MatchID: 300186463,
        HomeTeamInitials: "HON",
        AwayTeamInitials: "ECU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.97105,
          -19.86591
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "21 Jun 2014 - 13:00 ",
        Stage: "Group F",
        Stadium: "Estadio Mineirao",
        City: "Belo Horizonte ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "IR Iran",
        WinConditions: " ",
        Attendance: 57698,
        RoundID: "group",
        MatchID: 300186466,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "IRN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -38.52241,
          -3.80739
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "21 Jun 2014 - 16:00 ",
        Stage: "Group G",
        Stadium: "Estadio Castelao",
        City: "Fortaleza ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Ghana",
        WinConditions: " ",
        Attendance: 59621,
        RoundID: "group",
        MatchID: 300186493,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "GHA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.12162,
          -15.60409
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "21 Jun 2014 - 18:00 ",
        Stage: "Group F",
        Stadium: "Arena Pantanal",
        City: "Cuiaba ",
        HomeTeamName: "Nigeria",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Bosnia and Herzegovina",
        WinConditions: " ",
        Attendance: 40499,
        RoundID: "group",
        MatchID: 300186511,
        HomeTeamInitials: "NGA",
        AwayTeamInitials: "BIH"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.23032,
          -22.91215
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "22 Jun 2014 - 13:00 ",
        Stage: "Group H",
        Stadium: "Estadio do Maracana",
        City: "Rio De Janeiro ",
        HomeTeamName: "Belgium",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Russia",
        WinConditions: " ",
        Attendance: 73819,
        RoundID: "group",
        MatchID: 300186481,
        HomeTeamInitials: "BEL",
        AwayTeamInitials: "RUS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -51.23599,
          -30.06547
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "22 Jun 2014 - 16:00 ",
        Stage: "Group H",
        Stadium: "Estadio Beira-Rio",
        City: "Porto Alegre ",
        HomeTeamName: "Korea Republic",
        HomeTeamGoals: 2,
        AwayTeamGoals: 4,
        AwayTeamName: "Algeria",
        WinConditions: " ",
        Attendance: 42732,
        RoundID: "group",
        MatchID: 300186495,
        HomeTeamInitials: "KOR",
        AwayTeamInitials: "ALG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -60.02827,
          -3.08372
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "22 Jun 2014 - 18:00 ",
        Stage: "Group G",
        Stadium: "Arena Amazonia",
        City: "Manaus ",
        HomeTeamName: "USA",
        HomeTeamGoals: 2,
        AwayTeamGoals: 2,
        AwayTeamName: "Portugal",
        WinConditions: " ",
        Attendance: 40123,
        RoundID: "group",
        MatchID: 300186483,
        HomeTeamInitials: "USA",
        AwayTeamInitials: "POR"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -49.27706,
          -25.44834
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "23 Jun 2014 - 13:00 ",
        Stage: "Group B",
        Stadium: "Arena da Baixada",
        City: "Curitiba ",
        HomeTeamName: "Australia",
        HomeTeamGoals: 0,
        AwayTeamGoals: 3,
        AwayTeamName: "Spain",
        WinConditions: " ",
        Attendance: 39375,
        RoundID: "group",
        MatchID: 300186467,
        HomeTeamInitials: "AUS",
        AwayTeamInitials: "ESP"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -46.474117,
          -23.545548
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "23 Jun 2014 - 13:00 ",
        Stage: "Group B",
        Stadium: "Arena de Sao Paulo",
        City: "Sao Paulo ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Chile",
        WinConditions: " ",
        Attendance: 62996,
        RoundID: "group",
        MatchID: 300186470,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "CHI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -47.8992,
          -15.78364
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "23 Jun 2014 - 17:00 ",
        Stage: "Group A",
        Stadium: "Estadio Nacional",
        City: "Brasilia ",
        HomeTeamName: "Cameroon",
        HomeTeamGoals: 1,
        AwayTeamGoals: 4,
        AwayTeamName: "Brazil",
        WinConditions: " ",
        Attendance: 69112,
        RoundID: "group",
        MatchID: 300186472,
        HomeTeamInitials: "CMR",
        AwayTeamInitials: "BRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -35.008131,
          -8.040877
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "23 Jun 2014 - 17:00 ",
        Stage: "Group A",
        Stadium: "Arena Pernambuco",
        City: "Recife ",
        HomeTeamName: "Croatia",
        HomeTeamGoals: 1,
        AwayTeamGoals: 3,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 41212,
        RoundID: "group",
        MatchID: 300186452,
        HomeTeamInitials: "CRO",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -35.212593,
          -5.825535
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "24 Jun 2014 - 13:00 ",
        Stage: "Group D",
        Stadium: "Estadio das Dunas",
        City: "Natal ",
        HomeTeamName: "Italy",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 39706,
        RoundID: "group",
        MatchID: 300186465,
        HomeTeamInitials: "ITA",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.97105,
          -19.86591
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "24 Jun 2014 - 13:00 ",
        Stage: "Group D",
        Stadium: "Estadio Mineirao",
        City: "Belo Horizonte ",
        HomeTeamName: "Costa Rica",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "England",
        WinConditions: " ",
        Attendance: 57823,
        RoundID: "group",
        MatchID: 300186484,
        HomeTeamInitials: "CRC",
        AwayTeamInitials: "ENG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -56.12162,
          -15.60409
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "24 Jun 2014 - 16:00 ",
        Stage: "Group C",
        Stadium: "Arena Pantanal",
        City: "Cuiaba ",
        HomeTeamName: "Japan",
        HomeTeamGoals: 1,
        AwayTeamGoals: 4,
        AwayTeamName: "Colombia",
        WinConditions: " ",
        Attendance: 40340,
        RoundID: "group",
        MatchID: 300186457,
        HomeTeamInitials: "JPN",
        AwayTeamInitials: "COL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -38.52241,
          -3.80739
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "24 Jun 2014 - 17:00 ",
        Stage: "Group C",
        Stadium: "Estadio Castelao",
        City: "Fortaleza ",
        HomeTeamName: "Greece",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Cote d'Ivoire",
        WinConditions: " ",
        Attendance: 59095,
        RoundID: "group",
        MatchID: 300186455,
        HomeTeamInitials: "GRE",
        AwayTeamInitials: "CIV"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -51.23599,
          -30.06547
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "25 Jun 2014 - 13:00 ",
        Stage: "Group F",
        Stadium: "Estadio Beira-Rio",
        City: "Porto Alegre ",
        HomeTeamName: "Nigeria",
        HomeTeamGoals: 2,
        AwayTeamGoals: 3,
        AwayTeamName: "Argentina",
        WinConditions: " ",
        Attendance: 43285,
        RoundID: "group",
        MatchID: 300186458,
        HomeTeamInitials: "NGA",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -38.50429,
          -12.97891
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "25 Jun 2014 - 13:00 ",
        Stage: "Group F",
        Stadium: "Arena Fonte Nova",
        City: "Salvador ",
        HomeTeamName: "Bosnia and Herzegovina",
        HomeTeamGoals: 3,
        AwayTeamGoals: 1,
        AwayTeamName: "IR Iran",
        WinConditions: " ",
        Attendance: 48011,
        RoundID: "group",
        MatchID: 300186464,
        HomeTeamInitials: "BIH",
        AwayTeamInitials: "IRN"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -60.02827,
          -3.08372
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "25 Jun 2014 - 16:00 ",
        Stage: "Group E",
        Stadium: "Arena Amazonia",
        City: "Manaus ",
        HomeTeamName: "Honduras",
        HomeTeamGoals: 0,
        AwayTeamGoals: 3,
        AwayTeamName: "Switzerland",
        WinConditions: " ",
        Attendance: 40322,
        RoundID: "group",
        MatchID: 300186482,
        HomeTeamInitials: "HON",
        AwayTeamInitials: "SUI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.23032,
          -22.91215
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "25 Jun 2014 - 17:00 ",
        Stage: "Group E",
        Stadium: "Estadio do Maracana",
        City: "Rio De Janeiro ",
        HomeTeamName: "Ecuador",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "France",
        WinConditions: " ",
        Attendance: 73749,
        RoundID: "group",
        MatchID: 300186515,
        HomeTeamInitials: "ECU",
        AwayTeamInitials: "FRA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -35.008131,
          -8.040877
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "26 Jun 2014 - 13:00 ",
        Stage: "Group G",
        Stadium: "Arena Pernambuco",
        City: "Recife ",
        HomeTeamName: "USA",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Germany",
        WinConditions: " ",
        Attendance: 41876,
        RoundID: "group",
        MatchID: 300186469,
        HomeTeamInitials: "USA",
        AwayTeamInitials: "GER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -47.8992,
          -15.78364
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "26 Jun 2014 - 13:00 ",
        Stage: "Group G",
        Stadium: "Estadio Nacional",
        City: "Brasilia ",
        HomeTeamName: "Portugal",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Ghana",
        WinConditions: " ",
        Attendance: 67540,
        RoundID: "group",
        MatchID: 300186476,
        HomeTeamInitials: "POR",
        AwayTeamInitials: "GHA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -46.474117,
          -23.545548
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "26 Jun 2014 - 17:00 ",
        Stage: "Group H",
        Stadium: "Arena de Sao Paulo",
        City: "Sao Paulo ",
        HomeTeamName: "Korea Republic",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Belgium",
        WinConditions: " ",
        Attendance: 61397,
        RoundID: "group",
        MatchID: 300186480,
        HomeTeamInitials: "KOR",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -49.27706,
          -25.44834
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "26 Jun 2014 - 17:00 ",
        Stage: "Group H",
        Stadium: "Arena da Baixada",
        City: "Curitiba ",
        HomeTeamName: "Algeria",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Russia",
        WinConditions: " ",
        Attendance: 39311,
        RoundID: "group",
        MatchID: 300186506,
        HomeTeamInitials: "ALG",
        AwayTeamInitials: "RUS"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.97105,
          -19.86591
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "28 Jun 2014 - 13:00 ",
        Stage: "Round of 16",
        Stadium: "Estadio Mineirao",
        City: "Belo Horizonte ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Chile",
        WinConditions: "Brazil win on penalties (3 - 2) ",
        Attendance: 57714,
        RoundID: "rsixteen",
        MatchID: 300186487,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "CHI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.23032,
          -22.91215
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "28 Jun 2014 - 17:00 ",
        Stage: "Round of 16",
        Stadium: "Estadio do Maracana",
        City: "Rio De Janeiro ",
        HomeTeamName: "Colombia",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Uruguay",
        WinConditions: " ",
        Attendance: 73804,
        RoundID: "rsixteen",
        MatchID: 300186491,
        HomeTeamInitials: "COL",
        AwayTeamInitials: "URU"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -38.52241,
          -3.80739
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "29 Jun 2014 - 13:00 ",
        Stage: "Round of 16",
        Stadium: "Estadio Castelao",
        City: "Fortaleza ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Mexico",
        WinConditions: " ",
        Attendance: 58817,
        RoundID: "rsixteen",
        MatchID: 300186508,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "MEX"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -35.008131,
          -8.040877
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "29 Jun 2014 - 17:00 ",
        Stage: "Round of 16",
        Stadium: "Arena Pernambuco",
        City: "Recife ",
        HomeTeamName: "Costa Rica",
        HomeTeamGoals: 1,
        AwayTeamGoals: 1,
        AwayTeamName: "Greece",
        WinConditions: "Costa Rica win on penalties (5 - 3) ",
        Attendance: 41242,
        RoundID: "rsixteen",
        MatchID: 300186459,
        HomeTeamInitials: "CRC",
        AwayTeamInitials: "GRE"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -47.8992,
          -15.78364
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "30 Jun 2014 - 13:00 ",
        Stage: "Round of 16",
        Stadium: "Estadio Nacional",
        City: "Brasilia ",
        HomeTeamName: "France",
        HomeTeamGoals: 2,
        AwayTeamGoals: 0,
        AwayTeamName: "Nigeria",
        WinConditions: " ",
        Attendance: 67882,
        RoundID: "rsixteen",
        MatchID: 300186462,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "NGA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -51.23599,
          -30.06547
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "30 Jun 2014 - 17:00 ",
        Stage: "Round of 16",
        Stadium: "Estadio Beira-Rio",
        City: "Porto Alegre ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Algeria",
        WinConditions: "win after extra time ",
        Attendance: 43063,
        RoundID: "rsixteen",
        MatchID: 300186460,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "ALG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -46.474117,
          -23.545548
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "01 Jul 2014 - 13:00 ",
        Stage: "Round of 16",
        Stadium: "Arena de Sao Paulo",
        City: "Sao Paulo ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Switzerland",
        WinConditions: "win after extra time ",
        Attendance: 63255,
        RoundID: "rsixteen",
        MatchID: 300186503,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "SUI"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -38.50429,
          -12.97891
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "01 Jul 2014 - 17:00 ",
        Stage: "Round of 16",
        Stadium: "Arena Fonte Nova",
        City: "Salvador ",
        HomeTeamName: "Belgium",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "USA",
        WinConditions: "win after extra time ",
        Attendance: 51227,
        RoundID: "rsixteen",
        MatchID: 300186497,
        HomeTeamInitials: "BEL",
        AwayTeamInitials: "USA"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.23032,
          -22.91215
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "04 Jul 2014 - 13:00 ",
        Stage: "Quarter-finals",
        Stadium: "Estadio do Maracana",
        City: "Rio De Janeiro ",
        HomeTeamName: "France",
        HomeTeamGoals: 0,
        AwayTeamGoals: 1,
        AwayTeamName: "Germany",
        WinConditions: " ",
        Attendance: 74240,
        RoundID: "quart",
        MatchID: 300186485,
        HomeTeamInitials: "FRA",
        AwayTeamInitials: "GER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -38.52241,
          -3.80739
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "04 Jul 2014 - 17:00 ",
        Stage: "Quarter-finals",
        Stadium: "Estadio Castelao",
        City: "Fortaleza ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 2,
        AwayTeamGoals: 1,
        AwayTeamName: "Colombia",
        WinConditions: " ",
        Attendance: 60342,
        RoundID: "quart",
        MatchID: 300186461,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "COL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -47.8992,
          -15.78364
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "05 Jul 2014 - 13:00 ",
        Stage: "Quarter-finals",
        Stadium: "Estadio Nacional",
        City: "Brasilia ",
        HomeTeamName: "Argentina",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Belgium",
        WinConditions: " ",
        Attendance: 68551,
        RoundID: "quart",
        MatchID: 300186504,
        HomeTeamInitials: "ARG",
        AwayTeamInitials: "BEL"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -38.50429,
          -12.97891
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "05 Jul 2014 - 17:00 ",
        Stage: "Quarter-finals",
        Stadium: "Arena Fonte Nova",
        City: "Salvador ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Costa Rica",
        WinConditions: "Netherlands win on penalties (4 - 3) ",
        Attendance: 51179,
        RoundID: "quart",
        MatchID: 300186488,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "CRC"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.97105,
          -19.86591
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "08 Jul 2014 - 17:00 ",
        Stage: "Semi-finals",
        Stadium: "Estadio Mineirao",
        City: "Belo Horizonte ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 1,
        AwayTeamGoals: 7,
        AwayTeamName: "Germany",
        WinConditions: " ",
        Attendance: 58141,
        RoundID: "semi",
        MatchID: 300186474,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "GER"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -46.474117,
          -23.545548
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "09 Jul 2014 - 17:00 ",
        Stage: "Semi-finals",
        Stadium: "Arena de Sao Paulo",
        City: "Sao Paulo ",
        HomeTeamName: "Netherlands",
        HomeTeamGoals: 0,
        AwayTeamGoals: 0,
        AwayTeamName: "Argentina",
        WinConditions: "Argentina win on penalties (2 - 4) ",
        Attendance: 63267,
        RoundID: "semi",
        MatchID: 300186490,
        HomeTeamInitials: "NED",
        AwayTeamInitials: "ARG"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -47.8992,
          -15.78364
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "12 Jul 2014 - 17:00 ",
        Stage: "Match for third place",
        Stadium: "Estadio Nacional",
        City: "Brasilia ",
        HomeTeamName: "Brazil",
        HomeTeamGoals: 0,
        AwayTeamGoals: 3,
        AwayTeamName: "Netherlands",
        WinConditions: " ",
        Attendance: 68034,
        RoundID: "third",
        MatchID: 300186502,
        HomeTeamInitials: "BRA",
        AwayTeamInitials: "NED"
      }
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          -43.23032,
          -22.91215
        ]
      },
      properties: {
        Year: 2014,
        Datetime: "13 Jul 2014 - 16:00 ",
        Stage: "Final",
        Stadium: "Estadio do Maracana",
        City: "Rio De Janeiro ",
        HomeTeamName: "Germany",
        HomeTeamGoals: 1,
        AwayTeamGoals: 0,
        AwayTeamName: "Argentina",
        WinConditions: "win after extra time ",
        Attendance: 74738,
        RoundID: "final",
        MatchID: 300186501,
        HomeTeamInitials: "GER",
        AwayTeamInitials: "ARG"
      }
    }
  ]
}